const env = process.env;
const api = {

    apiBase: env.VUE_APP_Apibase,
    //
    imgBase: env.VUE_APP_Filebase,
    ssqBase: env.VUE_APP_SSQbase,
    main: { //主框架  公用
        checkToken: "/wx/nothing/empty.smallwx",
        getOpenid: "/smallwx/getOpenid.smallwx",
        getQyOpenid: "/smallwx/getUserid.smallwx",
        buyToken: "/smallwx/empBaseInfo/isExistsmallToken.smallwx", //使用openid换token
        buyQyToken: "/smallwx/empBaseInfo/isExistSmallwxTokenByUserid.smallwx", //使用openid换token
        getDept: "/web/deptInfo/queryDeptInfoByParentId.jhtml", //获取部门选择
        buildLevelDept: '/web/vitasoyDept/buildLevelDept.jhtml', //层级部门

        getDeptAll: "/web/deptInfo/getAllDeptTree.smallwx", //获取部门选择全选

        serDept: "/web/deptInfo/getDeptInfoByProperties.smallwx", //部门搜索

        getApproveUserAll: "/web/deptInfo/queryDeptInfoAndEmpInfoByParentId.smallwx", //获取全部审批人选择

        getApproveUser: "/web/deptInfo/getDeptInfoAndEmpInfoOfAppvLevelByParentId.jhtml", //获取全部审批人选择

        serApproveUser: "/web/empBaseInfo/queryEmpBaseInfoByName.smallwx", //审批人搜索
        getdeptIdEmp: '/web/empBaseInfo/queryEmpBaseInfoByName.jhtml', //根据部门获取员工
        getEmpByLogId: "/web/log/emp/change/getEmpByLogId.jhtml", //获取人员以及部门之间的关系
        upload: "/web/UpLoadFile/upload.smallwx", //附件上传
        upload1: "/web/UpLoadFile/upload.smallwxEmp", //附件上传
        getArea: "/web/dictArea/getDictArea.smallwx", //地区
        getFlowControlState: "/web/flowControl/getFlowControlState.jhtml", //是否审批
        hasDept: "/web/privilegeDept/getEnableDeptId.smallwxHr", //部门权限
        setHeadImg: "/web/empAttachment/saveEmpPhoto.smallwxEmp", //设置头像
        getMenusByMenuTypes: "/web/menu/getMenusByMenuTypes.jhtml", //根据id获取菜单
        delWxBind: "/smallwx/empBaseInfo/delSmallwxREL.smallwx", //删除微信绑定关系

        hasMenu: "/web/menu/getAllAuMenusByMenuType1.jhtml", //获取功能权限

        workIcon: "/web/appIconSource/getAppIcons.empweb", //工作首页图标权限

        bindUnionId: "/smallwx/bindRelaction/bind.smallwx", //小程序unionId绑定

        getBinded: "/smallwx/bindRelaction/getAllRelationTypes.smallwx", //获取已经绑定的应用type

        getHelp: "/web/sysAppHelp/getSysAppHelps.smallwxEmp", //获取帮助初始化信息
        setHelp: "/web/sysAppHelp/updateSysAppHelp.smallwxEmp", //修改帮助设置结果

        sendMail: "/web/bxmail/mail.smallwxEmp", //发送商保联系邮件

        isTxl: "/qywx/other/isInstallTxl.smallwxEmp", //是否要安装通讯录  需要安装通讯录"-->1 ,"不需要安装通讯录"-->2

        selectPms: "/web/manualAdditionalService/findApplyForNum.smallwxHr", //获取初始化选角色操作次数

        fileDownload: "/web/UpLoadFile/download.jhtml", //图片下载
        fileDownloadEmpweb: "/web/UpLoadFile/download.empweb", //图片下载 员工端

        getDic: "/dict/get/by/code.ajax", //获取数据字典
        getDeptTiling: "/web/deptInfo/getTileTree.jhtml", //获取平铺的组织结构（维度类型）
        getAppIconSourceList: "/web/appIconSource/getAppIconSourceList.empweb", //获取工作端权限
        customIcon: "/web/appIconSource/getCustomAppIconSourceList.empweb", //自定义申请权限

        findIsRetranslationInfo: "/web/IsRetranslation/findIsRetranslationInfo.jhtml", //企业微信   员工名称和部门是否需要转译
        findEscapeState: "/web/setoperation/findEscapeState.jhtml", //新企业微信   员工名称和部门是否需要转译
        getAuthInfo: "/qywx/other/getJsConfigSignature.jhtml", // 获取第三方应用的身份信息(corpid,agentid,signature等)
        recordGet: '/web/common/import/record/get.jhtml',
        revokeApply: "/web/attExamStep/revokeApply.jhtml", //撤销申请
        getAttQywxSecrets: "/web/attQywxSecret/getAttQywxSecrets.jhtml", //获取绑定信息接口，不需要参数
        saveAttQywxSecrets: "/web/attQywxSecret/saveAttQywxSecrets.jhtml", //绑定接口
        deleteAttQywxSecrets: "/web/attQywxSecret/deleteAttQywxSecrets.jhtml", //解除绑定接口，不需要参数
        importid:"/web/file/import/getFileImportRecordById.jhtml",//参数  id   轮询接口
    },
    loginApi: {
        login: "/web/user/login.jhtml"
    },
    accountApi: {
        //修改密码
        modifyPwd: "/web/user/updateUserPasswordByOldPwd.jhtml",
        //忘记密码，修改密码接口
        updateUserPassword: "/web/user/updateUserPassword.jhtml",
        //修改手机
        modifyMobile: "/web/user/updateUserMobileByOldMobile.jhtml",
        //获取验证码
        getMobileVerifyCode: "/web/user/getMobileVerifyCode.jhtml",
        //验证验证码
        verifyMobileCode: "/web/user/verifyMobileCode.jhtml",
        getGeetest: "/web/geetest/init.jhtml",
        verifyGeetest: "/web/geetest/verifyLogin.jhtml",
        getUserInfo: '/web/user/getUserInfo.jhtml'

    },
    commonApi: {
        imgcode: "/web/custInfo/authImg.jhtml",
        smscode: "/web/custInfo/getMobileVerifyCode.jhtml",
        mobileVerifyCode: "/web/custInfo/verifyMobileCode.jhtml",
        //获取系统当前时间
        getDate: "/web/sysSet/getSysDate.jhtml",
        //获取系统当前时间
        getDateEmp: "/web/sysSet/getSysDate.empweb",
        //获取城市字典
        getAreaDic: "/web/dictArea/queryDictArea.jhtml",
        getDictAreas: "/web/dictArea/getDictAreas.jhtml", //模糊搜索工作城市
        //下载Excel文件
        downloadExcelFile: "/web/SysCommon/downloadExcelFile.jhtml",
        //首页客户信息
        getCustInfo: "/web/custInfo/getFirstHtmlInfo.jhtml",
        //获得是否开启审批以及是否预设流程接口
        getFlowControlState: "/web/flowControl/getExamType.jhtml",
        getAllMenu: "/web/menu/getAllAuMenus.jhtml", //获取全部菜单
        getReportNames: "/web/report/getReportNames.jhtml", //获取自定义报表名称
        getReportNamesemp: "/web/report/getReportNamesemp/getReportNames.jhtml", //获取自定义报表名称---许婧媛
        getReports: "/web/report/getReports.jhtml", //获取自定义报表数据
        getReportsemp: "/web/report/getReportsemp/getReports.jhtml", //获取自定义报表数据 ----许婧媛
        exportReport: "/web/report/exprotReport.jhtml", //自定义报表导出
        exportReportemp: "/web/report/exportReportemp/exprotReport.jhtml", //自定义报表导出
        getDimension: '/web/setDataDimension/getDimensions.jhtml', //维度类型
        getShowBtnState: '/web/privilegeNew/getIsShowByUserId.jhtml', //显示全部的开与关
        saveShowBtnState: '/web/privilegeNew/updateIsShow.jhtml',//展示全部按钮状态保存
        //获取顶级部门
        getTopDeptInfo: "/web/deptInfo/getTopDeptInfo.jhtml",
        //获取通用字典
        getDict: "/web/dictionary/getDict.jhtml",
        //公用保存未选审批人
        updateExamManSelfSelect: "/web/attRelExamStepSelfSelect/updateExamManSelfSelect.jhtml",
        //获取部门下员工信息 {empName:"",empCode:"",certNo:"":model:"3",deptIds:[1,2,3]}
        getEmpBaseInfosByDeptIds: "/web/empBaseInfo/getEmpBaseInfosByDeptIds.jhtml",
        //根据部门获取人员信息(非华为)  deptId参数
        FHWgetEmpByDeptId: "/web/zr/batchWorkOver/getEmpByDeptId.jhtml",
        //根据姓名搜索员工
        getApproverByVague: "/web/deptInfo/getApproverByVague.jhtml",
        getOrgInfoAndEmpInfo: "/web/deptInfo/getOrgInfoAndEmpInfo.jhtml",

        //按照学院名称模糊查询院校
        searchCustBusinessItem: "/web/custBusinessDict/searchCustBusinessItem.jhtml",
        //员工 下拉框联动字段
        getItemListByParent: "/web/custBusinessDict/getItemListByParent.jhtml",
        //参数businessName :EMPLIST（花名册导入） 
        //LEAVE_EMPLIST（离职历史导入） 
        //IMPORT_EMPLOYMENT_EMP_INFO（录用审批员工信息导入） 
        //IMPORT_EMPTRAIN_EMP_INFO（实习生导入）
        importPage: "/web/file/import/page.jhtml", //上传历史列表
        importSearch: "/web/file/import/search.jhtml", //上传历史搜索
        importGet: "/web/file/import/get.jhtml", //上传历史下载    参数 id


        importEmpRegPage: "/web/file/import/empReg/page.jhtml", //上传历史列表   录用审批
        importEmpSpecialInformationPage: "/web/file/import/empSpecialInformation/page.jhtml", //上传历史列表 特殊信息导入  中软
        importEmpOnjobPage: "/web/file/import/empOnjob/page.jhtml", //上传历史列表   花名册
        importEmpDeparturePage: "/web/file/import/empDeparture/page.jhtml", //上传历史列表    离职
        importEmpInternPage: "/web/file/import/empIntern/page.jhtml", //上传历史列表 实习生
        //员工 下拉框联动字段
        getItemListByParent: "/web/custBusinessDict/getItemListByParent.jhtml",
        //获取部门树
        getDeptTree: '/web/deptInfo/getSimpleTree.jhtml',
        saveDeptTreeOrder:"/web/deptInfo/saveDeptTreeOrder.jhtml",
    },
    //员工模块API
    EmpInfoApi: {
        getAllSetSchema: "/web/attSetSchemaNew/getAllSetSchema.jhtml",
        getUpdateEmpColsList: "/web/empBaseInfoNew/getUpdateEmpColsList.jhtml", //新查询表单接口 2020-12-07
        getUpdateEmpColsListLeave: "/web/empBaseInfoNew/leave/getUpdateEmpColsList.jhtml",
        updateEmpTrainToFormal: "web/empTrainee/updateEmpTrainToFormal.jhtml", //转全职提交表单接口
        getAddColsList: "/web/empBaseInfoNew/getAddColsList.jhtml", //新增查询表单接口 2020-12-09
        geTmplateColsList: "/web/tmpBaseInfo/geTmplateColsList.jhtml", //模板获取详情
        getdictInfoList: "/web/setShowCols/getFieldValueByField.jhtml", //获取关联字典表
        removeTmpBaseInfoByPrimaryKey: "/web/tmpBaseInfo/removeTmpBaseInfoByPrimaryKey.jhtml", //删除入职登记
        getEmpBaseInfoNoWorkIngListPage: "/web/empBaseInfo/getEmpBaseInfoNoWorkIngListPage.jhtml", //待生效列表
        getEmpBaseInfoLeaveListPage: "/web/empBaseInfo/getEmpBaseInfoLeaveListPage.jhtml", //离职列表
        //员工列表字段查询
        searchTemp: "/web/empBaseInfo/searchTemp.jhtml",
        searchTempOfLeave: "/web/empBaseInfo/searchTempOfLeave.jhtml",
        //新增员工
        saveEmpInfo: "/web/empBaseInfo/saveEmpInfo.jhtml",
        //保存待入职
        saveEmpInfo2: "/web/empBaseInfo/saveEmpInfo2.jhtml",
        //修改员工
        updateEmpInfo: "/web/empBaseInfo/updateEmpBaseInfo.jhtml",
        deleteEmpBaseInfo2: "/web/empBaseInfo/deleteEmpBaseInfo2.jhtml",
        //刪除
        deleteEmpBaseInfo: "/web/empBaseInfo/deleteEmpBaseInfo.jhtml",
        deleteEmpBaseInfoIntern: "/web/empBaseInfo/intern/deleteEmpBaseInfo.jhtml",
        //新增员工字段查询
        getShowFields: "/web/setShowCols/getShowFields.jhtml",
        //新增员工字段查询
        getShowFieldsByAppro: "/web/setShowCols/getShowFields.jhtml", //修改人：谭金晶
        //发送短息
        sendSms: "/web/empBaseInfo/sendSms.jhtml",
        //获取员工详细信息
        getEmpPost: "/web/empPost/getEmpPost.jhtml",
        getEmpPost1: "/web/empPost/getEmpPost.empweb",
        getEmpPostByZhuanZheng: "/web/empPost/getEmpPostByZhuanZheng.jhtml",
        // 获取员工的权限
        getEmpUserRoles: "/saastosimple/role/getCurrentUserRoles",
//      批量获取员工权限
		getUserRoles:"/saastosimple/role/getUserRoles",
        //更新员工转正信息
        updateEmpPost: "/web/empPost/updateEmpPost.jhtml",
        //更新员工离职/转正信息
        updateEmpPostAndSoin: "/web/empPost/updateEmpPostAndSoin.jhtml",

        //所有部门
        getDept: "/web/deptInfo/getAllDeptByCustIdToPlugIn.jhtml",
        getDept1: "/web/deptInfo/getAllDeptByCustIdToPlugIn.empweb",
        //获取补偿金免税额
        queryDictAreaAvgwage: "/web/dictAreaAvgwage/queryDictAreaAvgwage.jhtml",
        //根据身份证号得到信息
        getEmpInfoByIdCard: "/web/empBaseInfo/getEmpBaseInfoByIdCard.jhtml",
        //根据字典值动态获取字典项
        getFieldValueByParentId: "/web/setShowCols/getFieldValueByParentId.jhtml",
        //员工列表
        empList: "/web/empBaseInfo/getEmpBaseInfoWorkIngListPage.jhtml",
        empList1: "/web/empBaseInfo/1/getEmpBaseInfoWorkIngListPage.jhtml",
        empList2: "/web/empBaseInfo/2/getEmpBaseInfoWorkIngListPage.jhtml",
        //通过部门获取职级
        getLevelById: "/web/posLevel/getDeptPosLevelByDeptId.jhtml",
        //附件上传
        empUplaod: "/web/UpLoadFile/upload.jhtml",
        cardUploadForFile: "/web/UpLoadFile/cardUploadForFile.jhtml", //证件识别

        empUplaodEmpweb: "/web/UpLoadFile/upload.empweb", //员工端 附件上传
        onJobDownLaodEmpInfo: "/web/empBaseInfo/downLaodEmpInfo.jhtml", //在职导出
        importGrowthRecord:"/web/empBaseInfo/downLaodGrowthRecord.jhtml",//导出成长记录
        onJobDownLaodEmpBaseInfoTemp: "/web/empBaseInfo/downLaodEmpBaseInfoTemp.jhtml", //在职导入模板
        onJobImportExcel: '/web/emp/import/empInfoimport.jhtml', //在职导入
        onJobImportExcelLY: '/mybatis/ly/importExcel.jhtml', //在职导入 --csy
        applyrecordExport:"/web/empBaseInfoNew/downloadChangeOfPersonnel.jhtml",//员工人事异动导出
        importEmploymentExcel: '/web/tmpBaseInfo/importEmploymentExcel.jhtml', //20201215 新录用导入
        downLaodNoWorkIngEmpInfo: '/web/empBaseInfo/downLaodNoWorkIngEmpInfo.jhtml', //待生效导出
        downLaodLZEmpInfoTemp: '/web/empBaseInfo/downLaodLZEmpInfoTemp.jhtml', //离职导入模板
        importExcelByLZEmpInfo: '/mybatis/importExcelByLZEmpInfo.jhtml', //离职导入上传
        leaveEmpInfoimport: "/web/emp/import/leaveEmpInfoimport.jhtml", //离职导入上传 (xin )
        downLaodEmpInfoBylz: '/web/empBaseInfo/downLaodEmpInfoBylz.jhtml', //离职导出
        downLoadUnConfirmedEmpPool: "/web/tmpBaseInfo/downLoadUnConfirmedEmpPool.jhtml", //入职登记导出
        //薪酬管理导入薪酬
        salaryAdjImportExcel: "/web/salaryAdj/importExcel.jhtml", //导入
        salaryAdjDownLaodEmpSalaryAdjTemp: "/web/salaryAdj/downLaodEmpSalaryAdjTemp.jhtml", //模板
        //部门人数上限控制
        getIsEnableAddPerson: "/web/deptInfo/getIsEnableAddPerson.jhtml",
        //员工统计查询
        seachTotal: "/web/empPost/queryEmpCountPage.jhtml",
        //统计导出
        totalExport: "/web/empPost/downExcel.jhtml",
        //我的申请
        personApprove: "/web/attExamStep/getAttExamStepAllowReapplyPage.jhtml",
        //获取员工数据
        getpersonAdd: "/web/setShowCols/getShowUpdateEmpFieldInfos.jhtml",
        //获取员工数据
        getpersonAddByAppro: "/web/setShowCols/getShowUpdateEmpFieldInfos.jhtml",
        //撤销
        personCancel: "/web/attExamStep/epersonCancel/revokeApply.jhtml",
        personCancel1: "/web/attExamStep/1/revokeApply.jhtml",
        //我的申请条件查询
        personApperoveSeach: "/web/attExamStep/getAttExamStepSer.jhtml",
        //离职日期修改
        modifyLevelDate: "/web/empPost/updateLeaveDate.jhtml",
        //根据部门获取员工工号
        getEmpCode: "/web/empPost/getEmpCode.jhtml",
        //获取员工证明文件类型
        queryCertificateTemplate: "/web/certificateTemplate/queryCertificateTemplate.jhtml",
        //员工WORD导出
        exportWrod: "/web/certificateTemplate/exportWrod.jhtml",
        exportSingleWrod: "/web/empBaseInfoNew/exportSingleWrod.jhtml", //新证明文件下载 2020-04-27
        exportListWrods: "/web/empBaseInfoNew/exportListWrods.jhtml", // 证明文件批量下载 2020-04-27
        exportSingleEmployWrod: "/web/tmpBaseInfo/exportSingleEmployWrod.jhtml",
        exportListEmployWrod: "/web/tmpBaseInfo/exportListEmployWrod.jhtml",

        getTiaogang2: "/web/empPost/getTiaogang2.jhtml", //获取调岗数据
        getTiaogang22: "/web/empPost/getTiaogang2.empweb", //获取调岗数据
        saveTiaoGang2: "/web/empPost/saveTiaoGang2.jhtml", //保存调岗
        saveTiaoGang22: "/web/empPost/saveTiaoGang2.empweb", //保存调岗
        getSetShowColsDict: "/web/setShowCols/getSetShowColsDict.jhtml", //获取控件类型集合 
        //待入职搜索接口
        searchTempNoWorking: "/web/empBaseInfo/searchTempNoWorking.jhtml",
        mubanlist: '/web/tmpBaseInfo/loadTmpBaseListPage.jhtml', //员工基本信息/模板信息
        mubandel: '/web/tmpBaseInfo/delTmpBaseInfo.jhtml', //模板删除
        mubansave: '/web/tmpBaseInfo/saveHrTmpBaseInfo.jhtml', //岗位信息存入模板
        mubansaveByAppro: '/web/tmpBaseInfo/saveHrTmpBaseInfo.jhtml', //岗位信息存入模板(录用审批) 修改：谭金晶
        unconfirm: '/web/tmpBaseInfo/saveEmpTmpBaseInfo.jhtml', //存入待确认人才库
        unconfirmByAppro: '/web/tmpBaseInfo/saveEmpTmpBaseInfo.jhtml', //存入待确认人才库(录用审批) 修改：谭金晶
        saveEmpEntry: "/web/tmpBaseInfo/saveEmpEntry.jhtml", //录用审批
        scerweim: '/web/tmpBaseInfo/createQrCode.jhtml', //二维码生成
        scerweimByAppro: '/web/tmpBaseInfo/createQrCode.jhtml', //二维码生成,录用审批 修改：谭金晶
        emppoolsearch: "/web/tmpBaseInfo/searchTemp.jhtml", //待确认人才库搜索
        downloaderweim: '/web/tmpBaseInfo/downloadQrCode.jhtml', //下载二维码
        custname: '/web/custInfo/getCustInfoByCustId.jhtml', //获取公司名称
        sysDateTime: '/web/sysSet/getSysDateTime.jhtml', //获取系统时间（年月日时分秒）
        staffStatisticsGetTime: '/web/custPeriodEmp/getBaseInfo.jhtml', //员工统计获取备份时间
        staffStatisticsSetTime: '/web/custPeriodEmp/saveorUpdateCustPeriodEmp.jhtml', //员工统计设置备份时间
        staffStatisticsGetBackup: '/web/custPeriodEmpMain/getBaseInfo.jhtml', //员工统计获取手动备份时间
        staffStatisticsBackup: '/web/custPeriodEmpMain/saveorUpdateCustPeriodEmpMain.jhtml', //员工统计手动备份
        staffStatisticsList: '/web/custPeriodEmpMain/getCustPeriodEmpMainListPage.jhtml', //员工统计备份列表
        createExcel: '/web/custPeriodEmpMain/createExcel.jhtml', //生成备份文件
        staffStatisticsDownLaod: '/web/custPeriodEmpDetail/downLaodEmpInfo.jhtml', //员工手册下载
        VTsynchronization: "/web/vitasoy/esbEmp/empInfoPlaSync.jhtml", //数据同步  维他奶本地化接口
        ADListAPI: "/web/vitasoyAccount/getVitasoyAccountListPage.jhtml", //ad列表
        ADListDown: "/web/vitasoyAccount/downVitasoyAccountExcel.jhtml", //AD列表导出
        ADListSearch: "/web/vitasoyAccount/searchTemp.jhtml", //ad列表搜索头
        getOtherFieldValueByParentId: "/web/setShowCols/getFieldValueByParentId.jhtml", //下拉查询子集
        getEmpBaseInfoCount: "/web/tmpBaseInfo/getEmpBaseInfoCount.jhtml", //获取暂存数量
        getEmpBaseInfoCountByAppro: "/web/tmpBaseInfo/getEmpBaseInfoCount.jhtml", //获取暂存数量(录用审批) 修改：谭金晶
        savepostinfo:"/web/tmpBaseInfo/saveLoadPicAndExplain.jhtml",//
        getScanInfo:"/web/tmpBaseInfo/getLoadPicAndExplain.jhtml",//获取扫码入职配置信息

        //入职登记
        erGetTmpBaseInfoPage: "/web/tmpBaseInfo/getTmpBaseInfoPage.jhtml", //列表
        //待生效
        peGetEmpBaseInfoNoWorkIngListPage: "/web/empBaseInfo/getEmpBaseInfoNoWorkIngListPage.jhtml", //列表

        checkData: "/web/tmpBaseInfo/checkDataNew.jhtml", //验证数据信息完整性
        checkEmpEntryFlowControl: "/web/tmpBaseInfo/checkEmpEntryFlowControl.jhtml", //判断是不是需要审批
        employeeEntryBatch: "/web/tmpBaseInfo/employeeEntryBatch.jhtml", //批量入职
        getAllTmpBaseInfoPage: "/web/tmpBaseInfo/getAllTmpBaseInfoPage.jhtml", //查看全部
        sendingSms: "/web/tmpBaseInfo/sendingSms.jhtml", //发送短信
        getDetailInfo: "/web/tmpBaseInfo/getDetailInfo.jhtml", //编辑时候获取详情
        updateTmpBaseInfo: "/web/tmpBaseInfo/updateTmpBaseInfo.jhtml", //入职暂存编辑保存
        updateTmpBaseInfoByAppro: "/web/tmpBaseInfo/updateTmpBaseInfo.jhtml", //入职暂存编辑保存(录用审批) 修改：谭金晶
        getEmpBaseInfoOfM: "/web/empBaseInfo/getEmpBaseInfoOfM.jhtml", //获取详情数据

        downLoadUnConfirmedEmpTemplate: "/web/tmpBaseInfo/downLoadUnConfirmedEmpTemplate.jhtml", //入职登记导入

        getEmpListForSearch: "/web/empBaseInfoNew/getEmpListForSearch.jhtml",
        //-----------------------  档案信息管理  ----------------------------
        getDisplayEmpcustomTable: '/web/setCustEmpcustomTable/getDisplayEmpcustomTable.jhtml', //获取档案表单名称模块列表
        getDisplayEmpcustomTabledr: '/web/setCustEmpcustomTable/dr/getDisplayEmpcustomTable.jhtml', //获取档案表单名称模块列表 --csy
        getDisplayEmpcustomTablely: '/web/setCustEmpcustomTable/ly/getDisplayEmpcustomTable.jhtml', //获取档案表单名称模块列表 --csy
        getListEmpOtherData: '/web/empOther/getListEmpOtherData.jhtml', //获取档案列表信息
        searchEmpOther: '/web/empOther/searchEmpOther.jhtml', //列表搜索
        getEmpOtherTemplate: '/web/empBaseInfo/getEmpTemplate.jhtml', //新增添加的模板信息
        saveOrModifyEmpOther: '/web/empOther/saveOrModifyEmpOther.jhtml', //新增保存
        saveOrModifyEmpOtherUpdate: '/web/empOther/update/saveOrModifyEmpOther.jhtml', //新增保存
        downLondEmpOther: "/web/empOther/downLondEmpOther.jhtml", //导出 
        uploadEmpArchive: "/web/empOther/uploadEmpArchive.jhtml", //上传员工档案信息
        downLoadAddTemplate: "/web/empOther/downLoadAddTemplate.jhtml", //下载导入模板
        downLoadEmpArchiveDate: "/web/empOther/downLoadEmpArchiveDate.jhtml", //下载批量修改列表模板
        removeEmpOther: "/web/empOther/removeEmpOther.jhtml", //删除
        deleteEmpArchive: "/web/empOther/deleteEmpArchive.jhtml", //删除 新
        deleteBathEmpArchives: "/web/empOther/deleteBathEmpArchives.jhtml", //删除 批量删除
        checkEmpBlackWhiteInfo: "/web/empBlackWhiteInfo/checkEmpBlackWhiteInfo.jhtml", //征信验证
        findSetOperationInfo: "/web/setoperation/findSetOperationInfo.jhtml", //入职征信验证(是否)
        findSetOperationInfoemp: "/web/setoperation/findSetOperationInfoemp/findSetOperationInfo.jhtml", //入职征信验证(是否)----许婧媛
        findSetOperationInfozxsb: "/web/setoperation/findSetOperationInfozxsb/findSetOperationInfo.jhtml", //社保自行申报入职征信验证(是否)----许婧媛
        downLondPdfEmpBlackWhite: "/web/empBlackWhiteInfo/downLondPdfEmpBlackWhite.jhtml", //征信验证文件下载

        downLaodEmpBaseInfoTempLZ: "/web/empBaseInfo/downLaodEmpBaseInfoTempLZ.jhtml", //下载离职员工模板
        creditList: "/web/empBlackWhiteInfo/getEmpBlackWhiteList.jhtml", //征信列表==黑名单列表
        creditList1: "/web/empBlackWhiteInfo/1/getEmpBlackWhiteList.jhtml", //征信列表==黑名单列表
        creditList2: "/web/empBlackWhiteInfo/2/getEmpBlackWhiteList.jhtml", //征信列表==黑名单列表
        creditSearch: "/web/empBlackWhiteInfo/search.jhtml", //征信搜索==黑名单搜索
        creditSearch1: "/web/empBlackWhiteInfo/creditSearch1/search.jhtml", //征信搜索==黑名单搜索  胡卫卫
        creditAddTemp: "/web/empBlackWhiteInfo/getTemplate.jhtml", //征信添加获取模板==黑名单添加获取模板
        creditAddSavaData: "/web/empBlackWhiteInfo/saveOrModifyEmpBlackInfo.jhtml", //征信添加保存信息==黑名单添加保存信息
        creditDel: "/web/empBlackWhiteInfo/removeEmpBlackWhiteInfo.jhtml", //征信删除==黑名单删除
        creditDel1: "/web/empBlackWhiteInfo/creditDel1/removeEmpBlackWhiteInfo.jhtml", //征信删除==黑名单删除 胡卫卫
        creditDel2: "/web/empBlackWhiteInfo/creditDel2/removeEmpBlackWhiteInfo.jhtml", //征信删除==黑名单删除 胡卫卫
        creditDel3: "/web/empBlackWhiteInfo/creditDel3/removeEmpBlackWhiteInfo.jhtml", //征信删除==黑名单删除  胡卫卫

        creditDownTemp: "/web/empBlackWhiteInfo/downLoadAddTemplate.jhtml", // 征信模板下载==
        creditDownTemp1: "/web/empBlackWhiteInfo/creditDownTemp1/downLoadAddTemplate.jhtml", // 征信模板下载==黑名单模板下载  胡卫卫
        creditUpload: "/web/empBlackWhiteInfo/uploadEmpBlackWhite.jhtml", // 征信模板上传==黑名单模板上传
        creditUpload1: "/web/empBlackWhiteInfo/creditUpload1/uploadEmpBlackWhite.jhtml", //胡卫卫
        creditDownList: "/web/empBlackWhiteInfo/downLondEmpBlackWhiteList.jhtml", // 征信名单导出==黑名单导出
        creditDownList1: "/web/empBlackWhiteInfo/1/downLondEmpBlackWhiteList.jhtml", // 征信名单导出==黑名单导出
        creditDownList2: "/web/empBlackWhiteInfo/2/downLondEmpBlackWhiteList.jhtml", // 征信名单导出==黑名单导出
        saveOrUpdateSetOperation: "/web/setoperation/saveOrUpdateSetOperation.jhtml", //保存征信验证状态

        regular: "/web/empPost/getEmpPostByZhuanZheng.empweb",
        updateEmpPostAndSoin1: "/web/empPost/updateEmpPostAndSoin.empweb",
        updateEmpPostAndSoin2: "/web/empBaseInfoNew/saveEmpLeaveOperation.empweb",
        updateEmpPostAndSoin3: "/web/empBaseInfoNew/saveEmpWorkIngOperation.empweb",

        //----------------20191220 放弃入职
        getCancelWorkingInfo: "/web/empBaseInfo/getCancelWorkingInfo.jhtml", //获取放弃入职原因
        getEmpBaseInfoCancelWorkIngListPage: "/web/empBaseInfo/getEmpBaseInfoCancelWorkIngListPage.jhtml", //放弃入职列表
        searchTempCancelWorking: "/web/empBaseInfo/searchTempCancelWorking.jhtml", //搜索
        updateEmpBaseInfoNoWorking: "/web/empBaseInfo/updateEmpBaseInfoNoWorking.jhtml", //转待入职
        downLaodEmpInfoCancelRuzhi: "/web/empBaseInfo/downLaodEmpInfoCancelRuzhi.jhtml", //导出

        //----------------20191230 转正申请管理 Positive
        getEmpBaseInfoReguListPage: "/web/empPost/getEmpBaseInfoReguListPage.jhtml", //转正管理列表
        PositiveSearchTemp: "/web/empPost/searchTemp.jhtml", //转正管理列表的搜索模板
        getEmpBaseInfoReguListPage2: "/web/empPost/getEmpBaseInfoReguListPage2.jhtml", //转正管理列表(待生效)
        PositiveSearchTemp2: "/web/empPost/searchTemp2.jhtml", //转正管理列表的搜索模板(待生效)

        ToBeConfirmedSearchTemp: "/web/empPost/searchToBeReguTemp.jhtml", //待转正管理列表的搜索模板
        ToBeConfirmedListPage: "/web/empPost/getEmpBaseInfoBeReguPage.jhtml", //待转正管理列表
        ToBeConfirmedDown: "/web/empPost/exportEmpBaseInfoToBeReguExcel.jhtml", //待转正管理列表导出

        //----------------20200103 离职申请管理 
        getHandlingLeaveEmpListPage: "/web/empBaseInfoNew/getHandlingLeaveEmpListPage.jhtml", //离职管理列表
        searchLeaveTemp: "/web/empBaseInfoNew/searchLeaveTemp.jhtml", //办理离职列表/待生效离职列表  搜索模板
        getConfirmLeaveEmpListPage: "/web/empBaseInfoNew/getConfirmLeaveEmpListPage.jhtml", //离职管理列表(待生效)
        getConfirmLeaveEmpDown: "/web/empBaseInfoNew/downloadConfirmLeaveEmpExcel.jhtml", //待离职导出接口

        //web/empPost/updateEmpPostAndSoin
        // 接口换成
        // /web/empBaseInfoNew/saveEmpLeaveOperation  办理员工离职信息  接口调整参数不动 
        saveEmpLeaveOperation: "/web/empBaseInfoNew/saveEmpLeaveOperation.jhtml",

        //确认离职保存
        saveConfirmLeave: "/web/empPost/saveConfirmLeave.jhtml",
        cancelLeave: "/web/empPost/cancelLeave.jhtml", //放弃离职
        examStep: "/web/attExamStep/examStep.jhtml", //放弃离职 (新2020-02-24)
        getMattersInfo: "/web/empPost/getEmpInfo.jhtml", //获取离职事项信息
        isTerminate: "/web/empPostContractApply/verifyContractRelieve.jhtml", //离职事项里  合同是否允许解除的校验接口

        //web/empPost/updateEmpPostAndSoin
        // 接口换成
        // /web/empBaseInfoNew/saveEmpWorkIngOperation  办理员工转正信息  接口调整参数请把empId放到 empPost:{empId,....}
        saveEmpWorkIngOperation: "/web/empBaseInfoNew/saveEmpWorkIngOperation.jhtml",
        getLeaveEmpBaseInfo: "/web/empBaseInfo/getLeaveEmpBaseInfo.jhtml", //离职在入职获取数据

        //离职在入职
        getEmpLeaveList: "/web/empBaseInfoNew/getEmpLeaveList.jhtml", //员工入职时获取员工离职

        //----------------20200108 调岗申请管理 
        getEmpBaseInfoTiaogangListPage: "/web/empPost/getEmpBaseInfoTiaogangListPage.jhtml", //调岗管理列表
        getEmpBaseInfoTiaogangListPage2: "/web/empPost/getEmpBaseInfoTiaogangListPage2.jhtml", //调岗待生效列表
        getEmpBaseInfoTiaogangHisListPage: "/web/empPost/getEmpBaseInfoTiaogangHisListPage.jhtml", //调岗历史列表
        searchTempOfTiaogang: "/web/empPost/searchTempOfTiaogang.jhtml", //调岗待生效和调岗历史记录搜索共用接口
        searchTempOfTiaogang1: "/web/empPost/searchTempOfTiaogang1/searchTempOfTiaogang.jhtml", //调岗待生效和调岗历史记录搜索共用接口  胡卫卫
        searchTemp3: "/web/empPost/searchTemp3.jhtml", //调岗管理搜索接口

        downloadChangePostTemplate: "/web/empPost/downloadChangePostTemplate.jhtml", //调岗导入模板下载接口
        importChangePost: "/web/empPost/importChangePost.jhtml", //调岗导入接口


        // ------ 20200121我的申请
        getChangeOfPersonnelSearchTemp: "/web/empBaseInfoNew/getChangeOfPersonnelSearchTemp.jhtml", //员工人事异动查询模板
        getChangeOfPersonnelList: "/web/empBaseInfoNew/getChangeOfPersonnelList.jhtml", //PC员工人事异动列表/异动端我的申请列表

        // -------20200304直接主管
        getDirectSupervisorEmpList: "/web/empBaseInfoNew/getDirectSupervisorEmpList.jhtml",

        // -------20200311编制
        findPositionEmptyAndAuthorized: "/web/authorized/strength/statistics/findPositionEmptyAndAuthorized.jhtml", //根据部门和岗位查询编制列表：
        findLevelAndPostTypeAndStaffRankByAuthStrenId: "/web/authorized/strength/statistics/findLevelAndPostTypeAndStaffRankByAuthStrenId.jhtml", //根据编制Id查询职位类型、职位等级、员工等级

        //--------20200317审批补充信息 (新版)
        getFormActionRights: "/web/emp/empSupplementInfo/getFormActionRights.jhtml", //获取员工入职补充信息接口

        salaryAdjExport: "/web/salaryAdj/export.jhtml", //导出薪酬
        empSubsidyProjectExport: "/web/empSubsidyProject/export.jhtml", //导出津贴

        leaveSalaryAdjExport: "/web/salaryAdj/leave/export.jhtml", //导出薪酬
        leaveEmpSubsidyProjectExport: "/web/empSubsidyProject/leave/export.jhtml", //导出津贴

        //----------------------------2020-08-25补充信息
        getSupplementTemplateDetail: "/web/supplementTemplateDetail/getSupplementTemplateDetail.jhtml", //设置邀请员工补充信息模板
        saveSupplementTemplateDetail: "/web/supplementTemplateDetail/saveSupplementTemplateDetail.jhtml", // 保存员工信息补充模板，并邀请员工补充信息

        getEmpSupplementInfoByPage: "/web/emp/empSupplementInfo/getEmpSupplementInfoByPage.jhtml", //列表
        empSupplementInfoSearchTemp: "/web/emp/empSupplementInfo/searchTemp.jhtml", //列表搜索
        relinquishEmpSupplementInfo: "/web/emp/empSupplementInfo/relinquishEmpSupplementInfo.jhtml", //放弃补充接口
        synchEmpSupplementInfo: "/web/emp/empSupplementInfo/synchEmpSupplementInfo.jhtml", //确认补充信息
        synchEmpSupplementInfoBatch: "/web/emp/empSupplementInfo/synchEmpSupplementInfoBatch.jhtml", //批量确认补充信息


        //---------------------------------2020-09-04
        //薪酬列表
        salaryAdjGetLogListPage: "/web/salaryAdj/getLogListPage.jhtml",
        salaryAdjSearchTemplate: "/web/salaryAdj/searchTemplate.jhtml",
        salaryAdjExportLog: "/web/salaryAdj/exportLog.jhtml",
        //津贴列表
        empSubsidyProjectGetLogListPage: "/web/empSubsidyProject/getLogListPage.jhtml",
        empSubsidyProjectSearchTemplate: "/web/empSubsidyProject/searchTemplate.jhtml",
        empSubsidyProjectExportLog: "/web/empSubsidyProject/exportLog.jhtml",

        // ------------------2020-09-14 调岗历史导出
        downLaodTiaoGangHis: "/web/empPost/downLaodTiaoGangHis.jhtml",


        //-------------------2020-09-17 
        addEmpLocationRelation: "/web/attEmpLocation/addEmpLocationRelation.jhtml", //批量新增 json格式：{relations:[{startTime:'',endTime:'',locations:[1,2,3,4]}]}

        NewAddEmpLocationRelation: "/web/attLocationApply/addLocationApply.jhtml", //新的调整考勤地点 保存接口
        getHistoryList: "/web/attEmpLocation/getHistoryList.jhtml", //分页查询历史记录列表
        getSearchTemplate: "/web/attEmpLocation/getSearchTemplate.jhtml", //高级查询字段
        getLocationDetailForPerson: "/web/attEmpLocation/getLocationDetailForPerson.jhtml", //获取员工考勤地点设置(isHistory=0 生效和待生效 isHistory=1 历史数据)  两个参数empId、isHistory get请求
        getAllLocationsForSelect: "/web/attSetLocation/getAllLocationsForSelect.jhtml", //所有考勤地点下拉数据；参数locSetCode 可不传 get请求

        getPlaceList: '/web/attLocationApply/getSomeOneEffective.jhtml', //获取当前生效考勤地点
        savePlaceInfo: "/web/attLocationApply/addLocationApply.jhtml", //  保存考勤地点调整
        AStayTakeEffectList: "/web/attLocationApply/getSinglePlaceList.jhtml", //单个打卡地点调整中列表
        AStayTakeEffectSearch: "/web/attLocationApply/list/searchSinglePlaceTemp.jhtml", //单个打卡地点调整中高级筛选模板

        AgetEmployeeHisList: "/web/attLocationApply/getSinglePlaceHisList.jhtml", //单个打卡地点历史记录列表
        AgetEmployeeHisSearch: "/web/attLocationApply/history/searchSinglePlaceTemp.jhtml", //单个打卡地点历史记录高级筛选模板
        adjustmentbatchattendanceList: "/web/attLocationApply/queryByPageForAdjustment.jhtml", //获取批量考勤地点列表
        adjustmentbatchattendanceSearch: "/web/attLocationApply/getAdjuestmentSearchTemplate.jhtml", //获取批量考勤地点列表搜索条件
        OneAdjustmentbatchattendanceList: "/web/attLocationApply/one/queryByPageForAdjustment.jhtml", //获取单个考勤地点列表
        OneAdjustmentbatchattendanceSearch: "/web/attLocationApply/one/getAdjuestmentSearchTemplate.jhtml", //获取单个考勤地点列表搜索条件
        adjustmentbatchattendanceGetInfo: "/web/attLocationBatchApply/getEffectiveLocations.jhtml", //获取 批量 员工考勤点详情的  
        StayTakeEffectList: "/web/attLocationBatchApply/getEmployeeList.jhtml", //批量考勤地点发起调整中列表
        StayTakeEffectSearch: "/web/attLocationBatchApply/list/searchEmployeeTemp.jhtml", //批量考勤地点发起调整中搜索条件
        isRevokeApply: "/web/attLocationBatchApply/getApplyState.jhtml", //查询是否 可以继续撤回
        getEmployeeHisList: "/web/attLocationBatchApply/getEmployeeHisList.jhtml", //批量发起历史页面中
        getEmployeeHisSearch: "/web/attLocationBatchApply/history/searchEmployeeTemp.jhtml", //批量发起历史页面搜索条件

        fileDownList: "/web/annex/getAnnexPage.jhtml", //   员工附件下载列表 
        fileDownSearch: "/web/annex/getAnnexTemp.jhtml", //  员工附件下载 列表搜索模板获取
        fileDownRecordsList: "/web/annex/downAnnexPage.jhtml", //员工附件下载记录列表
        getDownPath: "/web/annex/getPathByAnnexId.jhtml", //员工附件下载记录列表 中 获取下载附件路径
        getFileDownType: "/web/annex/getAnnexData.jhtml", //获取可以下载的附件类型
        saveFileDownInfo: "/web/annex/saveAnnexData.jhtml", //提交 需要下载的附件信息

        //---------------------2020-09-17
        getEmpChangeJobHistoryList: "/web/empBaseInfoNew/getEmpChangeJobHistoryList.jhtml", //穿越数据列表


        //----------------------2020-10-26 
        //实习生
        getEmpTraineeSer: "/web/empTrainee/getEmpTraineeSer.jhtml", //查询条件接口
        getEmpTraineePage: "/web/empTrainee/getEmpTraineePage.jhtml", // 分页查询接口

        empTraineeDownLaodEmpBaseInfoTemp: "/web/empTrainee/downLaodEmpBaseInfoTemp.jhtml", //导入模板下载接口
        empTraineeImportExcel: "/mybatis/importExcel.jhtml?opType=train", //导入接口
        empTraineeDownloadEmpTrainee: "/web/empTrainee/downloadEmpTrainee.jhtml", //导出


        empTraineeImportEmpTrainExcel: "/web/empTrainee/importEmpTrainExcel.jhtml", //导入接口
        //转全职员工记录
        getChangeOfPersonnelSearchTempEmpTrainee: "/web/empTrainee/getChangeOfPersonnelSearchTemp.jhtml", // 查询条件接口
        getChangeOfPersonnelListEmpTrainee: "/web/empTrainee/getChangeOfPersonnelList.jhtml", //分页查询接口

        empTraineeDownloadChangeOfPersonnelList: "/web/empTrainee/downloadChangeOfPersonnelList.jhtml", //导出

        getLeaveShowFields: "/web/empDetail/getLeaveShowFields.jhtml", //原离职信息

        getEmpOther: "/web/empOther/getEmpOther.jhtml", //档案信息查询
        removeEmpOther: "/web/empOther/removeEmpOther.jhtml", //档案信息删除 
        getTechniqueCategoryColsList: "/web/empDetail/getTechniqueCategoryColsList.jhtml", //获取主技能标签
        getLevelItemListById: "/web/custBusinessDict/getLevelItemListById.jhtml", //查询主技能选中的那个层级ID  返回当前级联层级下的多技能列表


        //2020-12-25调整历史记录查询和修改  导入
        getEmpPostSpecialFeild: "/web/icss/empPost/getEmpPostSpecialFeild.jhtml", //查询岗位特殊字段调整表单接口,直接返回表单，字段的选择级联等跟花名册表单一样
        updateEmpPostSpecialFeild: "/web/icss/empPost/updateEmpPostSpecialFeild.jhtml", //保存接口
        getEmpPostSpecialFeildLogPage: "/web/icss/empPost/getEmpPostSpecialFeildLogPage.jhtml", //调整记录分页查询接口
        getEmpPostSpecialFeildImportTitle: "/web/icss/empPost/getEmpPostSpecialFeildImportTitle.jhtml", //查询岗位特殊字段导入tab切换页接
        downLoadEmpPostSpecialFeildImportTemplate: "/web/icss/empPost/downLoadEmpPostSpecialFeildImportTemplate.jhtml", //模板下载接口
        importEmpPostSpecialFeildExcel: "/web/icss/empPost/importEmpPostSpecialFeildExcel.jhtml", //导入接口

        downLaodNoWorkIngEmpSalary: "/web/vitasoyEmpBaseInfo/downLaodNoWorkIngEmpSalary.jhtml", //入职管理中 薪酬津贴导出接口

        checkStartFlow: "/web/empapply/checkStartFlow.jhtml", //校验申请请能否发起


        //2021-02-26  批量确认入职
        batchEmpBaseInfoEntry: "/web/empBaseInfo/batchEmpBaseInfoEntry.jhtml", //批量确认入职接口
        selectBatchEmpBaseInfoEntry: "/web/empBaseInfo/selectBatchEmpBaseInfoEntry.jhtml", //查询是否可以发起批量入职
        getEmpBaseInfoOrderListPage:"/web/empBaseInfo/getEmpBaseInfoOrderListPage.jhtml",//员工排序列表
        searchToEmpOrderTemp:"/web/empBaseInfo/searchToEmpOrderTemp.jhtml",//员工排序筛选条件
        exportEmpOrderExcel:"/web/empBaseInfo/exportEmpOrderExcel.jhtml",//员工筛选列表导出
        exportEmpOrderExcelTemplate:"/web/empBaseInfo/exportEmpOrderExcelTemplate.jhtml",//导出上传的文件模板
        importEmpOrderExcel: "/web/empBaseInfo/importEmpOrderExcel.jhtml",//导入
        clearSort:"/web/empBaseInfo/clearEmpOrder.jhtml",//清空排序
    },
    editEmpApi: {
        saveSubsidy: '/web/empSubsidyProject/save.jhtml', //津贴信息保存
        getFlowControlState: '/web/flowControl/getExamType.jhtml', //获取是否需要审批
        getEmpCode: "/web/empPost/getEmpCode.jhtml", //获取工号
        saveEmpInfo2Mth: '/web/empBaseInfo/saveEmpInfo2Mth.jhtml', //保存

        getShowUpdateEmpFieldsemp: '/web/empBaseInfo/emp/getEmpBaseInfos.jhtml', //获取基本信息(个人)
        getShowUpdateEmpFieldspost: '/web/empBaseInfo/post/getEmpBaseInfos.jhtml', //获取基本信息(岗位)
        getShowUpdateEmpFieldscompensation: '/web/empBaseInfo/compensation/getEmpBaseInfos.jhtml', //获取基本信息(薪酬)
        getShowUpdateEmpFieldscontract: '/web/empBaseInfo/contract/getEmpBaseInfos.jhtml', //获取基本信息(合同)
        getShowUpdateEmpFieldsfile: '/web/empBaseInfo/file/getEmpBaseInfos.jhtml', //获取基本信息(附件)
        getShowUpdateEmpFields: '/web/empBaseInfo/getEmpBaseInfos.jhtml', //获取基本信息(默认)
        getEmpViewDetailColsList: '/web/empBaseInfoNew/getEmpViewDetailColsList.jhtml', //
        getAddTemplate: '/web/empSubsidyProject/getAddTemplate.jhtml', //获取津贴信息模板
        updateEmpBaseInfo: '/web/empBaseInfo/updateEmpBaseInfo.jhtml', //保存基本信息
        getShowUpdatePostFields: '/web/setShowCols/getShowUpdatePostFields.jhtml', //获取岗位信息
        getDeptPosLevelByDeptId: '/web/posLevel/getDeptPosLevelByDeptId.jhtml', //通过部门获取岗位
        getSysDate: '/web/sysSet/getSysDate.jhtml', //获取系统时间
        queryDictArea: '/web/dictArea/queryDictArea.jhtml', //查询省市区
        getFieldValueByParentId: '/web/setShowCols/getFieldValueByParentId.jhtml', //查询关联项
        empAdjustReport: '/web/vitasoyReport/empAdjustReport.jhtml', //备份异常统计
        downExcel: '/web/vitasoyReport/downExcel.jhtml' //导出
    },
    danganDetailApi: {
        upload: '/web/empAttachment/uploadEmpPhoto.jhtml',
        getList: '/web/empOther/getEmpOther.jhtml',
        removeDetail: '/web/empOther/removeEmpOther.jhtml',
        save: '/web/empOther/saveOrModifyEmpOther.jhtml',

    },
    customerApi: {
        loadCustInfo: "",
        addCustInfo: "/web/custInfo/addCustInfo.jhtml",
        updateCustInfo: "/web/custInfo/updateCustInfo.jhtml"
    },
    DeptInfoApi: {
        //新增
        add: "/web/deptInfo/addDetpInfo.jhtml",
        //修改
        edit: "/web/deptInfo/updateDeptInfo.jhtml",
        //删除组织
        remove: "/web/deptInfo/deleteDeptInfo.jhtml",
        //获取所有
        getAll: "/web/deptInfo/getOrgInfo.jhtml",
        //部门实体
        get: "/web/deptInfo/getDeptInfoByDeptId.jhtml",
        getDeptFromEmp: "/web/deptInfo/emp/getDeptInfoByDeptId.jhtml",
        //部门移动数据
        getSelect: "/web/deptInfo/getOrgSelectInfo.jhtml",
        //组织图形预览
        view: "/web/deptInfo/getOrgInfoByDept.jhtml",
        //获取有权限的部门
        getEnableDeptId: "/web/privilegeDept/getEnableDeptId.jhtml",
        //审批设置获取有权限的部门
        getDeptInfoByPrivilege: "/web/deptInfo/getDeptInfoByPrivilege.jhtml",
        //岗位设置列表
        postList: "/web/posLevel/getDeptPosLevelPage.jhtml",
        //岗位设置新增
        postAdd: "/web/posLevel/saveDeptPosLevel.jhtml",
        //岗位设置修改
        postModify: "/web/posLevel/updateDeptPosLevel.jhtml",
        //岗位设置获取
        postGet: "/web/posLevel/getDeptPosLevel.jhtml",
        //岗位设置删除
        postDel: "/web/posLevel/deleteDeptPosLevel.jhtml",
        //岗位设置修改状态
        postSetStatus: "/web/posLevel/updateIsEnable.jhtml",
        //岗位设置查询
        searchTemp: "/web/posLevel/searchTemp.jhtml",
        //获得所有部门与岗位对应的数据
        getAllPositionLevelGroupByDeptId: "/web/posLevel/getAllPositionLevelGroupByDeptId.jhtml",
        //获取所有部门及人员
        getOrgInfoAndEmpInfo: "/web/deptInfo/getOrgInfoAndEmpInfo.jhtml",
        //------------------------------------------
        getAddTmplate: "/web/posLevel/getAddTmplate.jhtml", //新增获取
        getUpdateTmplate: "/web/posLevel/getUpdateTmplate.jhtml" //编辑获取
    },
    holiday: {
        //年假清零
        yearClear: "/web/deptInfo/getOrgInfoAndEmpInfo.jhtml",
        yearClearSub: "/web/attHolYear/clearAttHolYearRecords.jhtml",
        dayOffClearSub: "/web/attHolRest/clearAttHolRestRecords.jhtml",
        sicklist: '/web/attHolSick/queryAttHolSickByPage.jhtml', //带薪病假列表
        sickcal: '/web/attHolSick/caculateAttHolSick.jhtml', //带薪病假计算
        sickclear: '/web/attHolSick/clearAttHolSick.jhtml', //带薪病假清零
        sickgetdata: '/web/attHolSick/getAttHolSick.jhtml', //带薪病假编辑获取数据
        sickeditsave: '/web/attHolSick/updateAttHolSick.jhtml', //带薪病假编辑保存
        sickdaochu: '/web/attHolSick/exportAttHolSick.jhtml', //带薪病假导出
        sickdaoru: '/web/attHolSick/importAttHolSick.jhtml', //带薪病假导入
        sickdaorumuban: '/web/attHolSick/exportAttSickTemplate.jhtml', //带薪病假导入模板
        sickhistory: '/web/attHolYearRestTrash/queryAttHolSickTrashPage.jhtml', //带薪病假历史报表
        sickser: '/web/attHolSick/getAttSickSearchTemplate.jhtml', //带薪病假列表搜索
        sickhistoryser: '/web/attHolYearRestTrash/searchAttHolSickTrashTemp.jhtml', //带薪病假历史报表列表搜索
        payclear: '/web/attHolPayRest/clearHolPayRest.jhtml', //付费调休清零
        bxzyClear: '/web/attHolPayRest/clearBxzyRest.jhtml', //补休资源清零
        getCurrentSchema: '/web/attSetSchemaNew/getCurrentSchema.empweb', //获取当前员工考勤设置
        saveAttOverseasAssignmentForm: "/web/attOverseasAssign/saveAttOverseasAssignmentForm.jhtml", //新增海外驻派人员
        updateAttOverseasAssignment: "/web/attOverseasAssign/updateAttOverseasAssignment.jhtml", //修改海外驻派人员
        deleteAttOverseasAssignmentByEmpId: "/web/attOverseasAssign/deleteAttOverseasAssignmentByEmpId.jhtml", //删除海外驻派人员
        queryAttOverseasAssignmentPage: "/web/attOverseasAssign/queryAttOverseasAssignmentPage.jhtml", //列表
        exportAttOverseasAssignmentExcel: "/web/attOverseasAssign/exportAttOverseasAssignmentExcel.jhtml", //海外驻派人员导出
        importAttOverseasAssignmentExcel: "/web/attOverseasAssign/importAttOverseasAssignmentExcel.jhtml", //海外驻派人员导入
        getAttOverseasAssignment: "/web/attOverseasAssign/getAttOverseasAssignment.jhtml", //查询海外驻派人员
        exportAttOverseasAssignmentTemplate: "/web/attOverseasAssign/exportAttOverseasAssignmentTemplate.jhtml", //下载导入模板
        queryAttGiveUpHolyearPage: "/web/attGiveUpHolYear/queryAttGiveUpHolYearPage.jhtml", //放弃年假列表
        deleteAttGiveUpHolyearByIds: "/web/attGiveUpHolYear/deleteAttGiveUpHolYearByIds.jhtml", //删除放弃年家
        exportAttGiveUpHolyearTemplate: "/web/attGiveUpHolYear/exportAttGiveUpHolYearTemplate.jhtml", //导出模板
        exportAttGiveUpHolyearExcel: "/web/attGiveUpHolYear/exportAttGiveUpHolYearExcel.jhtml", //导出excel
        importAttGiveUpHolyearExcel: "/web/attGiveUpHolYear/importAttGiveUpHolYearExcel.jhtml", //上传文件
        saveAttGiveUpHolyearForm: "/web/attGiveUpHolYear/saveAttGiveUpHolYearForm.jhtml", //添加放弃年假人员
        queryAttOverseasAssignmentHistoryPage: "/web/attOverseasAssign/queryAttOverseasAssignmentHistoryPage.jhtml", //海外年假历史列表
        exportAttOverseasAssignmentHistoryExcel: "/web/attOverseasAssign/exportAttOverseasAssignmentHistoryExcel.jhtml", //海外年假历史导出
        queryAttGiveUpHolyearHistoryPage: "/web/attGiveUpHolYear/queryAttGiveUpHolYearHistoryPage.jhtml", //放弃年假历史列表
        exportAttGiveUpHolyearHistoryExcel: "/web/attGiveUpHolYear/exportAttGiveUpHolYearHistoryExcel.jhtml", //放弃年假历史导出
        getSearchOverseasAssignTemplate: "/web/attOverseasAssign/overSeas/getSearchOverseasAssignTemplate.jhtml", //海外年假人员搜索
        getSearchOverseasAssignTemplatehistory: "/web/attOverseasAssign/overSeasHistory/getSearchOverseasAssignTemplate.jhtml", //海外年假历史搜索
        getSearchGiveUpTemplate: "/web/attGiveUpHolYear/giveUp/getSearchGiveUpTemplate.jhtml", //放弃年假搜索
        getSearchGiveUpTemplatehistory: "/web/attGiveUpHolYear/giveUpHistory/getSearchGiveUpTemplate.jhtml", //放弃年假历史搜索
    },
    NewsalaryAPI: { //新的薪酬
        ManagementList: "/payrollSetSchema/getPage.jhtml", // 薪酬方案管理的列表页
        getDetail: "/payrollSetSchema/getDetail.jhtml", //打开新增/修改
        getInitData: "/payrollSetSchema/getInitItem.jhtml", //获得初始化数据
        getItem: "/payrollSetSchema/getGroupItem.jhtml", //获得分组项
        editData: "/payrollSetSchema/edit/save.jhtml", //修改保存
        addData: "/payrollSetSchema/add/save.jhtml", //新增保存
        delete: "/payrollSetSchema/delete.jhtml", //  删除薪酬方案
        updateEnable: "/payrollSetSchema/updateEnable.jhtml", //修改状态
        groupList: "/payrollSetting/getPage.jhtml", //薪资组 列表
        groupSearch: "/payrollSetting/getSearch.jhtml", //薪资组搜索
        groupGetDetail: "/payrollSetting/getDetail.jhtml", //薪资组获取详情
        groupSave: "/payrollSetting/save.jhtml", //薪资组保存
        groupDelete: "/payrollSetting/delete.jhtml", //删除薪资组
        getGuideSetting: "/payrollSetSchema/getGuideSchema.jhtml", //
    },
    salaryApi: {
        getSalaSettingsPage: '/web/payrollSalaSettings/getPage.jhtml', //获取薪资组分页
        getSalaSettingsPage1: '/web/payrollSalaSettings/1/getPage.jhtml', //获取薪资组分页 归档历史
        getSalaSettingsSearch: '/web/payrollSalaSettings/getSearch.jhtml', //获取薪资组分页
        getSalaSettingsDetail: '/web/payrollSalaSettings/getDetailEcology.jhtml', //获取薪资详情
        getTempDetailApi: '/web/payrollSalaSettingsItem/getDetail.jhtml', //获取单个薪酬调整的模板
        upDetailApi: '/web/payrollSalaSettingsItem/update.jhtml', //修改单个薪酬调整的数据
        saveSalaData: "/web/payrollSalaSettings/save.jhtml", //保存薪酬组数据   新增和修改的保存
        salaryDelEmp: '/web/payrollSalaSettingsItem/delete.jhtml', //删除人员
        salaryDelItem: '/web/payrollSalaSettings/delete.jhtml', //删除薪酬组
        getSalaStated: '/web/payrollSalaSettings/getPayrollSalaInfos.jhtml', //获取该月数据准备的状态
        salarycreadSet: "/web/payrollSetRules/savePayrollSetRuels.jhtml", //初始选择信息保存
        getPayrollSetRules: '/web/payrollSetRules/getPayrollSetRules.jhtml', //获取选择信息
        salarySubject: "/web/payrollSetSalaSchema/getPayrollSetSalaSchemaForNew.jhtml", //获取薪酬方案信息
        salarySubjectDel: "/web/payrollSetSalaSchemaItem/deletePayrollSetSalaSchemaItem.jhtml", //薪酬方案删除  单个
        salarySubjectSave: "/web/payrollSetSalaSchemaItem/addOrUpdatePayrollSetSalaSchemaItem.jhtml", //修改保存 和新增保存
        salaryManagerList: "/web/payrollSalaSettings/queryPayrollSalaSettingsPage.jhtml", //获取薪酬历史列表
        //高级版薪酬字段获取
        salarySubjectOldGet: '/web/setShowCols/getSetShowFieldsList.jhtml',
        //高级版薪酬字段编辑保存
        salarySubjectOldEditSave: '/web/setShowCols/saveSetShowCol_single.jhtml',
        //高级版薪酬字段删除
        salarySubjectOldDel: '/web/setShowCols/delSetShowCols.jhtml',
        salarySubjectOldDelold: '/web/setShowCols/salarySubjectOldDelold/delSetShowCols.jhtml',
        getAddEmp: "/web/payrollSalaSettingsItem/getDictAddEmp.jhtml", //获得可添加的人信息
        defuctionlist: '/web/taSpecialDeuction/listByPage.jhtml', //员工个税附加扣除列表
        cefuctionDown: '/web/taSpecialDeuction/downLoadExcelTemplate.jhtml', //员工个税附加扣除下载
        cefuctionUp: '/web/taSpecialDeuction/importExcel.jhtml', //员工个税扣除导入
        ReverseFiling: '/web/payrollSalaSettings/updateStateArchReverse.jhtml', //反归档
        filingDang: '/web/payrollSalaSettings/queryPayrollSalaSettingsHistoryPage.jhtml', //已归档获取  统 计信息
        //薪酬管理字典
        salaryDic: "/web/payrollSalaSettings/openAddPayrollSalaSettings.jhtml",
        //薪酬管理新增接口
        salaryAdd: "/web/payrollSalaSettings/savePayrollSalaSettings.jhtml",
        //薪酬管理编辑获取信息接口
        salaryGetInfo: "/web/payrollSalaSettings/openUpdatePayrollSalaSettings.jhtml",
        //薪酬管理编辑接口
        salaryEdit: "/web/payrollSalaSettings/updatePayrollSalaSettings.jhtml",
        //薪酬首页删除接口
        salaryMainDelete: "/web/payrollSalaSettings/deletePayrollSalaSettings.jhtml",
        //人员调整删除接口
        turnoverDelete: "/web/payrollSalaSettingsItem/deletePayrollSalaSettingsItem.jhtml",
        //人员调整
        turnoverList: "/web/payrollSalaSettingsItem/queryPayrollSalaSettingsItemPage.jhtml",
        //薪酬调整
        salaryAdjustList: "",
        //薪酬计算列表
        salaryCalcList: "",
        salaryArchive: "/web/payrollSalaSettings/archPayrollSalaSettings.jhtml",
        salaryCalc: "/web/payrollSalaSettings/calculatePayrollSalaSettings.jhtml",
        //归档本月
        salaryArchiveList: "",
        //发送工资条
        salaryBillList: "",
        //人员调整搜索接口
        turnoverListSearch: "/web/payrollSalaSettingsItem/getPayrollSalaSettingsItemSer.jhtml",
        //薪酬调整搜索接口
        salaryAdjustSearch: "",
        //薪酬计算搜索接口
        salaryCalcSearch: "",
        //归档本月搜索接口
        salaryArchiveSearch: "",
        //发送工资条搜索接口
        salaryBillSearch: "",
        //归档历史、详情搜索接口
        salaryArchiveHistorySearch: "/web/payrollSalaSettings/getHistoryPayrollSalaSettingsItemSer.jhtml",
        //薪酬管理搜索接口
        salarySearch: "/web/payrollSalaSettings/getPayrollSalaSettingsSer.jhtml",
        //归档历史
        salaryArchiveHistory: "/web/payrollSalaSettings/queryPayrollSalaSettingsHistoryPage.jhtml",
        //归档历史导出接口
        salaryArchiveHisExport: "/web/payrollSalaSettings/downHistoryExcel.jhtml",
        //归档历史详情
        salaryArchiveHistoryDetail: "/web/payrollSalaSettingsItem/PayrollSalaSettingsItemDetailPage.jhtml",
        //归档历史详情导出接口
        salaryArchiveHisDetailExport: "/web/payrollSalaSettingsItem/downExcel.jhtml",
        //薪酬报表搜索接口
        salaryRptSearch: "/web/EmpPayReport/searchMonthReportTemp.jhtml",
        //薪酬报表数据汇总搜索接口
        dataSumSearch: "",
        //薪酬报表部门汇总搜索接口
        deptSumSearch: "/web/EmpPayReport/getDeptStatisticsSearchTemp.jhtml",
        //薪酬报表人工成本搜索接口
        laborCostSearch: "/web/EmpPayReport/searchEmpPayRollTemp.jhtml",
        //工资报表统计接口
        salaryStaticRpt: "/web/EmpPayReport/getEmpPayRollStatistics.jhtml",
        //工资报表
        salaryReport: "/web/EmpPayReport/queryEmpPayReportPage.jhtml",
        //数据汇总
        dataSumReport: "/web/EmpPayReport/queryEmpPayReportPage.jhtml",
        //部门汇总
        deptSumReport: "/web/EmpPayReport/getDeptStatisticsInfo.jhtml",
        //人工成本
        laborCostReport: "/web/EmpPayReport/queryEmpPayRollByPage.jhtml",
        //工资报表导出
        salaryRptExport: "/web/EmpPayReport/downLoadEmpPayReportExcel.jhtml",
        //部门汇总报表导出
        deptSumRptExport: "/web/EmpPayReport/exportDeptStatisticsInfo.jhtml",
        //人工成本报表导出
        laborCostRptExport: "/web/EmpPayReport/exportEmpPayRoll.jhtml",
        //工资条列表
        sarayBarList: "/web/role/getPage.jhtml",
        //历史工资条列表
        sarayBarHistory: "/web/role/getPage.jhtml",
        //确认发送工资条
        sarayBarSend: "/web/payrollSalaSettings/sendPaySlip.jhtml",
        //薪酬调整查询
        sarayGetAdjust: "/web/payrollSalaSettingsItem/openUpdatePayrollSalaSettingsItem.jhtml",
        //薪酬调整接口
        sarayModifyAdjust: "/web/payrollSalaSettingsItem/updatePayrollSalaSettingsItem.jhtml",
        //新增人员打开接口
        openStaffAdd: "/web/payrollSalaSettingsItem/openAddPayrollSalaSettingsItem.jhtml",
        //新增人员保存接口
        staffAdd: "/web/payrollSalaSettingsItem/addPayrollSalaSettingsItem.jhtml",
        //新版新增人员保存接口
        NewStaffAdd: "/web/payrollSalaSettingsItem/add.jhtml",
        //薪酬计算、归档查看详情接口
        salaryDetail: "/web/payrollSalaSettingsItem/PayrollSalaSettingsItemDetail.jhtml",
        //薪酬计算，判断是否允许下一步
        salaryCheckState: "/web/payrollSalaSettings/getPayrollSalaSettingsDetail.jhtml",
        //本期报盘文件列表
        curOfferDocList: "/web/payrollSetSalaSchema/queryPayrollSalaSettingsAndSchema.jhtml",
        //本期报盘文件一键生成
        curOfferDocCreate: "/web/payrollOffer/doOneTouch.jhtml",
        //生成报盘文件列表
        curCreateOfferDocList: "/web/payrollOffer/queryPayrollOffer.jhtml",
        //本期报盘文件明细
        curOfferDocDetails: "/web/payrollOfferDetail/queryPayrollOfferDetailByPage.jhtml",
        //本期报盘下载全部
        curExportPayrollOfferZipExcel: "/web/payrollOfferDetail/exportPayrollOfferZipExcel.jhtml",
        //本期报盘下载单个
        curExportPayrollOfferExcel: "/web/payrollOfferDetail/exportPayrollOfferExcel.jhtml",
        //本期个税报表薪酬列表
        curTaxDocList: "/web/payrollSetSalaSchema/queryPayrollSalaSettingsAndSchema.jhtml",
        //本期个税一键生成
        curTaxDocCreate: "/web/payrollTax/doOneTouch.jhtml",
        //生成本期个税文件列表
        curCreateTaxDocList: "/web/payrollTax/queryPayrollTaxByMonthStep.jhtml",
        //本期个税明细
        curTaxDocDetails: "/web/payrollTax/queryPayrollTaxByPage.jhtml",
        //本期个税导出
        curexportPayrollTaxZipExcel: "/web/payrollTax/exportPayrollTaxZipExcel.jhtml",
        //薪酬管理导入模板
        salaryTemplate: "/web/payrollSalaSettingsItem/downTemplate.jhtml",
        //薪酬管理导入接口
        salaryImport: "/web/payrollSalaSettingsItem/uploadExcel.jhtml",
        //薪酬管理导出接口
        salaryExport: "/web/payrollSalaSettingsItem/downExcel.jhtml",
        //获取薪酬名称下拉列表
        getSelectList: "/web/payrollSalaSettings/getSelectList.jhtml",
        //薪酬核算数据列表
        dataList: '/web/payrollSalaSettingsItem/getPage.jhtml',
        //薪酬核算数据列表搜索
        dataListSearch: '/web/payrollSalaSettingsItem/getSearch.jhtml',
        //薪酬核算数据导出
        dataListdaochu: "/web/payrollSalaSettingsItem/excelDown.jhtml",
        //薪酬核算数据导出
        nulldataListdaochu: "/web/payrollSalaSettingsItem/nulldataListdaochu/excelDown.jhtml",
        //开始计算
        StartCalculationApi: '/web/payrollSalaSettings/updateStateCalculate.jhtml',
        //归档
        guidang: '/web/payrollSalaSettings/updateStateArch.jhtml',
        guidangDown: '/web/payrollSalaSettings/excelDown.jhtml', //已归档历史到处
        guidangDown1: '/web/payrollSalaSettings/1/excelDown.jhtml', //已归档历史到处
        //算薪基础数据模板下载
        dataExceDown: '/web/payrollSalaSettingsItem/excelDown.jhtml',
        //算薪基础数据导入
        dataExceUpload: '/web/payrollSalaSettingsItem/excelUpload.jhtml',
        allowanceList: '/web/setSubsidyNew/findPaySetSubsideyByPage.jhtml', //津贴方案列表
        allowanceDoc: '/web/setSubsidyNew/saveTemp.jhtml', //津贴方案字典表
        allowanceAdd: '/web/setSubsidyNew/savePayrollSetSubsidyNew.jhtml', //添加津贴方案
        allowanceEdit: '/web/setSubsidyNew/updateTemp.jhtml', //修改获取数据
        allowanceDel: '/web/setSubsidyNew/deletePaySetSubsidey.jhtml', //删除津贴方案
        allowanceUpda: '/web/setSubsidyNew/PayrollSetSubsidyNew.jhtml', //修改津贴方案
        getOnePageListAPI: "/web/payslip/queryEmpPayslipDetail.jhtml", //智能薪酬工资单列表
        getIndexGuideData: "/web/intelligencePayrollAnalysis/getIndexGuideData.jhtml", //首页引导页获取数据
    },
    socialApi: {
        //基本信息(社保增员)
        basicCreate: "/web/soin/addTemplateByBase.jhtml",
        //社保信息下一步保存
        socialCreate: "/web/soin/saveBaseSoinEmpInfo.jhtml",
        //公积金信息
        fundCreate: "",
        //完成
        completeCreate: "",
        //社保管理
        socialList: "/web/soin/empSionPage.jhtml",
        //历史申报表
        sociaHistory: "/web/soin/hisEmpSionPage.jhtml",
        //社保管理撤销
        sociaCancle: "/web/soin/cancelTemplateByFund.jhtml",
        //根据省份编号得到市区
        getCity: "/web/soin/getCity.jhtml",
        //得到户口性质
        getEmpType: "/web/soin/getEmpType.jhtml",
        //根据ID获取减员员工详细信息
        getJyInfo: "/web/soin/getDeleteSoinEmp.jhtml",
        //获取社保公积金截至日接口
        getByEndDate: "/web/soin/endDate.jhtml",
        //保存减员接口
        saveLessEmp: "/web/soin/deleteSoinEmp.jhtml",
        //社保信息接口
        addTemplateBySoin: "/web/soin/addTemplateBySoin.jhtml",
        //根据市区得到截止日
        addDateByendDate: "/web/soin/addDateByendDate.jhtml",
        //社保缴纳明细
        getEmpSoinDetail: "/web/soin/getEmpSoinDetail.jhtml",
        //公积金信息接口
        addTemplateByFund: "/web/soin/addTemplateByFund.jhtml",
        //公积金缴纳明细
        getEmpFundDetail: "/web/soin/getEmpFundDetail.jhtml",
        //社保增员保存接口
        saveSoinEmp: "/web/soin/saveSoinEmp.jhtml",
        //获取当前汇缴月
        getRemitStartMon: "/web/soin/getRemitStartMon.jhtml",
        //社保费用明细列表
        getSoinDetailsItems: "/web/soin/getSsFeeMonth.jhtml",
        //得到基数范围
        getBaseLimite: "/web/soin/getBaseLimite.jhtml",
        //社保下一步保存
        socialNext: "/web/soin/saveSs.jhtml",
        //获取公积金比例
        getFundProduct: "/web/soin/getFundProduct.jhtml",
        //获取公积金明细
        getFundDetailsItems: "/web/soin/getPfFeeMonth.jhtml",
        //公积金下一步保存
        fundNext: "/web/soin/savePf.jhtml",
        //获取修改基本信息
        getEditInfo: "/web/soin/updateSoinEmpInfo.jhtml",
        //社保基本信息修改（增员）
        socialModify: "/web/soin/updateBaseSoinEmpInfo.jhtml",
        //获取社保设置列表
        loadSoinCustListPage: "/web/soinCust/loadSoinCustListPage.jhtml",
        getServiceType: "/web/soinCust/getServiceType.jhtml",
        //保存社保方案
        saveSoinCustInfo: "/web/soinCust/saveSoinCustInfo.jhtml",
        //删除社保方案
        delSoinCustInfo: "/web/soinCust/delSoinCustInfo.jhtml",
        //社保是否自动翻月开关
        saveOrUpdateSetOperation: "/web/setoperation/saveOrUpdateSetOperation.jhtml",
        getSoinPlanList: "/web/soinCust/getSoinPlanList.jhtml",
        getCitysForAddTemplate: "/web/soin/getCitysForAddTemplate.jhtml",
        downLoadSoinEmpAddTemplate: "/web/soin/downLoadSoinEmpAddTemplate.jhtml",
        downLoadSoinEmpReduceTemplate: "/web/soin/downLoadSoinEmpReduceTemplate.jhtml",
        exportEmpSionExcel: "/web/soin/exportEmpSionExcel.jhtml",
        importBatchSoinEmpAddExcel: "/web/soin/importBatchSoinEmpAddExcel.jhtml",
        importSoinEmpReduceExcel: "/web/soin/importSoinEmpReduceExcel.jhtml",
        createDeailHandTurnMonth: "/web/soinReceivable/createDeailHandTurnMonth.jhtml",
        exportReceivableReportExcel: "/web/soinReceivable/exportReceivableReportExcel.jhtml",
        soinBillPage: "/web/SoinBillNewController/soinBillPage.jhtml",
        exportSoinBillDetail: "/web/SoinBillNewController/exportSoinBillDetail.jhtml",
        addBillDetail: "/web/SoinBillNewController/addBillDetail.jhtml",
        findSetOperationInfo: "/web/setoperation/findSetOperationInfo.jhtml",
        loadSoinReceivableListPage: "/web/soinReceivable/loadSoinReceivableListPage.jhtml",

    },
    //权限管理API
    privilegeApi: {
        //显示超级管理员
        getSuperAdmin: "/web/privilege/getSuperAdmin.jhtml",
        //显示高级管理员
        getSeniorAdmin: "/web/privilege/getSeniorAdminByPage.jhtml",
        //显示模块管理员
        getModularAdmin: "/web/privilege/getModularAdminByPage.jhtml",
        //显示自定义管理员
        getCustomeAdmin: "/web/privilege/getCustomeAdminByPage.jhtml",
        //数据带到添加高级管理员页面
        forSaveSeniorAdmin: "/web/privilege/forSaveSeniorAdmin.jhtml",
        //数据带到添加模块管理员页面
        forSaveModularAdmin: "/web/privilege/forSaveModularAdmin.jhtml",
        //数据带到添加自定义管理员页面
        forSaveCustomAdmin: "/web/privilege/forSaveCustomAdmin.jhtml",
        //数据带到编辑模块管理员页面
        forEditModularAdmin: "/web/privilege/forEditModularAdmin.jhtml",
        //数据带到编辑自定义管理员页面
        forEditCustomAdmin: "/web/privilege/forEditCustomAdmin.jhtml",
        //添加高级管理员
        saveSeniorAdmin: "/web/privilege/saveSeniorAdmin.jhtml",
        //添加模块管理员
        saveModularAdmin: "/web/privilege/saveModularAdmin.jhtml",
        //添加自定义管理员
        saveCustomAdmin: "/web/privilege/saveCustomAdmin.jhtml",
        //删除高级管理员
        delSeniorAdmin: "/web/privilege/delSeniorAdmin.jhtml",
        //删除模块管理员
        delModularAdmin: "/web/privilege/delModularAdmin.jhtml",
        //删除自定义管理员
        delCustomAdmin: "/web/privilege/delCustomAdmin.jhtml",
        //更新模块管理员
        updateModularAdmin: "/web/privilege/updateModularAdmin.jhtml",
        //更新自定义管理员
        updateCustomAdmin: "/web/privilege/updateCustomAdmin.jhtml",
        //部门权限设置保存接口
        saveDeptPrivilege: "/web/privilege/saveDeptPrivilege.jhtml",
        //部门权限设置打开获取信息接口
        getPrivilegeDeptsByCustIdToPlugIn: "/web/privilege/getPrivilegeDeptsByCustIdToPlugIn.jhtml"

    },
    privilegeNewApi: {
        getUserList: "/web/privilegeNew/userList.jhtml", //获取用户列表
        addUser: "/web/privilegeNew/saveUser.jhtml", //保存用户
        updateUser: "/web/privilegeNew/updateUserRole.jhtml", //更新用户
        deleteUser: "/web/privilegeNew/delUser.jhtml", //删除用户
        forAddUser: "/web/privilegeNew/go4SaveUser.jhtml", //数据带到新增用户页面
        forUpdateUser: "/web/privilegeNew/go4EditUser.jhtml", //数据带到更新用户页面
        saveRole: "/web/privilegeNew/saveRole.jhtml", //保存角色
        getRoleList: "/web/privilegeNew/rolesList.jhtml", //获取角色列表
        for_save_rightsetting: "/web/privilegeNew/forsaveRolePrivilege.jhtml", //数据带包权限设置页面
        save_rightsetting: "/web/privilegeNew/saveRolePrivilege.jhtml", //保存权限设置
        getRole: "/web/privilegeNew/getRole.jhtml", //获取角色信息
        updateRole: "/web/privilegeNew/updataRole.jhtml", //更新角色
        deleteRole: "/web/privilegeNew/delRole.jhtml", //删除角色
        userSer: '/web/privilegeNew/getEmpsBySearch.jhtml', //用户搜索
        userSeremp: '/web/privilegeNew/userSeremp/getEmpsBySearch.jhtml', //用户搜索
    },
    noticeApi: {
        //公告列表
        list: "/web/noticeinfo/getNoticeInfoListPage.jhtml",
        //保存公告
        save: "/web/noticeinfo/saveNoticeInfo.jhtml",
        //删除公告
        del: "/web/noticeinfo/deleteNoticeInfo.jhtml",
        //发布范围
        getAllDeptByCustId: "/web/deptInfo/getAllDeptByCustId.jhtml",
        //公告附件上传
        noticeUpload: "/web/UpLoadFile/upload.jhtml",
        //获取公告
        getNoticeInfo: "/web/noticeinfo/getNoticeInfo.jhtml",
        //修改保存
        updateNoticeInfo: "/web/noticeinfo/updateNoticeInfo.jhtml",
        //列表查询字段
        searchTemp: "/web/noticeinfo/searchTemp.jhtml",
    },
    messageApi: {
        //消息列表
        list: "/web/syswarning/querySysWarningPages.jhtml",
        // 设置为已读
        readApi: '/web/syswarning/deleteSysMessageUnread.jhtml',
        // 删除
        delApi: '/web/syswarning/deleteSysWarning.jhtml',
        //获取详情
        getDetailsApi: "/web/noticeinfo/getNoticeInfo.jhtml"
    },
    personalNoticeApi: {
        //公告列表
        list: "/web/noticeinfo/getNoticeInfoListPage.empweb",
        //获取公告
        getNoticeInfo: "/web/noticeinfo/getNoticeInfo.empweb",
        //列表查询字段
        searchTemp: "/web/noticeinfo/searchTemp.empweb",
        //获取详情
        getDetailsApi: "/web/noticeinfo/getNoticeInfo.empweb",
        dimsionList: '/web/setDataDimension/getDimensions.empweb', //获取组织结构维度列表

    },
    personalMessageApi: {
        //消息列表
        list: "/web/syswarning/querySysWarningPages.empweb",
        // 设置为已读
        readApi: '/web/syswarning/deleteSysMessageUnread.empweb',
        // 删除
        delApi: '/web/syswarning/deleteSysWarning.empweb',
        //获取详情
        getDetailsApi: "/web/noticeinfo/getNoticeInfo.empweb",
        //获取 员工端  消息详情
        getEmpMessageInfo: '/web/syswarning/querySysWarningItemByPage.empweb',
        //批量打卡权限到期提醒获取消息详情
        getMsgDetail: "/web/attLocationApply/findLocationCloseNoticeById.empweb",
        //批量加班 单独的列表
        getWorkOverSupplementInfo: "/web/zr/batchWorkOver/getWorkOverSupplementInfo.empweb",
        checkHavePass: "/payslip/wxLookHtml/checkHavePass.empweb",//检查是否设置过密码
        checkPassRight: "/payslip/wxLookHtml/checkPassRight.empweb",//检查密码是否正确
    },
    workbenchApi: {
        //员工统计接口
        getEmpStatic: "/web/empBaseInfo/empBaseInfoStatis.jhtml",
        //考勤统计接口
        getAttStatic: "/web/attStMonth/getAttStMonth.jhtml",
        //每日消息提醒
        getRemindList: "/web/sysTransactionNoticeLog/querySysTransactionNoticeLogByPage.jhtml", //"/web/empPost/getRemindListPage.jhtml",
        //实发工资统计
        getSalaryStatic: "/web/payrollSalaSettingsItem/deptSalary.jhtml",
        //获取按月提醒
        getStatisByYearMonth: "/web/sysTransactionNoticeLog/getSysTransactionNoticeLog.jhtml", //"/web/empPost/getStatisByYearMonth.jhtml",
        //获取审批超时提醒列表
        getOverTimeRemindList: "/web/attExamStep/getExamOverTimeWarningList.jhtml",
        //审批超时提醒
        examTimeOutWarn: "/web/attExamStep/examTimeOutWarn.jhtml",
        //获取设置提醒接口
        getRemindInfos: "/web/remind/getRemindInfos.jhtml",
        //保存自定义提醒
        saveRemindInfos: "/web/remind/saveRemindInfos.jhtml",
        //获取薪酬统计报表接口
        getSalaryYmStatic: "/web/payrollSalaSettingsItem/ymSalary.jhtml",
        //薪酬计算规则校验
        check: "/web/payrollSetSalaSchemaItem/checkFormula.jhtml",
        //获取社保统计接口
        getSoinStatisByYM: "/web/soin/getStatisByYearMonth.jhtml",
        /** 提醒API 开始 **/
        //获取系统默认提醒
        getSysTransactionNotice: "/web/sysTransactionNotice/getSysTransactionNotice.jhtml",
        //保存系统默认提醒
        saveSysTransactionNotice: "/web/sysTransactionNotice/saveSysTransactionNotice.jhtml",
        //删除系统默认提醒
        deleteSysCustomTransactionNotice: "/web/sysTransactionNotice/deleteSysCustomTransactionNotice.jhtml",
        //获取提醒设置列表：新版
        getList: "/web/sysTransactionNoticeNew/getSysTransactionNoticeNewList.jhtml",
        //按类型获取提醒数据
        getRuleList: "/web/sysTransactionNoticeNew/getSysTransactionNoticeNewItemList.jhtml",
        //获取提醒详情
        getTemp: "/web/sysTransactionNoticeNew/getTemp.jhtml",
        //保存提醒数据
        saveSysTransactionNoticeNewItem: "/web/sysTransactionNoticeNew/saveSysTransactionNoticeNewItem.jhtml",
        //新版:人事概况
        getEmpStatisticsByCust: "/web/workbench/getEmpStatisticsByCust.jhtml",
        //新版：人事提醒
        getEmpRemindByCust: "/web/workbench/getEmpRemindByCust.jhtml",
        //新版:出勤概况
        getAttEmpDetailStatisticsByCust: "/web/workbench/getAttEmpDetailStatisticsByCust.jhtml",
        //新版：假期到期提醒
        getHolidayDueCounts: "/web/workbench/getHolidayDueCounts.jhtml",
        //新版：更新提醒规则状态
        updateIsEnable: "/web/sysTransactionNoticeNew/updateIsEnable.jhtml",
        //新版：删除提醒项目
        deleteItem: "/web/sysTransactionNoticeNew/deleteItems.jhtml",
        //新版：异常提醒列表
        reminderList: "/web/workbench/reminderList.jhtml",
        //新版：获取未读消息数量
        getAllUnreadMessageCount: "/web/sysmessageunread/getAllUnreadMessageCount.jhtml"
    },
    //公司信息
    companyApi: {
        //得到公司信息
        get: "/web/custInfo/getCustInfoByUpDate.jhtml",
        //保存公司信息
        modify: "/web/custInfo/updateCustInfo.jhtml",
        WxEdition: "/qywx/other/getSmallWxEdition.jhtml",
        WxEditionNew: "/qywx/other/new/getSmallWxEdition.jhtml",
        doCancelFollow: "/web/qywxCustInfo/doCancelFollow.jhtml",
        isQywxUser: "/qywx/other/isQywxUser.jhtml",
    },
    //报表管理
    reportApi: {
        //报表列表
        list: "/web/payrollReport/queryPayrollReportPage.jhtml",
        //固定字典项
        dics: "/web/payrollReport/OpenAddPayrollReport.jhtml",
        //获得字段系统名(筛选条件)
        getsyscon: "/web/payrollReport/getFieldSysNameList.jhtml",
        //获得字段值（筛选条件）
        getfvaluecon: "/web/payrollReport/getValueList.jhtml",
        //字段系统名称(增加字段)
        getsysfiled: "/web/payrollReport/getCalFieldSysNameList.jhtml",
        //保存报表
        save: "/web/payrollReport/addPayrollReport.jhtml",
        //修改报表
        edit: "/web/payrollReport/updatePayrollReport.jhtml",
        //报表实体
        get: "/web/payrollReport/OpenUpdatePayrollReport.jhtml",
        //分页查询列表
        seach: "/web/payrollReportItem/queryPayrollReportItemPage.jhtml",
        //批量导出
        exports: "/web/payrollReportItem/exportPayrollReportByPage.jhtml",
        //删除报表
        remove: "/web/payrollReport/deletePayrollReport.jhtml"
    },
    //  是否审批
    isShenpi: {
        // 		获得审批列表
        getShenpilist: "/web/deptInfo/getDeptAndEmpList.jhtml",
        getShenpilistEmpweb: "/web/deptInfo/getDeptAndEmpList.empweb"

        //		getShenpilist:"/web/deptInfo/getExamDeptAndEmpList.jhtml"
    },
    //审批设置
    approveApi: {
        //审批列表
        list: "/web/flowControl/getFlowControlList.jhtml",
        flowList: "/web/flowSet/getFlowSetListForGraph.jhtml",
        //添加审批流
        addFlow: "/web/flowSet/addOrUpdateFlowSetForGraph.jhtml",
        //设置状态
        setState: "/web/flowControl/updateFlowControl.jhtml",
        //搜索条件
        seachCon: "/web/flowSet/getFlowSetList.jhtml",
        //保存流程
        save: "/web/flowSet/addFlowSet.jhtml",
        //类型字典
        getType: "/web/flowSetStep/getStepType.jhtml",
        //根据部门获取职位
        getPost: "/web/flowSetStep/getPositionByDeptInfo.jhtml",
        //获取字段名称
        getFiledName: "/web/flowControl/getFlowSelectOfTableAndCols.jhtml",
        //获取明细
        getDetails: "/web/flowSet/getFlowSetAndStepDetails.jhtml",
        //补充信息
        getSupUrls: "/web/menu/getMenusByMenuState.jhtml",
        //批量审批
        getBathAttExamStepPage: "/web/attExamStep/getBathAttExamStepPage.jhtml",
        //更新审批查看状态
        updateCsExamerCheck: "/web/attExamStep/updateCsExamerCheck.jhtml",
        //删除流程
        deleteFlow: "/web/flowSet/deleteFlowSetAndDetails.jhtml",
        //复制流程
        copyFlowSet: "/web/flowSet/copyFlowSet.jhtml",
        approverlist: "/web/attExamerExchangeLog/getAttExamerExchangeLogPage.jhtml", //审批人交接列表
        approverset: '/web/attExamerExchangeLog/getAllEmpByDeptId.jhtml', //根据部门获取已有的审批人
        approverrsave: '/web/attExamerExchangeLog/replaceExamMan.jhtml', //审批人交接保存
        approverquan: '/web/flowSetStep/getPositionByDeptInfo.jhtml', //根据部门获取有权限的审批人
        getAbstractRoleForFlow: "/web/custAbstractRole/getAbstractRoleForFlow.jhtml", //获取业务角色
        addOrUpdateFlowSetStepDetail: "/web/flowSetStepDetail/addOrUpdateFlowSetStepDetail.jhtml", //添加修改节点上的审批人
        getReportRelation: "/web/flowSet/getReportRelation.jhtml", //获取汇报关系
        saveOrUpdateStepsAndLogics: "/web/flowSetStepLogic/saveOrUpdateStepsAndLogics.jhtml", //节点和线关系整体大保存
        getFlowSetStepLogic: "/web/flowSetStepLogic/getFlowSetStepLogic.jhtml", //根据条件id或者开始结束节点id获取条件
        addOrUpdateFlowSetStepLogic: "/web/flowSetStepLogic/addOrUpdateFlowSetStepLogic.jhtml", //新增修改条件
        deleteFlowSetStepLogic: "/web/flowSetStepLogic/deleteFlowSetStepLogic.jhtml", //删除条件
        getFlowSetStepDetail: "/web/flowSetStepDetail/getFlowSetStepDetail.jhtml", //获取审批人详情
        addOrUpdateFlowSetStep: "/web/flowSetStep/addOrUpdateFlowSetStep.jhtml", //保存单个节点
        validateData: "/web/flowSetStepLogicDetail/validateData.jhtml",
        getFormActionRights: "/web/emp/formActionRight/getFormActionRights.jhtml", //获取表单操作权限列表
        getFormActionRightType: "/web/emp/formActionRight/getFormActionRightType.jhtml", //获取权限类型
        saveFormActionRight: "/web/emp/formActionRight/saveFormActionRight.jhtml", //保存表单操作权限
        deleteFormActionRight: "/web/emp/formActionRight/deleteFormActionRight.jhtml", //删除表单操作权限
        getFormActionRightDetails: "/web/emp/formActionRight/getFormActionRightDetails.jhtml", //获取表单操作权限数据
        updateFormActionRightDetails: "/web/emp/formActionRight/updateFormActionRightDetails.jhtml", //修改表单操作权限
        getCustomList: "/web/flowSetStepTypeCustom/getList.jhtml",
    },
    //自定义审批
    customApi: {
        //新增
        add: "/web/flowCustApplySetting/saveFlowCustApplySetting.jhtml",

        //修改
        modify: "/web/flowCustApplySetting/updateFlowCustApplySetting.jhtml",
        //获取实体
        get: "/web/flowCustApplySetting/getFlowCustApplySettingDetails.jhtml",
        //删除
        del: "/web/flowCustApplySetting/deleteFlowCustApplySetting.jhtml"
    },
    //审批列表管理
    examstepApi: {
        //获取审批详情
        get: "/web/attExamStep/getAttExamStepDetail.jhtml",
        getSeal: "/web/attExamStep/seal/getAttExamStepDetail.jhtml", //--csy 
        getApply: "/web/attExamStep/apply/getAttExamStepDetail.jhtml", //--csy
        //审批保存
        save: "/web/attExamStep/examStep.jhtml",
        //审批管理
        list: "/web/attExamStep/getAttExamStepPage.jhtml",
        //审批历史
        history: "/web/attExamStep/getAttExamStepHistoryPage.jhtml",
        //我的审批管理
        person: "/web/attExamStep/examStep4Mobile.jhtml",
        //获取离职日期
        getLeaveDate: "/web/empPost/getLizhiDate.jhtml",
        //保存离职日期
        updateEpuLizhiDate: "/web/empPost/updateEpuLizhiDate.jhtml",
        //自定义审批，导出word
        exportWord: "/web/flowHandleWord/exportWrod.jhtml",
        //查看规则
        getHolInfo: "/web/attHolApply/getHolInfo.jhtml",
        //获取自定义表单数据
        queryCustomOfSetShowCols: "/web/customTable/queryCustomOfSetShowCols.jhtml",
        //保存自定义表单
        addCustomTableEmp: "/web/customTableEmp/addCustomTableEmp.jhtml",
        //获取调岗日期
        getEnableDate: "/web/empPost/getEnableDate.jhtml",
        //保存调岗日期
        updateEpuEnableDate: "/web/empPost/updateEpuEnableDate.jhtml",
        //加班审批补充信息------修改小时数  这个因为要兼容员工端 所以不加后缀   在具体页面里会加后缀
        getdateHours: '/web/attOverApply/getPermitOverHours', //获取
        updateHours: '/web/attOverApply/updatePermitOverHours', //修改
        checkExamManSelfSelectLogic: "/web/attExamStep/checkExamManSelfSelectLogic.jhtml", //审批节点解析逻辑返回
        getRollbackStep: "/web/attExamStep/getRollbackStep.jhtml", //获取回退审批人字典
        examStepRollback: "/web/attExamStep/examStepRollback.jhtml" //回退操作
    },
    jiediaoApi: {
        jiediaoemp: '/web/empBaseInfo/getEmpBaseInfoByDeptIds.jhtml', //根据部门获取员工列表
        findEmpBaseInfoByDeptOrParams: '/web/empBaseInfo/getEmpBaseInfoByDeptIdsOrPamar.jhtml', //根据部门获取员工
        getEmpBaseInfoBybaseId: '/web/empBaseInfo/getEmpBaseInfoBybaseId.jhtml' //根据员工获取亲友 
    },
    overworkApi: {
        overworkList: '/web/attSetOvertimeNew/queryAttSetOvertimeByPage.jhtml', //加班列表页
        addoverwork: '/web/attSetOvertimeNew/openAddAttSetOvertime.jhtml', //新增加班
        addoverworksave: '/web/attSetOvertimeNew/saveAttSetOvertime.jhtml', //新增保存
        updateoverwork: '/web/attSetOvertimeNew/openUpdateAttSetOvertime.jhtml', //修改列表
        updateoverworksave: '/web/attSetOvertimeNew/updateAttSetOvertime.jhtml', //修改保存
        deloverwork: '/web/attSetOvertimeNew/deleteAttSetOvertime.jhtml', //加班删除
        statusoverwork: '/web/attSetOvertimeNew/updateAttSetOvertimeState.jhtml', //修改状态
        getSearchTemplate: "/web/attSetOvertimeNew/getSearchTemplate.jhtml",
        BatchOvertimeList: '/web/zr/batchWorkOver/getManageList.jhtml', //批量加班列表
        BatchOvertimeListSearch: '/web/zr/batchWorkOver/getManageListSer.jhtml', //批量加班列表搜索
        BatchOvertimeListDown: '/web/zr/batchWorkOver/downExcel.jhtml', //批量加班导出
        withdraw: "/web/attExamStep/revokeApply.jhtml", //撤回
        del: "/web/batchWorkOver/deleteBatchWorkOvertime.jhtml", //删除一条加班申请
        BatchOvertimeAddDictionary: '/web/batchWorkOver/getDictionary.jhtml', //批量加班字典查询
        isPermission: '/web/batchWorkOver/getBelongingOperator.jhtml', //是否有权限查看这条批量加班的信息
        BatchOvertimeGetDetail: '/web/batchWorkOver/getDetail.jhtml', //查询批量加班详情
        BatchOvertimeGetEmpByProjectId: '/web/zr/batchWorkOver/getEmpByProjectId.jhtml', //查询批量加班人员信息
        BatchOvertimeEmpUpOrDel: '/web/batchWorkOver/updateOrDeleteApply.jhtml', //退回或删除
        getOvertimeHours: "/web/batchWorkOver/getOvertimeHours.jhtml", //获取加班小时数
        BatchOvertimeSavaData: '/web/batchWorkOver/save.jhtml', //保存批量加班申请（下发）
        saveBatchByExamApproval: '/web/zr/batchWorkOver/saveBatchByExamApproval.jhtml', //保存批量加班审批（发起审批）
        getProjectByDeptApi: '/web/zr/batchWorkOver/getProjectByDept.jhtml', //根据部门获取项目信息
        getExamType: '/web/flowControl/getExamType.jhtml', //获取是否需要审批
        getDeptTree: '/web/deptInfo/getSimpleTree.jhtml', //获取部门树  
        seachEmpList: "/web/deptInfo/getSearchEmpByConditions.jhtml", //中软批量加班搜索员工  参数{empName:""}
        getOverAndRestInitInfo: '/web/icss/attOverApplyWithRest/getOverAndRestInitInfo.empweb',
        saveOverApplyAndRestApply: '/web/icss/attOverApplyWithRest/saveOverApplyAndRestApply.empweb',
        saveAttOverApplyWithRest: 'web/icss/attOverApplyWithRest/saveAttOverApplyWithRest.empweb',
    },
    personalOverworkApi: { //员工端批量加班
        BatchOvertimeList: '/web/zr/batchWorkOver/getManageList.empweb', //批量加班列表
        BatchOvertimeListDown: '/web/zr/batchWorkOver/downExcel.empweb', //批量加班导出
        BatchOvertimeListSearch: '/web/zr/batchWorkOver/getManageListSer.empweb', //批量加班列表搜索
        getIsItHuawei: '/web/zr/batchWorkOver/getIsItHuawei.empweb', //判断是否是华为
        getDate: "/web/sysSet/getSysDate.empweb",
        BatchOvertimeAddDictionary: '/web/batchWorkOver/getDictionary.empweb', //批量加班字典查询
        BatchOvertimeGetDetail: '/web/batchWorkOver/getDetail.empweb', //查询批量加班详情
        BatchOvertimeSavaData: '/web/batchWorkOver/save.empweb', //保存批量加班申请（下发）
        getExamType: '/web/flowControl/getExamType.empweb', //获取是否需要审批
        saveBatchByExamApproval: '/web/zr/batchWorkOver/saveBatchByExamApproval.empweb', //保存批量加班审批（发起审批）
        BatchOvertimeEmpUpOrDel: '/web/batchWorkOver/updateOrDeleteApply.empweb', //退回或删除
        getOvertimeHours: "/web/batchWorkOver/getOvertimeHours.empweb", //获取加班小时数
        getProjectByDeptApi: '/web/zr/batchWorkOver/getProjectByDept.empweb', //根据部门获取项目信息
        getDeptTree: '/web/deptInfo/getSimpleTree.empweb', //获取部门树  
        withdraw: "/web/attExamStep/revokeApply.empweb", //撤回
        del: "/web/batchWorkOver/deleteBatchWorkOvertime.empweb", //删除一条加班申请
        getDangDeptTree: '/web/zr/batchWorkOver/getChildDept.empweb', //查询当前部门及子部门
        FHWgetEmpByDeptId: "/web/zr/batchWorkOver/getEmpByDeptId.empweb", //根据部门获取人员信息(非华为)  deptId参数
        BatchOvertimeGetEmpByProjectId: '/web/zr/batchWorkOver/getEmpByProjectId.empweb', //查询批量加班人员信息
        getEmpInfo: "/web/empPost/getEmpPostInfo.empweb", // 查询员工岗位
        seachEmpList: "/web/deptInfo/getSearchEmpByConditions.empweb", //中软批量加班搜索员工  参数{empName:""}
    },
    paibanmodelApi: {
        paibanlist: '/web/attSetArrangeTemplate/queryAttSetArrangeTemplatePage.jhtml', //排班列表
        getbancilist: '/web/attSetSchemaNew/getAttSetSchemaNewByDeptId.jhtml', //根据部门获取 班次信息
        addpaibansave: '/web/attSetArrangeTemplate/addAttSetArrangeTemplate.jhtml', //增加排班保存
        paibaneditlist: '/web/attSetArrangeTemplate/queryAttSetArrangeTemplateById.jhtml', //排班修改列表
        paibaneditsave: '/web/attSetArrangeTemplate/updateAttSetArrangeTemplate.jhtml', //排班修改保存
        paibandel: '/web/attSetArrangeTemplate/deleteAttSetArrangeTemplateByTemplateId.jhtml', //排班删除
        panbanmingxi: '/web/attSetArrangeTemplate/getSchedulingByPage.jhtml', //排班明细列表
        paibandaoc: '/web/attSetArrangeTemplate/exportScheduling.jhtml', //排班明细导出
        savepaiban: '/web/attSetArrangeTemplate/getScheduling.jhtml', //排班保存
        paibanSer: '/web/attSetArrangeTemplate/searchAttSetArrangeTemplateTemp.jhtml',
        detaildownLoadApi: '/web/attArrangeSchedual/exportAttArrangeSchedualTemp.jhtml',
        detailImportApi: '/web/attArrangeSchedual/importScheduals.jhtml',
        paibanmag: '/web/attArrangeSchedual/addAttArrangeSchedual.jhtml', //排班管理

    },
    ziduangzApi: {
        ziduanlist: '/web/empCodeSettingPrim/queryEmpCodeSettingPrimOfPage.jhtml', //列表页
        zidugzsave: '/web/empCodeSettingPrim/addEmpCodeSettingPrim.jhtml', //字段规则设置和修改保存
        ziduangzstate: '/web/empCodeSettingPrim/updateEmpCodeSettingPrim.jhtml', //修改状态
        ziduangzdel: '/web/empCodeSettingPrim/deleteEmpCodeSettingPrim.jhtml', //删除
        ziduangzupdata: '/web/empCodeSetting/queryEmpCodeSetting.jhtml' //修改获取数据
    },
    contracts: {
        getExamType: '/web/flowControl/getExamType.jhtml', //获取是否需要审批
        getExamType1: '/web/flowControl/single/getExamType.jhtml', //单人签订获取是否需要审批
        contractsetlist: '/web/contractSetting/queryContractSettingPage.jhtml', //合同设置列表
        gethetongtype: '/web/contractSetting/getContractType.jhtml', //获取合同类型字典集合
        contractsave: '/web/contractSetting/saveContractSetting.jhtml', //保存合同模板
        contractupdate: '/web/contractSetting/getContractSettingDetail.jhtml', //获取修改详情
        contractdel: '/web/contractSetting/deleteContractSetting.jhtml', //合同模板删除
        contractqiandlist: '/web/empPostContract/getNoContractEmpPage.jhtml', //合同签订列表
        contractxuqianlist: '/web/empPostContract/getNeedRenewAndTerminateContractPage.jhtml', //合同续签与终止
        contractchangelist: '/web/empPostContract/getAllowChangeAndReleaseContractPage.jhtml', //合同变革与解除
        contractupdatelist: '/web/empPostContract/getAllowUpdateContractPage.jhtml', //合同修改列表
        contractmingxilist: '/web/empPostContract/getContractPage.jhtml', //合同明细
        contractdetail: '/web/empPostContract/getContractDetail.jhtml', //合同获取数据
        contractgetname: '/web/contractSetting/getContractSettingList.jhtml', //合同模板类型查询合同模板集合
        qianding: '/web/empPostContract/addContract.jhtml', //签订保存
        xuqian: '/web/empPostContract/reNewContract.jhtml', //续签保存
        zhongz: '/web/empPostContract/terminateContract.jhtml', //终止保存
        biangeng: '/web/empPostContract/changeContract.jhtml', //变更保存
        jiec: '/web/empPostContract/releaseContract.jhtml', //解除保存
        xiugai: '/web/empPostContract/updateContract.jhtml', //修改保存
        savescon: '/web/empPostContractApply/saveContractApply.jhtml',
        savesconxq: '/web/empPostContractApply/xq/saveContractApply.jhtml', //合同续签保存
        savesconzz: '/web/empPostContractApply/zz/saveContractApply.jhtml', //合同终止保存
        savesconbg: '/web/empPostContractApply/bg/saveContractApply.jhtml', //合同变更保存
        savesconjc: '/web/empPostContractApply/jc/saveContractApply.jhtml', //解除变更保存
        //  	hetongapplyser:'/web/empPostContractApply/getContractApplySer.jhtml',//申请页面查询条件
        //  	hetongapplylist:'/web/empPostContractApply/queryContractApplyPage.jhtml',//申请分页
        qiandser: '/web/empPostContract/getEmpSer.jhtml', //签订页面的查询
        contractser: '/web/empPostContract/getContractSer.jhtml', //合同搜索
        qiandimport: '/web/empPostContract/uploadExcel.jhtml', //合同签订导入
        // /web/empPostContract/uploadHistory.jhtml
        qiandupload: '/web/empPostContract/downTemplate.jhtml', //合同模板下载
        qiandupload1: '/web/empPostContract/1/downTemplate.jhtml', //合同模板下载
        qiandupload2: '/web/empPostContract/2/downTemplate.jhtml', //合同模板下载
        hetongdaochu: '/web/empPostContract/downExcel.jhtml', //合同明细导出
        contractapply: '/web/empPostContractApply/queryContractApplyPage.jhtml', //合同申请列表
        contapplydetail: '/web/attExamStep/getAttExamStepDetailFromApply.jhtml', //合同申请详情
        sendShortMessageAgain: '/web/empPostContractApply/sendShortMessageAgain.jhtml',
        conapplyser: '/web/empPostContractApply/getContractApplySer.jhtml', //合同申请搜索
        xuqianser: '/web/empPostContract/getNeedRenewAndTerminateContractSer.jhtml', //合同续签与终止搜索
        shenqingimport: '/web/empPostContract/uploadExcelApply.jhtml', //合同签订申请导入
        farenlist: '/web/custLegal/queryCustLegalByPage.jhtml', //法人单位设置列表
        farensearch: "/web/custLegal/getCustLegalSer.jhtml", //法人单位设置列表搜索
        addfaren: '/web/custLegal/saveCustLegal.jhtml', //新增法人单位
        updatefaren: '/web/custLegal/updateCustLegal.jhtml', //修改新增法人保存
        farendetail: '/web/custLegal/getCustLegalDetail.jhtml', //法人单位详情
        farendetail1: '/web/custLegal/1/getCustLegalDetail.jhtml', //法人单位详情
        farendetail2: '/web/custLegal/2/getCustLegalDetail.jhtml', //法人单位详情
        farendel: '/web/custLegal/deleteCustLegal.jhtml', //法人单位设置删除
        sftype: '/web/custLegal/getSsqCertType.jhtml', //身份证类型
        scpdf: '/thirdParty/shangshangqian/createPdf.jhtml', //生成pdf
        saveBatchContractApply: "/web/empPostContractApply/saveBatchContractApply.jhtml", //批量签订
        getCompanySealPage: "/web/attExamStep/getCompanySealPage.jhtml", //获得企业盖章的分页
        getguanlian: "/web/setShowCols/getFieldValueByParentId_M.jhtml",
        getpdfFile: "/thirdParty/shangshangqian/outPutPdf2Web.jhtml", //
        DeleteRecord: "/web/empPostContract/deleteEmpContract.jhtml", //合同申请记录删除
        saveTemplateTypeSetting: "/web/customTemplateType/saveTemplateTypeSetting.jhtml", //保存自定义模板类型
        getCustomTemplateTypeSer: "/web/customTemplateType/getCustomTemplateTypeSer.jhtml", //获取自定义模板类型查询条件
        getTemplateTypeGroups: "/web/customTemplateType/getTemplateTypeGroups.jhtml", //获取分组
        getCustomTemplateTypeList: "/web/customTemplateType/getCustomTemplateTypeList.jhtml", //获取自定义模板类型列表
        getCustomTemplateTypeDetail: "/web/customTemplateType/getCustomTemplateTypeDetail.jhtml", //查询自定义模板类型的详情
        updateCustomTemplateType: "/web/customTemplateType/updateCustomTemplateType.jhtml", //编辑自定义模板类型
        delCustomTemplateType: "/web/customTemplateType/delCustomTemplateType.jhtml", //删除自定义模板类型
        saveOrUpdateConCustomTemplate: "/web/customTemplate/saveOrUpdateConCustomTemplate.jhtml", //保存或修改自定义模板
        getCustomTemplateDetail: "/web/customTemplate/getCustomTemplateDetail.jhtml", //查询自定义模板的详情
        deleteCustomTemplate: "/web/customTemplate/deleteCustomTemplate.jhtml", //删除自定义模板
        getCustomTemplateList: "/web/customTemplate/getCustomTemplateList.jhtml", //获取自定义模板列表
        getCustLegalSer: "/web/custRelLegal/getCustLegalSer.jhtml", //法人单位设置列表搜索
        queryCustLegalByPage: "/web/custRelLegal/queryCustLegalByPage.jhtml", //法人单位设置列表
        saveCustLegal: "/web/custRelLegal/saveCustLegal.jhtml", //法人单位设置保存
        updateCustLegal: "/web/custRelLegal/updateCustLegal.jhtml", //法人单位修改保存
        getCustLegalDetail: "/web/custRelLegal/getCustLegalDetail.jhtml", //查询法人单位详情
        deleteCustLegal: "/web/custRelLegal/deleteCustLegal.jhtml", //删除法人单位设置
        custLegalSsqAuthentication: "/web/custRelLegal/custLegalSsqAuthentication.jhtml", //电子合同认证
        custLegalTaxAuthentication: "/web/custRelLegal/custLegalTaxAuthentication.jhtml", //报税认证
        gettempalteForEmpTypes: "/web/customTemplate/gettempalteForEmpTypes.jhtml", //获取适用类型
        getCustomTemplateTypes: "/web/contractSetting/getCustomTemplateTypes.jhtml", //获取合同部分自定义模板类型
        getTempalteSettingList: "/web/contractSetting/getTempalteSettingList.jhtml", //获取模板名称
        getAttExamStepDetailFromApply: "/web/attExamStep/getAttExamStepDetailFromApply.jhtml", //查看
        revokeApply: "/web/attExamStep/1/revokeApply.jhtml", //撤销
        revokeApplyzuofei: "/web/attExamStep/zuofei/revokeApply.jhtml", //撤销
        revokeApplyqz: "/web/attExamStep/qz/revokeApply.jhtml", //撤销
        contractSurveyCount: "/web/empElectronicSealApply/contractSurveyCount.jhtml", //签订概况
        queryRencentElectronicsContractList: "/web/empElectronicSealApply/queryRencentElectronicsContractList.jhtml", //签订概况列表
        getEmpElectronicSealApplyList: "/web/empElectronicSealApply/getEmpElectronicSealApplyList.jhtml", //企业盖章列表
        queryElectronicSealApplyPage: "/web/empElectronicSealApply/queryElectronicSealApplyPage.jhtml", //签订记录列表分类
        getDeleteSealFileList: "/web/empElectronicSealApply/getDeleteSealFileList.jhtml", //作废文件列表
        getElectronicSealEmpDetail: "/web/empElectronicSealApply/getElectronicSealEmpDetail.jhtml", //废弃页面回显页面
        getElectronicSealEmpDetail1: "/web/empElectronicSealApply/single/getElectronicSealEmpDetail.jhtml", //废弃页面回显页面
        getElectronicSealEmpDetailzuofei: "/web/empElectronicSealApply/zuofei/getElectronicSealEmpDetail.jhtml", //废弃页面回显页面
        getElectronicSealCustomDetail: "/web/empElectronicSealApply/getElectronicSealCustomDetail.jhtml", //获取作废自定义信息
        getElectronicSealCustomDetail1: "/web/empElectronicSealApply/single/getElectronicSealCustomDetail.jhtml", //单人签订获取作废自定义信息
        saveElectronicSealApply: "/web/empElectronicSealApply/saveElectronicSealApply.jhtml", //保存作废信息并发出申请
        saveElectronicSealApply1: "/web/empElectronicSealApply/single/saveElectronicSealApply.jhtml", //保存作废信息并发出申请
        getEmpElectronicSealApplyListSer: "/web/empElectronicSealApply/getEmpElectronicSealApplyListSer.jhtml", //企业盖章列表查询条件
        queryElectronicSealApplyPageSer: "/web/empElectronicSealApply/queryElectronicSealApplyPageSer.jhtml", //签订记录列表查询条件
        queryTemplateTypeList: "/web/empElectronicSealApply/queryTemplateTypeList.jhtml",
        querySignTemplateTypeList: "/web/empElectronicSealApply/querySignTemplateTypeList.jhtml", //电子签订模板类型查询
        searchTemp: "/web/empElectronicSealApply/searchTemp.jhtml", //员工查询条件
        getEmpBaseInfoWorkIngListPage: "/web/empElectronicSealApply/getEmpBaseInfoWorkIngListPage.jhtml", //员工分页查询
        downSignTemplate: "/web/empElectronicSealApply/downSignTemplate.jhtml", //模板下载
        uploadSignExcel: "/web/empElectronicSealApply/uploadSignExcel.jhtml", //模板导入
        cancleSealApply: "/web/empElectronicSealApply/cancleSealApply.jhtml", //单个作废
        getEmpElectronicList: "/web/empElectronicSealApply/getEmpElectronicList.jhtml", //通过模板id查询电子签章申请
        cancleSealApplyBatch: "/web/empElectronicSealApply/cancleSealApplyBatch.jhtml", //批量作废接口
        queryCancelContractList: "/web/empElectronicSealApply/queryCancelContractList.jhtml", //作废签订历史分页
        querySuccessElectronicsContractList: "/web/empElectronicSealApply/querySuccessElectronicsContractList.jhtml", //作废签订文件列表
        getCustomTemplateListSer: "/web/customTemplate/getCustomTemplateListSer.jhtml", //模板搜索
        getCustomTemplateListSerset: "/web/customTemplate/set/getCustomTemplateListSer.jhtml", //模板搜索
        queryExistCustLegal: "/web/custRelLegal/queryExistCustLegal.jhtml", //判断是否有法人接口
        getLegalsDetail: "/web/empPostContract/getLegalsDetail.jhtml", //批量作废获得法人主体
        getSsqCertType: "/web/custRelLegal/getSsqCertType.jhtml", //查询法人证件类型
        queryEmpCustLegal: "/web/custRelLegal/queryEmpCustLegal.jhtml", //电子盖章模块法人查询
        queryEmpCustLegal1: "/web/custRelLegal/single/queryEmpCustLegal.jhtml", //单人签订电子盖章模块法人查询
        getEmpCustomTemplate: '/web/customTemplate/getEmpCustomTemplate.jhtml', //电子盖章模板查询
        getEmpCustomTemplate1: '/web/customTemplate/sum/getEmpCustomTemplate.jhtml', //批量签订电子盖章模板查询
        getContractCodeSettingPage: "/web/contractCodeSetting/getContractCodeSettingPage.jhtml", //合同编号规则设置列表查询
        saveContractCodeSetting: "/web/contractCodeSetting/saveContractCodeSetting.jhtml", //合同编号规则设置保存
        updateContractCodeSetting: "/web/contractCodeSetting/updateContractCodeSetting.jhtml", //修改
        getContractCodeSettingById: "/web/contractCodeSetting/getContractCodeSettingById.jhtml", //查询
        getContractCodeSettingByIdlook: "/web/contractCodeSetting/look/getContractCodeSettingById.jhtml", //查看页面的查询
        deleteContractCodeSettingById: "/web/contractCodeSetting/deleteContractCodeSettingById.jhtml", //删除
        updateStateById: "/web/contractCodeSetting/updateStateById.jhtml", //修改状态
        queryBankCard: "/web/custRelLegal/queryBankCard.jhtml", //查询法人银行卡号
        payAuthVerify: "/web/custRelLegal/payAuthVerify.jhtml", //验证对公打款
        saveOrUpdateCustElecSeal: "/web/custElecSeal/saveOrUpdateCustElecSeal.jhtml", //保存或修改印章样式
        getCustSealerIdentitys: "/web/custSealerIdentity/getCustSealerIdentitys.jhtml", //盖章人实名认证列表
        getCustSealerIdentitysSer: "/web/custSealerIdentity/getCustSealerIdentitysSer.jhtml", //盖章人实名认证查询条件
        sendIdentityShortMessageAgain: "/web/custSealerIdentity/sendIdentityShortMessageAgain.jhtml", //重新发送认证短信
        deleteCustSealerIdentity: "/web/custSealerIdentity/deleteCustSealerIdentity.jhtml", //删除员工
        saveCustSealerIdentity: "/web/custSealerIdentity/saveCustSealerIdentity.jhtml", //员工实名认证
        getEmpBaseInfoWorkIngListPage: "/web/empElectronicSealApply/getEmpBaseInfoWorkIngListPage.jhtml", //获取用户权限下的所有员工
        getDaili: "/web/custRelLegal/getCustSealerIdentitys.jhtml", //获取代理人
        getCityName: "/web/custRelLegal/getCityName.jhtml", //获取城市列表
        queryCustSealModels: "/web/custSealModel/queryCustSealModels.jhtml", //获取印章列表
        deleteCustSealModel: "/web/custSealModel/deleteCustSealModel.jhtml", //删除印章样式
        saveOrUpdateCustSealModel: "/web/custSealModel/saveOrUpdateCustSealModel.jhtml", //保存或修改印章样式
        queryCustSealModelsNoPage: "/web/custSealModel/queryCustSealModelsNoPage.jhtml", //获取印章样式列表
        getValidityOfContract: "/web/customTemplateType/getValidityOfContract.jhtml", //获取员工签署有效期列表	
        getCustSealModelDetail: "/web/custSealModel/getCustSealModelDetail.jhtml", //获取印章详情
        getFaren: "/web/custLegalRelSealer/queryEmpCustLegal.jhtml", //获取登录人权限下的法人单位列表
        getOtherTypeTempalteSettingList: "/web/contractSetting/getOtherTypeTempalteSettingList.jhtml", //根据当前自定义模板类型之外的模板集合
        getCustomTemplateCount: "/web/customTemplate/getCustomTemplateCount.jhtml", //获取当前模板类型下的模板数量
        exportNoContractEmpPage:"/web/empPostContract/exportNoContractEmpPage.jhtml",//签订合同列表下载
        exportAllowChangeAndReleaseContract:"/web/empPostContract/exportAllowChangeAndReleaseContract.jhtml",//已签订合同列表下载
        exportExpiredContract:"/web/empPostContract/exportExpiredContract.jhtml",//即将到期合同下载
    },
    insuranceApi: {
        insuranceList: "/web/insurance/findInsProductBypage.jhtml", //保险列表
        findDataInfoByProdId: "/web/insurance/findDataInfoByProdId.jhtml", //保险详情
        findInsuranceMemberByProdId: "/web/insurance/findInsuranceMemberByProdId.jhtml", //本月人员查询
        delInsuranceChangeMember: "/web/insurance/updateChangeDeleteById.jhtml", //本月变更人员删除
        delInsuranceMember: "/web/insurance/updateAttritionById.jhtml", //本月在保人员删除
        getMemberByPamars: '/web/insurance/getMemberByPamars.jhtml', //根据部门获取员工列表(类型亲友or员工)
        saveInsEmpInfo: '/web/insurance/saveInsEmpInfo.jhtml', //新增社保人员
        exportExcel: '/web/insurance/downExcel.jhtml', //导出excel
        findInsEmpArrayByDeptId: '/web/insurance/queryInsEmpArrayByDeptId.jhtml', //根据科室ID和商品ID获取参保的人员
        findEmpDetail: '/web/insurance/queryEmpInfoById.jhtml', //获取员工详情注入
        uploadExcel: '/web/insurance/uploadExcel.jhtml', //批量导入
        downLoadApi: '/web/insurance/downLoadInsEmpTemp.jhtml', //下载导入模板
        getInsEmpInfoById: '/web/insurance/getInsEmpInfoById.jhtml', //根据ID获取详情
        updateInsEmpInfo: '/web/insurance/updateInsEmpInfo.jhtml', //修改保险员工信息
        exportProdExcel: '/web/insurance/downProdExcel.jhtml', //导出excel(产品页面)
        uploadExcelProd: '/web/insurance/uploadExcelProd.jhtml', //批量导入(产品页面)
        downLoadProdsInsEmpTemp: '/web/insurance/downLoadProdsInsEmpTemp.jhtml', //下载导入模板(产品页面)
        uploadExcelAttrition: '/web/insurance/uploadExcelAttrition.jhtml', //批量导入
        downLoadInsEmpAttritionTemp: '/web/insurance/downLoadInsEmpAttritionTemp.jhtml', //下载导入模板
        findInsProdList: '/web/insurance/findInsProductAll.jhtml', //获取权限下的计划
        findInsReport: '/web/insurance/findInsReport.jhtml', //获取报表信息
        exportInsReportExcel: '/web/insurance/exportInsReportExcel.jhtml', //导出EXcel 统计
        findInsMemberAllByPage: '/web/insurance/findInsMemberAllByPage.jhtml', //商保列表
        seachTempList: "/web/insurance/searchTemp.jhtml", //商保人员搜索模板
        seachBillList: "/web/insurance/findInsEmpBillDetails.jhtml", //商保账单统计
        findInsStates: "/web/insurance/findInsStats.jhtml", //商保状态
        findInsProdTypes: "/web/insurance/findInsProdType.jhtml", //商保类型
        seachInsEmpTransferDeptTmp: "/web/insurance/searchInsEmpTransferDeptTmp.jhtml", //商保部门异动列表
        seachInsEmpReductTmp: "/web/insurance/searchInsEmpReductTmp.jhtml", //商保异动减员列表
        exportInsBillReportExcel: '/web/insurance/exportInsEmpBillReportExcel.jhtml', //导出EXcel 统计
    },
    insSettingApi: { //商保设置
        list: "/web/insurance/findSettingInsProductBypage.jhtml", //保险列表
        delete: "/web/insurance/deleteProdInfoById.jhtml", //删除
        saveProd: "/web/insurance/saveProdInfo.jhtml", //保存商保信息
        findProdInfoById: "/web/insurance/findSettingProdInfoById.jhtml", //根据Id获取详情
        updateProd: "/web/insurance/updateProdInfo.jhtml", //修改商保信息
        findCheckOnly: '/web/insurance/findCheckOnly.jhtml', //判断员工是否同时参加多个商保计划
        saveOrUpdateInsCustInfo: '/web/inscustinfo/saveOrUpdateInsCustInfo.jhtml', // 商保设置保存数据
        //商保医生视频
        videoDocList: "/web/insVideoDoctor/findByPage.jhtml", //分页查询
        videoDocBatchByDept: "/web/insVideoDoctor/insertBatchByDept.jhtml", //根据部门批量新增
        videoDocSearchTemp: "/web/insVideoDoctor/searchTemp.jhtml", //搜索模板 
        updateVideoDoc: "/web/insVideoDoctor/updateVideoDoc.jhtml", //编辑人员次数
        deleteVideoDoc: "/web/insVideoDoctor/deleteVideoDoc.jhtml", //删除
        videoDocDownExcel: "/web/insVideoDoctor/downExcel.jhtml", //下载
        videoDocUploadExcel: "/web/insVideoDoctor/uploadExcel.jhtml", //导入EXCEL
        videoDocDownLoadTemp: "/web/insVideoDoctor/downLoadTemp.jhtml", //导入模板
        videoDocfindByInfo: "/web/insVideoDoctor/findByInfo.jhtml", //详情
    },
    insAdministrationApi: { //商保管理
        list: "/web/insurance/findInsuranceByPage.jhtml", //商保列表
        search: "/web/insurance/searchInsurance.jhtml", //商保搜索
        uploadExcel: "/web/insurance/uploadExcelProd.jhtml", //商保管理导入模板
        downLoadExcel: "/web/insurance/downLoadInsEmpInfoTemp.jhtml", //商保管理下载模板
        uploadExcelDelEmp: "/web/insurance/uploadExcelReduceProd.jhtml", //商保管理导入减员模板
        downLoadExcelDelEmp: "/web/insurance/downLoadInsEmpInforeduceTemp.jhtml", //商保管理下载减员模板
        delEmpList: "/web/insurance/queryInsEmpInfoListByIds.jhtml", //商保减员弹窗初始化列表  传入ids 数组[ieiId]
        delSaveData: "/web/insurance/saveOrUpdateInsEmp.jhtml", //商保减员保存
        changeEmpList: "/web/insurance/queryInsEmpChangeByIds.jhtml", //商保变更弹窗初始化列表   传入ids 数组[ieiId]
        changeSaveData: "/web/insurance/changeInPlan.jhtml", //商保变更保存
        withdraw: "/web/insurance/updateOrDeleteInsEmp.jhtml", //商保撤回
        getPlanList: "/web/insurance/queryDataInfoByProdId.jhtml", //获取新商保计划下拉框
        downLoad: "/web/insurance/downLondInsEmpInfo.jhtml", //商保导出
        IsOpen: "/web/inscustinfo/findInCustInfo.jhtml", //新新商保修改判断接口
        seePlanList: "/web/insurance/findInsProductBypage.jhtml", //查看商保计划列表
        findDataInfoByProdId: "/web/insurance/findDataInfoByProdId.jhtml", //保险详情
        UninsuredList: "/web/insurance/findUnInsuranceByPage.jhtml", //未参保员工列表
        UninsuredSearch: "/web/insurance/searchUnInsurance.jhtml", //未参保员工列表搜索
        UninsuredEmpInfo: "/web/insurance/initEmpIncrease.jhtml", //获取单个未参保员工信息
        saveInsEmpInfo: '/web/insurance/saveInsEmpInfo.jhtml', //新增社保人员
        reductionList: "/web/insurance/loadInsEmpReduct.jhtml", //减员确认列表
        reductionSearch: "/web/insurance/searchInsEmpReductTmp.jhtml", //减员确认列表搜索
        reductionSave: "/web/insurance/confirmInsEmpsReduct.jhtml", //减员确认列表 确认
        transferList: "/web/insurance/loadInsEmpTransferDept.jhtml", //异动确认列表
        transferSearch: "/web/insurance/searchInsEmpTransferDeptTmp.jhtml", //异动确认列表
        transferSee: "/web/insurance/getInsEmpTransferDeptDetails.jhtml", //移动确认查看详情
        transferSave: "/web/insurance/confirmInsEmpTransferDept.jhtml", //异动确认列表确认
        transferSaveck: "/web/insurance/transferSaveck/confirmInsEmpTransferDept.jhtml", //异动确认列表查看 -----许婧媛
        billList: "/web/insurance/findInsEmpBillDetails.jhtml", //账单统计列表
        billSearch: "/web/insurance/searchInsEmpBillDetails.jhtml", //账单统计搜索接口
        billexport: "/web/insurance/exportInsEmpBillReportExcel.jhtml", //账单统计导出
        participationList: "/web/insurance/findInsReport.jhtml", //参保变更列表
        participationSearch: "/web/insurance/searchFindInsReport.jhtml", //参保变更搜索
        participationexport: "/web/insurance/exportInsReportExcel.jhtml", //参保变更导出
    },
    contractApi: { //合同模块
        list: "/web/empPostContract/getNoContractEmpPage.jhtml", //合同签订列表
        list1: "/web/empPostContract/getNoContractEmpPage.jhtml", //合同签订列表
        search: "/web/empPostContract/getEmpSer.jhtml", //获取查询列表
        searchzuofei: "/web/empPostContract/zuofei/getEmpSer.jhtml", //获取查询列表
        searchzuofeils: "/web/empPostContract/zuofeils/getEmpSer.jhtml", //获取查询列表
        RenewalOrTerminationList: "/web/empPostContract/getNeedRenewAndTerminateContractPage.jhtml", //续签或者终止
        RenewalOrTerminationSearch: "/web/empPostContract/getNeedRenewAndTerminateContractSer.jhtml", //续签或者终止搜索
        ChangOrReleaseList: "/web/empPostContract/getAllowChangeAndReleaseContractPage.jhtml", //变更或解除列表
        ChangOrReleaseSearch: "/web/empPostContract/getContractSer.jhtml", //变更或解除列表搜索
        ModifyList: "/web/empPostContract/getAllowUpdateContractPage.jhtml", //合同修改列表
        ModifySearch: "/web/empPostContract/getContractSer.jhtml", //合同修改查询
        DetailedList: "/web/empPostContract/getContractPage.jhtml", //电子合同明细
        DetailedSearch: "/web/empPostContract/getContractSer.jhtml", //电子合同查询
        ApplyList: "/web/empPostContractApply/queryContractApplyPage.jhtml", //申请列表
        ApplySearch: "/web/empPostContractApply/getContractApplySer.jhtml", //申请列表
        ApplyExport: '/web/empPostContractApply/downExcel.jhtml', //合同申请导出
        SealList: "/web/attExamStep/SealList/getCompanySealPage.jhtml", //电子合同盖章列表
        SealSearch: "/web/empPostContract/getEmpSer.jhtml", //电子合同盖章查询
        ContractDetail: '/web/empPostContract/getContractDetail.jhtml', //在职员工签订获取页面模板
        ContractDetail1: '/web/empPostContract/1/getContractDetail.jhtml', //在职员工签订获取页面模板
        ContractDetail2: '/web/empPostContract/2/getContractDetail.jhtml', //在职员工签订获取页面模板
        ContractDetail3: '/web/empPostContract/3/getContractDetail.jhtml', //在职员工签订获取页面模板
        ContractDetail4: '/web/empPostContract/4/getContractDetail.jhtml', //在职员工签订获取页面模板
        ContractDetail5: '/web/empPostContract/5/getContractDetail.jhtml', //在职员工签订获取页面模板
        ContractDetail6: '/web/empPostContract/6/getContractDetail.jhtml', //在职员工签订获取页面模板
        ContractDetail7: '/web/empPostContract/7/getContractDetail.jhtml', //在职员工签订获取页面模板
        ContractDetail8: '/web/empPostContract/8/getContractDetail.jhtml', //在职员工签订获取页面模板
        yonghuigetCode: '/web/IdGen/getNo.jhtml', //永辉  获取合同编号
        ContractType: "/web/contractSetting/getContractType.jhtml", //获取合同类型字典表
        ContractName: "/web/contractSetting/getContractSettingList.jhtml", //获取合同模板名称 
        getCompany: "/thirdParty/shangshangqian/getContractPreviewURL.jhtml", //获取合同详情（合同盖章的）
        getCompany2: "/thirdParty/shangshangqian/getContractPreviewURL2.jhtml", //获取合同详情(查看的)
        confirmCompany: "/thirdParty/shangshangqian/autoSignCert.jhtml", //确认合同盖章
        downloadPdf: "/thirdParty/shangshangqian/downloadPdf.jhtml", //下载电子合同pdf
        downProveFile: '/thirdParty/shangshangqian/attachmentDown.jhtml', //下载证明文件
        verifyIsAllowSsq: "/web/contractSetting/verifyIsAllowSsq.jhtml", //是否还有签订电子合同的额度
        verifyIsAllowSsqzuofei: "/web/contractSetting/zuofei/verifyIsAllowSsq.jhtml", //作废是否还有签订电子合同的额度
        verifyIsAllowSsq1: "/web/contractSetting/single/verifyIsAllowSsq.jhtml", //单人签订是否还有签订电子合同的额度
        verifyIsAllowSsq2: "/web/contractSetting/sum/verifyIsAllowSsq.jhtml", //批量签订是否还有签订电子合同的额度
        deleteEmpContract: "/web/empPostContract/deleteEmpContract.jhtml", //合同删除
        getExpiredContractSer: '/web/empPostContract/getExpiredContractSer.jhtml', //即将到期的员工查询条件
        getExpiredContract: "/web/empPostContract/getExpiredContract.jhtml", //即将到期的员工列表
        saveElectronicSealApply: "/web/empElectronicSealApply/saveElectronicSealApply.jhtml", //证明文件保存及审批
        selectContractApplyEmpInfo: '/web/empPostContractApply/selectContractApplyEmpInfo.jhtml', //显示旧的员工信息
        getCustomTemplateFieldLabels: "/web/customTemplate/getCustomTemplateFieldLabels.jhtml", //查看模板对应字段标签
        getEmpSer: "/web/attExamStep/getEmpSer.jhtml", //电子合同盖章搜索
        verifyContractIsCanDelete: "/web/empPostContract/verifyContractIsCanDelete.jhtml", //校验合同是否允许删除
        htgetEmpBaseInfo: "/web/empPostContractApply/getEmpBaseInfo.jhtml", //盖章人信息确认，获取员工手机号

        getSealerVerifyCode: "/empweb/privilege/getSealerVerifyCode.jhtml", //合同盖章获取验证码
        htverifyMobileCode: "/empweb/privilege/verifyMobileCode.jhtml", //合同校验验证码
    },
    payslipApi: { //工资单
        resendPaylisp: "/web/payslip/resendPaylisp.jhtml", //未发送重发
        list: "/web/payslip/findPayslipListByPage.jhtml", //工资单列表
        seachList: "/web/payslip/searchTemp.jhtml", //搜索模板
        delete: "/web/payslip/deletePayslipInfoById.jhtml", //删除工资单
        export: "/web/payslip/exportPayslipList.jhtml", //导出工资单

        empList: "/web/payslipEmp/findPayslipEmpListByPage.jhtml", //工资单人员列表
        empBatchUpdateState: "/web/payslipEmp/updateBatchPayslipEmpState.jhtml", //工资单人员批量修改状态
        empUpdateState: "/web/payslipEmp/updatePayslipEmpState.jhtml", //工资单人员修改状态 //单条发送
        empSeachList: "/web/payslipEmp/searchTemp.jhtml", //工资单人员搜索模板
        empExport: "/web/payslipEmp/exportPayslipEmpList.jhtml", //工资单人员导出

        sysPayList: "/web/payslip/findPayrollListByDate.jhtml", //获取系统薪酬
        sysPaySetPayslipInfo: "/web/payslipEmp/findSysPaySetPayslipInfo.jhtml", //系统薪酬保存到工资单
        tmpPayslipEmpList: "/web/payslipEmp/findTmpPayslipEmpList.jhtml", //查询临时表人员信息
        tmpPayslipHeadList: "/web/payslipHead/findTmpHeadList.jhtml", //获取临时表头部信息
        savePayslip: "/web/payslip/savePayslipInfo.jhtml", //新增

        downLoadApi: "/web/payslip/downLoadTemp.jhtml", //下载模板
        uploadExcel: "/web/payslip/uploadExcel.jhtml", //上传
        payEmpDetails: "/web/payslipEmp/findPayslipEmpInfo.jhtml", //获取工资详情
        sendPayslipEmpList: "/web/payslip/sendPayslipEmpList.jhtml" //发送工资条
    },
    specialday: {
        specialList: '/web/attSetSpecialWorkday/queryAttSetSpecialWorkdayPage.jhtml', //特殊工作日列表
        addspecial: '/web/attSetSpecialWorkday/openSaveAttSetSpecialWorkday.jhtml', //打开添加特殊工作日
        addspecialsave: '/web/attSetSpecialWorkday/saveAttSetSpecialWorkday.jhtml', //保存特殊工作日
        editspecial: '/web/attSetSpecialWorkday/getAttSetSpecialWorkdayDetail.jhtml', //获取特殊工作日详情
        editspecialsave: '/web/attSetSpecialWorkday/updateAttSetSpecialWorkday.jhtml', //修改特殊工作日保存
        updatespecialstate: '/web/attSetSpecialWorkday/updateAttSetSpecialWorkdayState.jhtml', //修改特殊工作日状态
        delspecial: '/web/attSetSpecialWorkday/deleteAttSetSpecialWorkday.jhtml', //删除特殊工作日

    },
    socialSecurity: {
        empNoAddSionPage: "/web/soin/empNoAddSionPage.jhtml", //社保未增员列表
        // noAddSearchTemp: "/web/soin/noAddSearchTemp", //未增员搜索模板
        //新增
        getHroCustInfoList: "/web/soinCust/getHroCustInfoList.jhtml", //增员时获取社保方案
        getPersonCategoryByCityId: "/web/soin/getPersonCategoryByCityId.jhtml", //获取缴费人员类别
        addTemplateByBase: "/web/soin/addTemplateByBase.jhtml", //获取社保基础信息的数据
        getEmpBaseInfo: "/web/soin/getEmpBaseInfo.jhtml", //增员页面加载时获取员工信息
        saveBaseSoinEmpInfo: "/web/soin/saveBaseSoinEmpInfo.jhtml", //保存
        addTemplateByPfOfType: "/web/soin/addTemplateByPfOfType.jhtml", //增加公积金比例模板
        //社保
        addTemplateBySs: "/web/soin/addTemplateBySs.jhtml", //社保增加时的模板数据
        getProductDetail: "/web/soin/getProductDetail.jhtml", //预览费用详情接口
        saveSs: "/web/soin/saveSs.jhtml", //保存员工社保信息
        //公积金
        addTemplateByPf: "/web/soin/addTemplateByPf.jhtml", //增加公积金模板
        savePf: "/web/soin/savePf.jhtml", //保存公积金信息
        //详情
        getProductDetailSum: "/web/soin/getProductDetailSum.jhtml", //获取员工信息及社保信息 最后提交页面的社保公积金详情
        saveSoinEmp: "/web/soin/saveSoinEmp.jhtml", //提交接口
        //异动
        loadSoinEmpTransferDept: "/web/soin/loadSoinEmpTransferDept.jhtml", //参社保员工部门异动列表
        confirmSoinEmpTransferDept: "/web/soin/confirmSoinEmpTransferDept.jhtml", //确认异动员工岗位
        confirmSoinEmpTransferDeptByView: "/web/soin/confirmSoinEmpTransferDeptByView/confirmSoinEmpTransferDept.jhtml", //确认异动员工岗位 修改:谭金晶
        searchSoinEmpTransferDeptTmp: "/web/soin/searchSoinEmpTransferDeptTmp.jhtml", //搜索模板
        //在职员工的社保缴纳人员列表
        getEmpSionPage: "/web/soin/getEmpSionPage.jhtml",
        //离职员工社保缴纳列表
        getEmpSionOfLeavePage: "/web/soin/getEmpSionOfLeavePage.jhtml",
        //在职和离职续缴列表查询模板
        noAddSearchTemp: "/web/soin/noAddSearchTemp.jhtml",
        //减员
        getDeleteSoinEmp: "/web/soin/getDeleteSoinEmp.jhtml", //减员时获取员工数据
        checkEmpReduce: "/web/soin/checkEmpReduce.jhtml", //校验是否可以减员 
        checkEmpReduceByMove: "/web/soin/checkEmpReduceByMove/checkEmpReduce.jhtml", //校验是否可以减员 人员异动 修改:谭金晶
        checkEmpReduceByPayBill: "/web/soin/checkEmpReduce.jhtml", //校验是否可以减员 委托账单 修改:谭金晶
        deleteSoinEmp: "/web/soin/deleteSoinEmp.jhtml", //社保减员
        revokeAddSoinEmp: "/web/soin/revokeAddSoinEmp.jhtml", //增员撤回
        getEmpSionOfLeaveHistoryPage: "/web/soin/getEmpSionOfLeaveHistoryPage.jhtml", //社保减员历史列表
        addedSearchTemp: "/web/soin/addedSearchTemp.jhtml", //在职/离职/离职历史 参保列表模板
        addedSearchTempByHistory: "/web/soin/addedSearchTempByHistory/addedSearchTemp.jhtml", //离职历史 参保列表模板 修改:谭金晶
        addedSearchTempBySSDEparting: "/web/soin/addedSearchTempBySSDEparting/addedSearchTemp.jhtml", //离职历史 参保列表模板 修改:谭金晶
        //详情
        getSoinEmpAlreadyAddDetail: "/web/soin/getSoinEmpAlreadyAddDetail.jhtml",
        //跳过
        canSkip: "/web/soin/canSkip.jhtml",
        //获取异动详细信息
        getSoinEmpTransferDeptDetail: "/web/soin/getSoinEmpTransferDeptDetail.jhtml",
        searchSoinReceivableTemp: "/web/soinReceivable/searchSoinReceivableTemp.jhtml",
        searchSoinReceivableTempByPayBill: "/web/soinReceivable/searchSoinReceivableTempByPayBill/searchSoinReceivableTemp.jhtml", //修改：谭金晶

    },
    OverTime: {
        overTimeMan: '/web/attOverApply/queryAttOverApplyPage.jhtml',
        overTimeSer: '/web/attOverApply/getAttOverApplySer.jhtml', //加班管理搜索
        overTimeDownLoad: '/web/attOverApply/downExcel.jhtml', //加班管理导出
        revokeApply: '/web/attExamStep/revokeApply.jhtml', //撤销申请
        revokeApplyPost: '/web/attExamStep/post/revokeApply.jhtml', //撤销申请 调岗
        revokeApplyDeparture: '/web/attExamStep/departure/revokeApply.jhtml', //撤销申请 离职
        revokeApplyPositive: '/web/attExamStep/positive/revokeApply.jhtml', //撤销申请 转正
        revokeApplyEmployed: '/web/attExamStep/employed/revokeApply.jhtml', //撤销申请 录用
        revokeApplyInternship: '/web/attExamStep/internship/revokeApply.jhtml', //撤销申请 转全职
        revokeApply1: '/web/attExamStep/revokeApply1/revokeApply.jhtml', //撤销申请  胡卫卫
        revokeApply2: '/web/attExamStep/revokeApply2/revokeApply.jhtml', //撤销申请  胡卫卫
        revokeApply3: '/web/attExamStep/revokeApply3/revokeApply.jhtml', //撤销申请  胡卫卫
        revokeApply4: '/web/attExamStep/revokeApply4/revokeApply.jhtml', //撤销申请  胡卫卫
        overApplyDetail: '/web/attOverApply/openEdit.jhtml',
        getGroupExamStepInfo: '/web/attOverApply/getAttOverApplyAndGroupExamStepInfo.jhtml', //获取批量加班详情
        saveUpdate: '/web/attOverApply/updateRepayType.jhtml', //加班管理修改
        down: '/web/attOverApply/downExcel.jhtml', //导出
        downLoadApi: '/web/attOverApply/downTemplate.jhtml',
        ImportApi: '/web/attOverApply/uploadExcel.jhtml',
        getAttOverApplyWithRestDetail: "/web/icss/attOverApplyWithRest/getAttOverApplyWithRestDetail.jhtml", //华为夜班&补休详情
    },

    HolManage: {
        holManage: '/web/attHolApply/queryAttHolApplyByPage.jhtml', //假期管理
        holSer: '/web/attHolApply/searchAttHolApplyTemp.jhtml', //假期管理搜索
        holDetail: '/web/attHolApply/getAttHolApplyDetail.jhtml', //假期管理详情
        holDetailPubRelea: '/web/attHolApply/PubRelea/getAttHolApplyDetail.jhtml', //假期管理详情
        //holDetail:'/web/attExamStep/getAttExamStepDetail.jhtml',
        exports: '/web/attHolApply/exportAttHolApply.jhtml',
        downLoadApi: '/web/attHolApply/exprotAttHolApplyTemplate.jhtml',
        ImportApi: '/web/attHolApply/importAttHolApplyExcel.jhtml',
        ImportApiGongChu: '/web/attHolApply/GongChu/importAttHolApplyExcel.jhtml', //--csy
        publicredownLoad: '/web/attOutAddress/exprotOutAddressApplyTemplate.jhtml',

        publicexports: '/web/attOutAddress/exportExcel.jhtml',

        publicList: '/web/attOutAddress/queryOutAddressByPage.jhtml', //公出列表
        publicSer: '/web/attOutAddress/searchOutAddressApplyTemp.jhtml',
        getAddRecordDetail: "/web/vitasoyAttAddRec/attType/getAddRecordDetail.jhtml", //补请记录详情

    },
    Daily: {
        list: '/web/attEmpDetail/getAttEmpDetailListPage.jhtml', //日报列表
        statisnow: '/web/attEmpDetail/statisticsAttEmpDetailByPage.jhtml', //统计今日日报
        detail: '/web/attEmpLog/getAttEmpLogByEmpId.jhtml', //日报详情
        ser: '/web/attEmpDetail/searchDetail.jhtml', //日报搜索
        downLaod: '/web/attEmpDetail/downLaodAttEmpDetail.jhtml', //导出
        downLoadApi: '/web/attEmpLog/downLaodAttEmpLogTemp.jhtml',
        ImportApi: '/web/attEmpLog/importAttEmpLogExcel.jhtml',
        iccdownLaod: '/web/icss/attDailyData/downLaodAttEmpDetail.jhtml',
        iccList: '/web/icssAttEmpDetail/getAttEmpDetailListPage.jhtml',
        newdownLoadApi: '/web/attEmpLog/downLaodAttEmpLog.jhtml',
        newImportApi: '/web/attEmpLog/importAttEmpLogDaily.jhtml',
    },
    MonthR: {
        fileList: '/web/attStMonth/getInitMonthAttStMonthList.jhtml', //最后一次归档数据
        list: '/web/attStMonth/getAttStMonthPage.jhtml', //考勤统计后的数据
        list1: '/web/attStMonth/list1/getAttStMonthPage.jhtml', //考勤统计后的数据    胡卫卫
        list2: '/web/attStMonth/list2/getAttStMonthPage.jhtml', //考勤统计后的数据    胡卫卫
        staticItem: '/web/attStMonth/getCountAttStMonthList.jhtml', //考勤统计后时间列表
        staticItem1: '/web/attStMonth/staticItem1/getCountAttStMonthList.jhtml', //考勤统计后时间列表  胡卫卫
        staticItem2: '/web/attStMonth/staticItem2/getCountAttStMonthList.jhtml', //考勤统计后时间列表  胡卫卫
        cycle: '/web/attStMonth/getCountAttStMonthDate.jhtml', //考勤统计周期
        savecycle: '/web/attStMonth/saveAttStMonthByCount.jhtml', //考勤统计计算
        saveFile: '/web/attStMonth/saveAttStMonthArch.jhtml', //归档  新

        update: '/web/attStMonth/updateAttStMonthTemp.jhtml', //获取修改数据
        updatesave: '/web/attStMonth/updateAttStMonth.jhtml', //修改保存
        historyL: '/web/attStMonth/getHisMonthAttStMonthList.jhtml',
        fileTime: '/web/attStMonth/getAllArchList.jhtml', //归档过的周期
        historySer: '/web/attStMonth/searchTemp.jhtml',
        historySer1: '/web/attStMonth/historySer1/searchTemp.jhtml', //胡卫卫
        historySer2: '/web/attStMonth/historySer2/searchTemp.jhtml', //胡卫卫

        down: '/web/attStMonth/downCurrentAttStMonth.jhtml', //历史报表导出
        downLoad: '/web/attStMonth/downCurrentAttStMonth2.jhtml', //考勤月报导出
        downLoadMonthRep: '/web/attEmpDetail/getAttMonthReportByMonth.jhtml', //导出月度汇总表
        downLoadhistorys: '/web/attStMonth/history/downCurrentAttStMonth2.jhtml', //考勤月报导出
        downLoad3: '/web/attStMonth/downCurrentAttStMonth3.jhtml', //考勤月报导出
        detail: '/web/attEmpDetail/getAttEmpDeatilByMonthWeb.jhtml', //月报详情
        detailStatis: '/web/attEmpDetail/statis/getAttEmpDeatilByMonthWeb.jhtml', //月报详情 统计--csy
        detailHW: '/web/attEmpDetail/hw/getAttEmpDeatilByMonthWeb.jhtml', //月报详情 --csy
        detailFHW: '/web/attEmpDetail/fhw/getAttEmpDeatilByMonthWeb.jhtml', //月报详情 --csy
        detail2: '/web/attEmpDetail/getAttEmpDeatilByMonthWeb.empweb', //月报详情
        deleteAtt: '/web/attStMonth/deleteAttStMonthArch.jhtml', //新
        AnnualLeaveRestPoolReportList: '/web/icss/attStMonthQuickViewStPool/queryByPage.jhtml', //获取年假池调休 分页列表
        AnnualLeaveRestPoolReportSearch: '/web/icss/attStMonthQuickViewStPool/searchTemp.jhtml', //获取年假池调休 搜索条件
        AnnualLeaveRestPoolReportstaticItem: '/web/attStMonth/1/getCountAttStMonthList.jhtml', //考勤统计后时间列表
        AnnualLeaveRestPoolReportSave: '/web/icss/attStMonthQuickViewStPool/caculate.jhtml', //重新计算保存
        AnnualLeaveRestPoolReportDown: '/web/icss/attStMonthQuickViewStPool/exportExcel.jhtml', //获取年假池调休 导出
        downLoadApi: '/web/attStMonth/downAttStMonthArchTemp.jhtml', //月报导入下载模板
        downLoadApi1: '/web/attStMonth/downLoadApi1/downAttStMonthArchTemp.jhtml', //月报导入下载模板  胡卫卫
        downLoadApi2: '/web/attStMonth/downLoadApi2/downAttStMonthArchTemp.jhtml', //月报导入下载模板  胡卫卫
        ImportApi: '/web/attStMonth/importExcel.jhtml', //月报导入
        ImportApi1: '/web/attStMonth/ImportApi1/importExcel.jhtml', //月报导入  胡卫卫
        ImportApi2: '/web/attStMonth/ImportApi2/importExcel.jhtml', //月报导入  胡卫卫
        WhiteList: '/web/empAttNameData/getAttEmpListPage.jhtml', //考勤白名单列表
        WhiteListSearch: '/web/empAttNameData/searchTemplate.jhtml', //考勤白名单列表搜索
        WhiteListDown: '/web/empAttNameData/export.jhtml', //考勤白名单下载
        WhiteAddEmp: '/web/empAttNameData/saveAttEmp.jhtml', //考勤白名单新增员工
        WhiteDelEmp: '/web/empAttNameData/delAttEmp.jhtml', //考勤白名单删除员工
        WhiteDownTemlate: '/web/empAttNameData/downLoadAddTemplate.jhtml', //考勤白名单下载新增模板
        WhiteUpTemlate: '/web/empAttNameData/upload.jhtml', //考勤白名单上传新增模板 
        getAddTemplate: '/web/empAttNameData/get.jhtml', //获取新增模板
        getDeptTree: '/web/deptInfo/getAllDeptTree.jhtml', //获取部门树
        getEmp: '/web/empBaseInfo/getEmpInfoByDeptId.jhtml', //根据部门获取员工
        impordowns1: '/web/attStMonth/downAttStMonthTemp.jhtml',
        impordownsHR: '/web/attStMonth/impordownsHR/downAttStMonthTemp.jhtml', //胡卫卫
        impordowns: "/web/icss/AttStMonthQuickViewIcss/downAttStMonthTemp.jhtml",
        impordownsHw: "/web/icss/AttStMonthQuickViewIcss/impordownsHw/downAttStMonthTemp.jhtml", //胡卫卫
        impordownsnoHw: "/web/icss/AttStMonthQuickViewIcss/impordownsnoHw/downAttStMonthTemp.jhtml", //胡卫卫
        impordownsHisHw: "/web/icss/AttStMonthQuickViewIcss/impordownsHisHw/downAttStMonthTemp.jhtml", //胡卫卫
        impordownsdraft: "/web/icss/AttStMonthQuickViewIcss/impordownsdraft/downAttStMonthTemp.jhtml", //胡卫卫
        iccdeleteAtt: '/web/icss/AttStMonthQuickViewIcss/deleteAttStMonthArch.jhtml', //新
        iccdeleteAtt1: '/web/icss/AttStMonthQuickViewIcss/iccdeleteAtt1/deleteAttStMonthArch.jhtml', //新  胡卫卫

        //中软
        //      mothlist: '/web/icss/attStMonth/getAttStMonthPage.jhtml', //旧华为群考勤群列表
        mothlist: '/web/icss/AttStMonthQuickViewIcss/getAttStMonthPage.jhtml', //华为群考勤群列表
        mothlistHis: '/web/icss/AttStMonthQuickViewIcss/mothlistHis/getAttStMonthPage.jhtml', //华为群考勤群列表  胡卫卫
        mothlistHw: '/web/icss/AttStMonthQuickViewIcss/mothlistHw/getAttStMonthPage.jhtml', //华为群考勤群列表   胡卫卫
        mothlistHwhis: '/web/icss/AttStMonthQuickViewIcss/mothlistHwhis/getAttStMonthPage.jhtml', //华为群考勤群列表    胡卫卫
        downs: '/web/icss/attStMonth/downCurrentAttStMonth.jhtml', //华为群考勤群导出

        iccimport: '/web/icss/attStMonth/importExcel.jhtml', //导入
        iccdown: '/web/icss/attStMonth/downAttStMonthArchTemp.jhtml', //导入的下载模板
        IccsearchTemp: "/web/icss/attStMonth/searchTemp.jhtml",
        iccSer: '/web/icss/AttStMonthQuickViewIcss/searchTemp.jhtml',
        iccSerls: '/web/icss/AttStMonthQuickViewIcss/iccSerls/searchTemp.jhtml', //----许婧媛
        iccSerhw: '/web/icss/AttStMonthQuickViewIcss/iccSerhw/searchTemp.jhtml', //---许婧媛
        iccSerlshw: '/web/icss/AttStMonthQuickViewIcss/iccSerlshw/searchTemp.jhtml', //----许婧媛
        IccDowns: "/web/icss/AttStMonthQuickViewIcss/downCurrentAttStMonth.jhtml", //考勤月报
        IccDowns1: "/web/icss/AttStMonthQuickViewIcss/IccDowns1/downCurrentAttStMonth.jhtml", //考勤月报 胡卫卫
        IccDowns2: "/web/icss/AttStMonthQuickViewIcss/IccDowns2/downCurrentAttStMonth.jhtml", //考勤月报 胡卫卫
        IccDowns3: "/web/icss/AttStMonthQuickViewIcss/IccDowns3/downCurrentAttStMonth.jhtml", //考勤月报 胡卫卫

        getAttStMonthTemp: "/web/icss/AttStMonthQuickViewIcss/getAttStMonthTemp.jhtml", //修改获取数据新
        getAttStMonthTempHw: "/web/icss/AttStMonthQuickViewIcss/getAttStMonthTempHw/getAttStMonthTemp.jhtml", //修改获取数据新  胡卫卫
        //		getAttStMonthTemp: "/web/icss/attStMonth/getAttStMonthTemp.jhtml", //修改获取数据旧
        //		icceditsave: "/web/icss/attStMonth/saveAttStMonth.jhtml",//修改保存旧
        icceditsave: '/web/icss/AttStMonthQuickViewIcss/saveAttStMonth.jhtml', //修改保存新
        icceditsavehw: '/web/icss/AttStMonthQuickViewIcss/icceditsavehw/saveAttStMonth.jhtml', //修改保存新-----许婧媛
        saveAttStMonthArch: "/web/icss/attStMonth/saveAttStMonthArch.jhtml",
        saveAttStMonthArch1: "/web/icss/AttStMonthQuickViewIcss/saveAttStMonthArch.jhtml",
        saveAttStMonthArch1hw: "/web/icss/AttStMonthQuickViewIcss/saveAttStMonthArch1hw/saveAttStMonthArch.jhtml", //华为月报归档-------许婧媛

        batchimport1: '/web/attStMonth/bulkImportArchive.jhtml', //批量导入归档
        batchimportHR: '/web/attStMonth/batchimportHR/bulkImportArchive.jhtml', //批量导入归档     胡卫卫
        batchimport: '/web/icss/AttStMonthQuickViewIcss/bulkImportArchive.jhtml', //批量导入归档
        batchimportHw: '/web/icss/AttStMonthQuickViewIcss/batchimportHw/bulkImportArchive.jhtml', //批量导入归档  胡卫卫
        batchimportnoHw: '/web/icss/AttStMonthQuickViewIcss/batchimportnoHw/bulkImportArchive.jhtml', //批量导入归档  胡卫卫
        batchimportHisHw: '/web/icss/AttStMonthQuickViewIcss/batchimportHisHw/bulkImportArchive.jhtml', //批量导入归档  胡卫卫
        batchimportdraft: '/web/icss/AttStMonthQuickViewIcss/batchimportdraft/bulkImportArchive.jhtml', //批量导入归档  胡卫卫
        //      finalFinalization: "/web/icss/attStMonth/finalFinalization.jhtml", //最终定稿
        finalFinalization: "/web/icss/AttStMonthQuickViewIcss/finalFinalization.jhtml", //最终定稿
        //      removeFinal: "/web/icss/attStMonth/removeFinalFinalization.jhtml", //解除定稿
        removeFinal: '/web/icss/AttStMonthQuickViewIcss/removeFinalFinalization.jhtml', //解除定稿
        queryEmpBaseList: "/web/attStMonth/queryEmpBaseList.jhtml", //获取该周期已归档或者未归档的人
        queryEmpBaseList1: "/web/icss/AttStMonthQuickViewIcss/queryEmpBaseList.jhtml",
        fileEmp: "/web/attStMonth/fileAttStMonthQuickViewEmp.jhtml",
        fileEmp11: "/web/attStMonth/fileEmp11/fileAttStMonthQuickViewEmp.jhtml",

        fileEmp2: "/web/icss/AttStMonthQuickViewIcss/fileEmp2/fileAttStMonthQuickViewEmp.jhtml", //胡卫卫
        fileEmp3: "/web/icss/AttStMonthQuickViewIcss/fileEmp3/fileAttStMonthQuickViewEmp.jhtml", //胡卫卫
        fileEmp4: "/web/icss/AttStMonthQuickViewIcss/fileEmp4/fileAttStMonthQuickViewEmp.jhtml", //胡卫卫
        fileEmp5: "/web/icss/AttStMonthQuickViewIcss/fileEmp5/fileAttStMonthQuickViewEmp.jhtml", //胡卫卫

        AttStMonthQuick: '/web/icss/attStMonthQuickViewRegu/getAttStMonthQuickViewReguPage.jhtml', //事病假拆分月度汇总列表
        downLoadRegu: "/web/icss/attStMonthQuickViewRegu/downLoadRegu.jhtml", //事病假拆分月度汇总导出
        uploadRegu: "/web/icss/attStMonthQuickViewRegu/uploadRegu.jhtml", //事病假拆分月度汇总导入数据
        downLoadReguTemp: "/web/icss/attStMonthQuickViewRegu/downLoadReguTemp.jhtml", //事病假拆分月度汇总下载模板
        //中软

        //  调整  2020-04-03
        getEmpPostDms: "/web/icss/empPost/getEmpPostDms.jhtml", // 获取操作详情
        getChangeDmsDetail: "/web/icss/empPost/getChangeDmsDetail.jhtml",
        saveEmpPostDms: "/web/icss/empPost/saveEmpPostDms.jhtml", //  保存维度
        getEmployeeList: "/web/icss/empPost/getEmployeeList.jhtml", // 前维度可操作员工列表
        searchEmployeeTemp: "/web/icss/empPost/searchEmployeeTemp.jhtml", // 当前维度搜索模板
        getEmpChangeDmsList: "/web/icss/empPost/getEmpChangeDmsList.jhtml", //  操作维度后待生效列表 || 操作维度后历史列表
        getEmpChangeDmsListls: "/web/icss/empPost/getEmpChangeDmsListls/getEmpChangeDmsList.jhtml", //  操作维度后待生效列表 || 操作维度后历史列表
        searchDmsTemp: "/web/icss/empPost/searchDmsTemp.jhtml", // 操作维度搜索模板
        getDmsTitle: "/web/icss/empPost/getDmsTitle.jhtml", //w维度名称
        getAddLocationList: "/web/icss/placeCollect/searchPlaceCollectsByPage.jhtml", //根据分页查询条件获取考勤地点数据采集信息
        getAddLocationSearch: "/web/icss/placeCollect/searchPlaceCollectsTemp.jhtml", //获取数据采集搜索条件
        getAddLocationDetail: "/web/icss/placeCollect/selectPlaceCollectById.jhtml", //获取数据采集详情
        DelAddLocation: "/web/icss/placeCollect/deletePlaceCollectById.jhtml", //删除数据采集详情
        saveQuickViewFinalSet: "/web/icss/quickViewFinalSet/saveQuickViewFinalSet.jhtml", //月报定稿新增
        updateQuickViewFinalSet: "/web/icss/quickViewFinalSet/updateQuickViewFinalSet.jhtml", //月报定稿修改
        getStateBypItemId: "/web/icss/quickViewFinalSet/getStateBypItemId.jhtml", //月报定稿是否能修改
        getQuickViewFinalSetBypItemId: "/web/icss/quickViewFinalSet/getQuickViewFinalSetBypItemId.jhtml", //根据考勤获取实体
        collectAttData: "/web/vitasoy/esbAttMonth/collectAttData.jhtml", //收集月报信息
        pushEsbAttendance: "/web/vitasoy/esbAttMonth/pushEsbAttendance.jhtml", //推送铂金
        searchSchemaChangeTemp: "/web/attSchemaChange/searchSchemaChangeTemp.jhtml", //高级筛选
        queryAttSchemaEmpPage: "/web/attSchemaChange/queryAttSchemaEmpPage.jhtml", //列表接口
        saveAttSchemaEmp: "/web/attSchemaChange/saveAttSchemaEmp.jhtml", //保存接口
        searchSchemaChangeHisTemp: "/web/attSchemaChange/searchSchemaChangeHisTemp.jhtml", //历史高级筛选
        queryAttSchemaEmpHisPage: "/web/attSchemaChange/queryAttSchemaEmpHisPage.jhtml", //调整班次列表历史
        getSchemaChangeDetail: "/web/attSchemaChange/getSchemaChangeDetail.jhtml", //获取调整班次详情
        getAttSchemaDetail: "/web/attSchemaChange/getAttSchemaDetail.jhtml", //获取调整班次数据
    },
    HolPool: {
        newYearList: '/web/attHolYear/queryAttHolYearPage.jhtml', //年假列表
        newYearSer: '/web/attHolYear/searchAttHolYearTemp.jhtml', //年假搜索
        newYearEdit: '/web/attHolYear/getAttHolYearForm.jhtml', //年假修改
        newYearUpdata: '/web/attHolYear/updateAttHolYear.jhtml', //年假修改保存
        newYearCal: '/web/attHolYear/calculationYearHol.jhtml', //年假计算
        NewHistory: '/web/attHolYearRestTrash/queryAttHolYearTrashPage.jhtml', //年假历史
        NewClearBack: '/web/attHolYearRestTrash/backAttHolYearRestRecords.jhtml', //年假恢复
        NewClearBackNewyear: '/web/attHolYearRestTrash/newyear/backAttHolYearRestRecords.jhtml', //年假恢复 --CSY
        NewClearBackSickhol: '/web/attHolYearRestTrash/Sickhol/backAttHolYearRestRecords.jhtml', //年假恢复 --csy
        NewHistorySer: '/web/attHolYearRestTrash/searchAttHolYearTrashTemp.jhtml', //
        newexports: '/web/attHolYear/exportAttHolYearExcel.jhtml', //年假导出
        dayOffList: '/web/attHolRest/queryAttHolRestPage.jhtml', //调休列表
        dayOffSer: '/web/attHolRest/searchAttHolRestTemp.jhtml', //调休搜索
        dayOffEdit: '/web/attHolRest/getAttHolRestForm.jhtml', //调休编辑获取数据
        dayOffUpdate: '/web/attHolRest/updateAttHolRest.jhtml', //调休保存
        dayOffHis: '/web/attHolYearRestTrash/queryAttHolRestTrashPage.jhtml',
        dayOffHisSer: '/web/attHolYearRestTrash/searchAttHolReshTrashTemp.jhtml',
        dayoffexports: '/web/attHolRest/exportAttHolRestExcel.jhtml', //调休导出
        sickList: '/web/attHolSick/queryAttHolSickByPage.jhtml', //带薪病假
        sickSer: '/web/attHolSick/getAttSickSearchTemplate.jhtml', //带薪病假搜索
        sickexports: '/web/attHolSick/exportAttHolSick.jhtml', //病假导出
        dayoffDownLoadApi: '/web/attHolRest/exportAttRestTemplate.jhtml',
        dayoffImportApi: '/web/attHolRest/importAttHolRestExcel.jhtml',
        yearDownLoadApi: '/web/attHolYear/exportAttHolYearTemplate.jhtml',
        yearImportApi: '/web/attHolYear/importAttHolYearExcel.jhtml',
        sickdownLoadApi: '/web/attHolSick/exportAttSickTemplate.jhtml',
        sickImportApi: '/web/attHolSick/importAttHolSick.jhtml',
        advanceHol: '/web/attHolCreditYear/queryByPage.jhtml', //预支年假列表
        advanceExport: '/web/attHolCreditYear/exportExcel.jhtml', //预支年假导出
        advanceSer: '/web/attHolCreditYear/getSearchTemplate.jhtml', //预支年假搜索
        paydayoff: '/web/attHolPayRest/queryByPage.jhtml',
        paydayoff1: '/web/attHolPayRest/queryByPage.jhtml', //胡卫卫
        paySer: '/web/attHolPayRest/searchAttHolPayRestTemp.jhtml',
        payexport: '/web/attHolPayRest/exportExcel.jhtml',
        payimportdown: '/web/attHolPayRest/exportAttHolPayRestTemplate.jhtml',
        payExcel: '/web/attHolPayRest/importAttHolPayRestExcel.jhtml',
        Bxzywxport: '/web/attHolPayRest/exportBxzyExcel.jhtml', //导出
        Bxzytemp: '/web/attHolPayRest/exportBxzyTemplate.jhtml', //下载模板
        Bxzyimport: '/web/attHolPayRest/importBxzyExcel.jhtml',
        importExtraAttHolRest: "/web/attHolRest/importExtraAttHolRestExcel.jhtml", //批量新增导入
        exportExtraAttHolRest: "/web/attHolRest/exportExtraAttHolRestTemplate.jhtml", //下载上传模板
        importExtraAttHolPayRest: "/web/attHolPayRest/importExtraAttHolPayRestExcel.jhtml", //付费批量新增导入
        exportExtraAttHolPayRest: "/web/attHolPayRest/exportExtraAttHolPayRestTemplate.jhtml", //付费批量新增下载上传模板
        importExtraBxzy: "/web/attHolPayRest/importExtraBxzyExcel.jhtml", //HsBC批量新增导入
        exportExtraBxzy: "/web/attHolPayRest/exportExtraBxzyTemplate.jhtml", //HsBC批量新增下载上传模板
        YearAndCreditYear: "/web/attHolCreditYear/queryAttHolYearAndCreditYearByPage.jhtml", //年假列表
        YearPoolAndExpDateByEmpId: "/web/attHolYear/getListOfYearPoolAndExpDateByEmpId.jhtml", //员工年假详情列表
        YearCreditByEmpId: "/web/attHolCreditYear/listAttHolYearCreditByEmpId.jhtml", //员工预支年假列表
        queryHolPayRestTrash: "/web/attHolYearRestTrash/queryHolPayRestTrash.jhtml", //付费调休清零列表
        queryBxzyRestTrash: "/web/attHolYearRestTrash/queryBxzyRestTrash.jhtml", //HSBC调休清零列表

        vitasoyList: '/web/vitasoyAttHolYear/queryAttHolYearPage.jhtml', //公司福利年假列表
        vitasoyEdit: '/web/vitasoyAttHolYear/updateAttHolYear.jhtml', //公司福利编辑
        vitasoySer: '/web/vitasoyAttHolYear/searchAttHolYearTemp.jhtml', //公司福利搜索
        vitasoyGetData: '/web/vitasoyAttHolYear/getAttHolYearForm.jhtml', //公司福利获取接口
        vitasoyCal: '/web/vitasoyAttHolYear/calculationYearHol.jhtml', //公司福利年假计算
        vitasoyClear: '/web/vitasoyAttHolYear/clearAttHolYearRecords.jhtml', //公司福利年假清零
        vitasoyImpor: '/web/vitasoyAttHolYear/importAttHolYearExcel.jhtml', //公司福利年假导入
        vitasoyDownTemplate: '/web/vitasoyAttHolYear/exportAttHolYearTemplate.jhtml', //公司福利年假下载模板
        vitasoyExport: '/web/vitasoyAttHolYear/exportAttHolYearExcel.jhtml', //公司福利年假导出


    },
    Loan: {
        loanList: '/web/attEmpLoan/getAttEmpLoanByPage.jhtml', //借调列表
        deleLoan: '/web/attEmpLoan/deleteAttEmpLoan.jhtml', //删除借调
        loanEmp: '/web/attEmpLoan/addAttEmpLoan.jhtml', //借调员工
        getdept: '/web/deptInfo/getSimpleTree.jhtml',
        saveLoad: '/web/attEmpLoan/addAttEmpLoan.jhtml', //保存借调

    },
    orgin: {
        getsetlist: '/web/setDataDimension/listDimension.jhtml',
        adddimsion: '/web/setDataDimension/addDimension.jhtml',
        deldimsion: '/web/setDataDimension/deleteDimension.jhtml', //删除维度
        deldimsionfield: '/web/setDimensionShowCols/deleteSetDimensionShowCols.jhtml', //删除维度字段
        updatedimsion: '/web/setDataDimension/updateDimension.jhtml', //编辑维度
        updatedimfield: '/web/setDimensionShowCols/updateSetDimensionShowCols.jhtml', //编辑维度字段
        updatedimfieldsw: '/web/setDimensionShowCols/updatedimfieldsw/updateSetDimensionShowCols.jhtml', //编辑维度字段----许婧媛
        adddimsionfield: '/web/setDimensionShowCols/addSetDimensionShowCols.jhtml', //添加维度字段
        dimsionList: '/web/setDataDimension/getDimensions.jhtml', //获取组织结构维度列表
        deptTree: '/web/deptInfo/getOrgTree.jhtml', //多维度组织树
        listDimension: 'web/setDataDimension/listDimension.jhtml'

    },
    attenset: {
        cycleList: '/web/custPeriodSchedule/queryCustPeriodSchedulePage.jhtml',
        addcyclelist: '/web/custPeriod/getCustPeriod.jhtml', //获取创建周期信息
        addsave: '/web/custPeriod/saveCustPeriod.jhtml', //创建考勤周期
        geteditdata: '/web/custPeriodSchedule/openUpdateCustPeriodSchedule.jhtml',
        editsave: '/web/custPeriodSchedule/updateCustPeriodSchedule.jhtml',
        attlist: '/web/attSetSchemaNew/findAttSetSchemaByPage.jhtml',
        deleatt: '/web/attSetSchemaNew/deleteAttSetSchema.jhtml',
        getaddatt: '/web/attSetSchemaNew/getAddAttSetSchemaParam.jhtml',
        updatestates: '/web/attSetSchemaNew/updateAttSetSchemaOfStatus.jhtml',
        updatesave: '/web/attSetSchemaNew/updateAttSetSchema.jhtml',
        attensave: '/web/attSetSchemaNew/saveAttSetSchema.jhtml',
        getupdatarule: '/web/attSetSchemaNew/getAttSetSchemaByPK.jhtml',
        listSer: '/web/attSetSchemaNew/getSearchTemplate.jhtml',
        details: '/web/attSetSchemaNew/queryAttSetSchemaByPk.jhtml',

    },
    specialhol: {
        list: '/web/attSetSpecialDay/queryAttOverApplyPage.jhtml',
        updatestates: '/web/attSetSpecialDay/updateAttSetSpecialDayState.jhtml',
        delhol: '/web/attSetSpecialDay/deleteAttSetSpecialDay.jhtml',
        getdatas: '/web/attSetSpecialDay/openSaveAttSetSpecialDay.jhtml',
        addhol: '/web/attSetSpecialDay/saveAttSetSpecialDay.jhtml',
        getupdate: '/web/attSetSpecialDay/getAttSetSpecialDayDetail.jhtml',
        saveupdate: '/web/attSetSpecialDay/updateAttSetSpecialDay.jhtml',

    },
    holdayset: {
        list: '/web/attSetHolidayMain/listHolidayMainByPage.jhtml',
        listHol: '/web/attSetHolidayMain/hol/listHolidayMainByPage.jhtml', //--csy
        delholday: '/web/attSetHolidayMain/del/updateAttSetHolidayMain.jhtml',
        delholdayHol: '/web/attSetHolidayMain/delHol/updateAttSetHolidayMain.jhtml',
        updatestates: '/web/attSetHolidayMain/updateAttSetHolidayMain.jhtml',
        updatestates1: '/web/attSetHolidayMain/updatestates1/updateAttSetHolidayMain.jhtml', //胡卫卫
        updatestates2: '/web/attSetHolidayMain/updatestates2/updateAttSetHolidayMain.jhtml', //胡卫卫
        addlist: '/web/attSetHoliday/getAttSetHolidayDic.jhtml',
        addlist1: '/web/attSetHoliday/addlist1/getAttSetHolidayDic.jhtml', //胡卫卫
        getrelue: '/web/attSetHolidayMain/getHolidayMainByPage.jhtml',
        getrelue1: '/web/attSetHolidayMain/getrelue1/getHolidayMainByPage.jhtml', //胡卫卫
        addsave: '/web/attSetHolidayMain/saveAttSetHolidayMain.jhtml',
        shiupdate: '/web/attSetHoliday/updateAttSetHoliday.jhtml',
        shiupdate1: '/web/attSetHoliday/shiupdate1/updateAttSetHoliday.jhtml',
        shiadd: '/web/attSetHoliday/addAttSetHoliday.jhtml',
        shiaddHol: '/web/attSetHoliday/hol/addAttSetHoliday.jhtml', //--csy
        qitaupdate: '/web/attSetHolidayTemplate/saveAttSetHolidayTemplate.jhtml',
        newupdate: '/web/attSetHolidayYearNew/updateAttSetHolidayYearNew.jhtml',
        dayoffupdate: '/web/attSetHolidayRest/updateAttSetHolidayRest.jhtml',
        delpagelist: '/web/attSetHoliday/deleteAttSetHoliday.jhtml',
        getupdate: '/web/attSetHoliday/getAttSetHolidayDetail.jhtml',
        getupdateHol: '/web/attSetHoliday/hol/getAttSetHolidayDetail.jhtml', //--csy
        newdetail: '/web/attSetHolidayYearNew/getAttSetHolidayYearNewDetail.jhtml',
        newadd: '/web/attSetHolidayYearNew/saveAttSetHolidayYearNew.jhtml',
        getrest: '/web/attSetHolidayRest/queryAttSetHolidayRest.jhtml',
        restadd: '/web/attSetHolidayRest/addAttSetHolidayRest.jhtml',
        addholtemp: '/web/attSetHolidayTemplate/addAttSetHolidayTemplate.jhtml',
        savetemp: '/web/attSetHolidayTemplate/saveAttSetHolidayTemplate.jhtml',
        gettemp: '/web/attSetHolidayTemplate/getAttSetHolidayTemplate.jhtml'

    },
    locations: {
        list: '/web/attSetLocation/findSetLocationByPage.jhtml',
        dellocation: '/web/attSetLocation/deleteSetLocation.jhtml',
        getupdate: '/web/attSetLocation/getSetLocationByPk.jhtml',
        updatesave: '/web/attSetLocation/updateAttSetLocation.jhtml',
        addsave: '/web/attSetLocation/saveAttSetLocation.jhtml',
        updatestates: '/web/attSetLocation/updateState.jhtml',
        listSer: '/web/attSetLocation/getSearchTemplate.jhtml',
    },
    wifi: {
        wifilist: '/web/attSetWifiCheck/findSetWifiCheckByPage.jhtml',
        savewifi: '/web/attSetWifiCheck/saveSetWifiCheck.jhtml',
        wifistatus: '/web/attSetWifiCheck/updateState.jhtml',
        delewifi: '/web/attSetWifiCheck/removeWifiId.jhtml',
        getwifi: '/web/attSetWifiCheck/getAttRelWifiDept.jhtml',
        updatewifi: '/web/attSetWifiCheck/updateWifiData.jhtml'
    },
    approvework: {
        list: '/web/attExamGrant/getPage.jhtml',
        canclework: '/web/attExamGrant/cancelAttExamGrant.jhtml',
        saveapprove: '/web/attExamGrant/saveAttExamGrant.jhtml',
        getleveapp: '/web/attExamerExchangeLog/getAppvLevelEmpByDeptId.jhtml',
    },
    custom: {
        list: '/web/setShowCols/getSetShowColsOfCustTable.jhtml', //自定义表列表
        deletableitem: '/web/customTable/deleteCustomTableItem.jhtml',
        deletable: '/web/customTable/deleteCustomTable.jhtml',
        addtable: '/web/customTable/addCustomTable.jhtml',
        updatetable: '/web/customTable/updateCustomTable.jhtml', //修改自定义表
        getdic: '/web/setShowCols/getSetShowColsDict.jhtml',
        addfield: '/web/customTable/addCustomTableItem.jhtml',
        updatestate: '/web/setShowCols/updateIsShowState.jhtml',
    },
    importinfo: {
        infolist: '/web/roleFields/getAuRoleRelFieldListByPage.jhtml',
        dele: '/web/roleFields/delete.jhtml',
        updatestate: '/web/roleFields/updateAuRoles.jhtml',
        saveimport: '/web/roleFields/saveAuRolesRelFields.jhtml',
        getfield: '/web/roleFields/getTemp.jhtml',

    },
    proof: {
        prooflist: '/web/certificateTemplate/queryCertificateTemplateByPage.jhtml',
        deleproof: '/web/certificateTemplate/deleteCertificateTemplate.jhtml',
        getproof: '/web/certificateTemplate/getCertificateTemplate.jhtml',
        addproof: '/web/certificateTemplate/addCertificateTemplate.jhtml',
        updateproof: '/web/certificateTemplate/updateCertificateTemplate.jhtml',

    },
    post: {
        downtemp: '/web/posLevel/downLaodDeptPosLevelTemp.jhtml',
        imports: '/web/posLevel/importDeptPosLevelExcel.jhtml'
    },
    org: { //组织结构导入
        downtemp: '/web/deptInfo/downloImportTemplate.jhtml',
        imports: '/web/deptInfo/importExcel.jhtml',
        downBatchDelTemp: "/web/deptInfo/downloadBatchRemoveTemplate.jhtml",
        importBatchDel: "/web/deptInfo/importBatchRemove.jhtml"
    },
    reportline: {
        addline: '/web/deptPositionLevelRelation/addDeptPositionLevelRelation.jhtml',
        getlinedata: '/web/deptPositionLevelRelation/getDeptPositionLevelRelations.jhtml',
        updateline: '/web/deptPositionLevelRelation/updateDeptPositionLevelRelation.jhtml',
        list: '/web/deptPositionLevelRelation/queryByPage.jhtml',
        postdept: '/web/posLevel/getDeptPosLevelByDeptId.jhtml',
        lineDetail: '/web/deptPositionLevelRelation/getDeptPositionLevelRelationsByDeptId.jhtml',
        deleteline: '/web/deptPositionLevelRelation/deleteDeptPositionLevelRelation.jhtml',
    },
    idle: {
        list: '/web/icss/attIdleEmp/findAttIdleEmpInfoByPage.jhtml',
        search: '/web/icss/attIdleEmp/searchAttIdleEmpInfo.jhtml',
        exportIdle: '/web/icss/attIdleEmp/exportAttIdleEmpInfo.jhtml',
        downIdle: '/web/icss/attIdleEmp/downIdleTemplate.jhtml',
        uploadIdle: '/web/icss/attIdleEmp/uploadIdleTemplate.jhtml'
    },
    icssdaily: {
        region: '/web/icss/attDailyData/findIcssAttDailyRegion.jhtml',
        downd: '/web/icss/attDailyData/downExcepTemp.jhtml',
        uplond: '/web/icss/attDailyData/uploadExcel.jhtml'
    },
    sparepost: {
        list: '/emp/alternative/dept/getListPage.jhtml', // 列表
        del: '/emp/alternative/dept/delAlternativeDept.jhtml', // 删除
        delBatch: '/emp/alternative/dept/batch/delAlternativeDept.jhtml', // 删除 --csy
        search: '/emp/alternative/dept/searchTemplate.jhtml', // 搜索
        exp: '/emp/alternative/dept/export.jhtml', //导出列表
        down: '/emp/alternative/dept/downLoadAddTemplate.jhtml', // 下载模板
        upload: '/emp/alternative/dept/upload.jhtml', // 上传
        save: '/emp/alternative/dept/saveAlternativeDept.jhtml', // 保存
        update: '/emp/alternative/dept/updateAlternativeDept.jhtml', // 更新
        get: '/emp/alternative/dept/get.jhtml' // 数据回显
    },
    empAttNameDataHistory: {
        list: '/web/empAttNameDataHistory/queryLogEmpAttWhiteChangeByPage.jhtml',
        search: '/web/empAttNameDataHistory/searchTemplate.jhtml',
        exp: '/web/empAttNameDataHistory/exportHistoryLogEmp.jhtml'
    },
    bianzhiApi: {
        getListPage: "/web/authorized/strength/statistics/getListPage.jhtml", //获得编制统计列表
        getBranchTree: "/web/authorized/strength/statistics/getBranchTree.jhtml", //获得部门树
        downLondExcel: "/web/authorized/strength/statistics/downLondExcel.jhtml", //导出
        getPostTypeLevelType: '/AuthorizedStrength/getPostTypeLevelType.jhtml', //根据部门获取职级
        insertAuthorizedStrength: "/AuthorizedStrength/insertAuthorizedStrength.jhtml", //编制保存
        getAuthorizedStrength: "/AuthorizedStrength/getAuthorizedStrength.jhtml", //获取编制列表
        getAuthorizedStrengthEdit: "/AuthorizedStrength/Edit/getAuthorizedStrength.jhtml", //获取编制列表  --csy
        getEmpInfoWithNoAuthStren: "/AuthorizedStrength/getEmpInfoWithNoAuthStren.jhtml", //获取无编制人员列表
        getEmpInfoWithNoAuthStrenEdit: "/AuthorizedStrength/Edit/getEmpInfoWithNoAuthStren.jhtml", //获取无编制人员列表 --csy
        updateAuthorizedStrengthDetail: "/AuthorizedStrength/updateAuthorizedStrengthDetail.jhtml", //编制人员信息修改
        deleteAuthorizedStrength: "/AuthorizedStrength/deleteAuthorizedStrength.jhtml", //解除人员编制
        addDictionaryForPostLevelTpye: "/AuthorizedStrength/addDictionaryForPostLevelTpye.jhtml", //新增职级
        addDictionaryForDeptStaffRank: "/AuthorizedStrength/addDictionaryForDeptStaffRank.jhtml", //新增员工等级
        addDictionaryForPostTpye: "/AuthorizedStrength/addDictionaryForPostTpye.jhtml", //新增职位类型
        getPostLevelType: "/AuthorizedStrength/getPostLevelType.jhtml", //获取职位等级列表
        updatePostLevelType: '/AuthorizedStrength/updatePostLevelType.jhtml', //职位等级修改删除
        getPostType: "/AuthorizedStrength/getPostType.jhtml", //获取职位类型列表
        updatePostType: "/AuthorizedStrength/updatePostType.jhtml", //职位类型修改删除
        getDeptStaffRank: "/AuthorizedStrength/getDeptStaffRank.jhtml", //获取员工等级列表
        updateDeptStaffRank: "/AuthorizedStrength/updateDeptStaffRank.jhtml", //员工等级修改删除
        downExcel: "/web/authorized/strength/statistics/downExcel.jhtml", //新增数据下载模板
        uploadExcel: "/web/authorized/strength/statistics/uploadExcel.jhtml", //新增数据导入
        downAuthorizedExcel: "/web/authorized/strength/statistics/downAuthorizedExcel.jhtml", //修改数据更新数据的下载模板
        uploadUpdateExcel: "/web/authorized/strength/statistics/uploadUpdateExcel.jhtml", //修改数据的上传
        downDetailExcel: "/web/authorized/strength/statistics/downDetailExcel.jhtml", //编制明细导出
        distributionAuthorizedStrength: "/AuthorizedStrength/distributionAuthorizedStrength.jhtml", //分配编制保存
        removeAuthorizeds: "/web/authorized/strength/statistics/removeAuthorizeds.jhtml", //编制删除
        modifyAuthorizeds: "/web/authorized/strength/statistics/modifyAuthorizeds.jhtml", //编制调整
        queryPostTypeById: "/AuthorizedStrength/queryPostTypeById.jhtml", //获取职位类型，数据回显
        queryPostLevelType: "/AuthorizedStrength/queryPostLevelType.jhtml", //获取职位等级，数据回显
        queryDeptStaffRank: "/AuthorizedStrength/queryDeptStaffRank.jhtml", //获取员工等级，数据回显
        getAuthorizedStrengthById: "/AuthorizedStrength/getAuthorizedStrengthById.jhtml", //修改编制数据回显
    },
    kaoqinApi: {
        getCDList: '/web/attEmpDetail/getCDList.empweb',
        getAdd: '/web/attSetLocation/getAdd.empweb',
        getAttEmpDetailByEmpIdOfStatCurDay: '/web/attEmpLog/getAttEmpDetailByEmpId.empweb', //每天考勤统计
        getSysDate: '/web/attEmpLog/getSysDate.empweb', //获取系统时间
        getAttEmpDeatilByMonth: "/web/attEmpDetail/getAttEmpDeatilByMonth.empweb", //每月考勤统计
        getAttEmpDetailByEmpIdOfStat: '/web/attEmpLog/getAttEmpDetailByEmpIdOfStat.empweb', //统计
        getAttEmpDetailByEmpId: '/web/attEmpLog/getAttEmpDetailByEmpId.empweb', //获取考勤列表
        getAttEmpLogByEmpId: '/web/attEmpLog/getAttEmpLogByEmpId.empweb', //获取考勤列表(日历)
        getAttEmpLogByEmpId2: '/web/attEmpLog/getAttEmpLogByEmpId2.empweb',
        saveAttEmpLog: '/web/attEmpLog/saveAttEmpLog.empweb', //考勤
        getLastAttEmpLog: '/web/attEmpLog/getLastAttEmpLog.empweb', //获取打卡时间
        getEmpStMonthQuickViewIcc: '/web/icss/AttStMonthQuickViewIcss/getEmpStMonthQuickViewIcc.empweb', //获取月考勤记录
        getOwnPlaceList: "/web/attLocationApply/getOwnPlaceList.empweb", //获取打卡地址
        getLocSetDataByPage: "/web/icssAttEmpDetail/getLocSetDataByPage.empweb", //查看打卡数据
        getIcssUnsendAbnormalMessage: "/web/icss/unsendAbnomalMessage/getIcssUnsendAbnormalMessage.jhtml", //获取列表
        save: "/web/icss/unsendAbnomalMessage/save.jhtml", //保存
        editsave: "/web/icss/unsendAbnomalMessage/edit/save.jhtml", //修改保存
        saveAttEmp: "/web/icss/empAttNameData/saveAttEmp.jhtml", //新增
        delAttEmp: "/web/icss/empAttNameData/delAttEmp.jhtml", //删除
        getAttEmpListPage: "/web/icss/empAttNameData/getAttEmpListPage.jhtml", //列表
        searchTemplatenow: "/web/icss/empAttNameData/searchTemplate.jhtml", //高级筛选
        export: "/web/icss/empAttNameData/export.jhtml", //导出
        downLoadAddTemplate: "/web/icss/empAttNameData/downLoadAddTemplate.jhtml", //下载模板
        upload: "/web/icss/empAttNameData/upload.jhtml", //导入
        queryLogEmpAttWhiteChangeByPage: "/web/icss/empAttNameDataHistory/queryLogEmpAttWhiteChangeByPage.jhtml", //历史列表
        searchTemplate: "/web/icss/empAttNameDataHistory/searchTemplate.jhtml", //历史高级筛选
        exportHistoryLogEmp: "/web/icss/empAttNameDataHistory/exportHistoryLogEmp.jhtml", //历史导出

    },
    wageApi: {
        passwordIsOk: '/secondpassword/passwordIsOk.empweb', //验证密码是否正确
        updateSecondPassword: '/secondpassword/updateSecondPassword.empweb', //更改密码
        sendVerifyCode: '/secondpassword/sendVerifyCode.empweb', //发送验证码
        saveSecondPassword: '/secondpassword/saveSecondPassword.empweb', //保存密码
        isHasPassword: '/secondpassword/isHasPassword.empweb', //判断有没有密码
        PayDetails: "/web/payslip/findUserPayDetails.empweb",
        findUserPayList: "/web/payslip/findUserPayListByPage.empweb",
        updatePayEmpCheckState: "/web/payslip/updatePayEmpCheckState.empweb",

    },
    HolidayApi: {
        getApplyTypeAndNum: '/web/commonApply/getApplyTypeAndNum.empweb', //获取申请类型
        addAttHolApply: '/web/attHolApply/addAttHolApply.empweb', //假期申请提交接口
        getHolApplyHours: '/web/attHolApply/getHolApplyHours.empweb', //假期申请获取时长
        getAttSetHoliday: '/web/attSetHoliday/getAttSetHoliday.empweb', //获取假期列表
        getPageWaitSelect: '/web/attRelExamStepSelfSelect/getPageWaitSelect.empweb', //获取固定审批流列表
        getAttSetHolidayOfOutAddress: '/web/attSetHoliday/getAttSetHolidayOfOutAddress.empweb', //获得公出申请
        empUplaod: "/web/UpLoadFile/upload.empweb", //附件上传
        getNewFlowControlStateEmp: "/web/flowControl/getExamType.empweb", //是否审批 新
        queryAttHolReducePage: "/web/attHolReduceApply/queryAttHolReducePage.empweb", //获得销假选假列表
        getAttHolApplyRecords: '/web/attHolApply/getAttHolApplyRecords.empweb', //假期申请记录
        otherHistory: '/web/attExamStep/getAttExamStepAllowReapplyPage.empweb', //其他申请列表接口
        insertHoldayReduce: "/web/attHolReduceApply/insertHoldayReduce.empweb", //销假申请
        queryOneAttHolReducePage: '/web/attHolReduceApply/queryOneAttHolReducePage.empweb', //查询个人销假记录
        queryAttHolApplyByPage: '/web/attHolApply/queryAttHolApplyByPage.empweb',
        queryOutAddressByPage: "/web/attOutAddress/queryOutAddressByPage.empweb", //公出申请记录
        getTotalHourOfChanJianForOnce: '/web/attHolApply/getTotalHourOfChanJianForOnce.empweb', //获取产检假累计时长 
        queryAttOverApplyWithRestByPage: "/web/icss/attOverApplyWithRest/queryAttOverApplyWithRestByPage.empweb", //夜班补休详情
        queryByPage: "/web/icss/attOverApplyWithRest/queryByPage.empweb", //夜班/华为申请记录
    },
    WorkOvertimeApi: {
        openAttOverapply: '/web/attOverApply/openAttOverapply.empweb', //是否开启加班申请权限
        getInfo: '/web/batchWorkOver/getApplyDetail.empweb', //获取批量加班详情
        getGroupExamStepInfo: '/web/attOverApply/getAttOverApplyAndGroupExamStepInfo.empweb', //获取批量加班详情
        saveAttOverGroupApplyAgainInitiate: "/web/batchWorkOver/saveAttOverGroupApplyAgainInitiate.empweb", //重新发起批量加班
        overworkJilu: '/web/attOverApply/queryAttOverApplyPage4Mobile.empweb', //加班申请记录
        getAttExamStepDetailFromApply: '/web/attExamStep/getAttExamStepDetailFromApply.empweb', //加班申请列表
        revokeApply: '/web/attExamStep/revokeApply.empweb', //撤销申请
        getHours: '/web/attOverApply/getAttOverHours.empweb', //获取加班时长
        saveOverWork: '/web/attOverApply/saveAttOverApply.empweb', //保存加班
        confirmOverWork: '/web/attOverApply/saveAttOverApplyConfirm.jhtml', //确认加班补充信息
        newSave: "/web/zr/batchWorkOver/perfectAttOverApplyList.empweb", //新的批量加班（多条数据保存）
        perfectAttOverApply: "web/batchWorkOver/perfectAttOverApply.empweb", //批量加班保存
        queryOneAttHolReducePage: "/web/attOverApply/queryOneAttHolReducePage.empweb", //查询加班记录
        getIsItHuawei: '/web/zr/batchWorkOver/getIsItHuawei.jhtml', //判断是否是华为
        getOverRestApplyShowInfo: '/web/icss/attOverApplyWithRest/getOverRestApplyShowInfo.empweb',
        queryAttOverApplyPage: "/web/attOverApply/queryAttOverApplyPage.empweb", //延时工作/加班申请记录
        getManageList: "/web/batchWorkOver/getManageList.empweb", //延时工作/加班申请记录最新
        findBatchOvertimeApplicationRecord: "/web/attOverApply/findBatchOvertimeApplicationRecord.empweb", //延时工作/加班申请记录最新
        getIsHuaWei: "/web/icss/empBaseInfo/getIsHuaWei.empweb", //是否是华为群	
        getAttOverApplyDetail: "/web/attOverApply/getAttOverApplyDetail.jhtml", //获取预加班详情
        getHoursByHr: '/web/attOverApply/getAttOverHours.jhtml', //获取加班时长
        checkHavePass:"/payslip/wxLookHtml/checkHavePass.empweb",
    },
    SupplementApplicationApi: {
        isSaveAttCheckApply: '/web/attCheckApply/isSaveAttCheckApply.empweb', //是否允许补签
        saveAttCheckApply: '/web/attCheckApply/saveAttCheckApply.empweb' //保存补签
    },
    applyApi: {
        getPageApply: "/web/commonApply/getPageApply.empweb", //员工端申请记录新接口
        getRejectNum: '/web/commonApply/getRejectNum.empweb', //获得没查看的驳回的申请数量
        updateCheckFromWho: '/web/attExamStep/updateCheckFromWho.empweb', //发起人查看后修改查看状态

        queryApplyDetail: '/web/attHolidayDelay/queryApplyDetail.empweb', //年度列表
        addAttHolidayDelay: '/web/attHolidayDelay/addAttHolidayDelay.empweb', //年度延休提交
        queryAttHolidayDelayByPage: '/web/attHolidayDelay/queryAttHolidayDelayByPage.empweb', //年度延休申请列表

        getAttExamStepAllowReapplyPage: "/web/attExamStep/getAttExamStepAllowReapplyPage.empweb", //我的申请
        revokeApply: "/web/attExamStep/revokeApply.empweb", //发起人撤销申请
        queryAttCheckApplyByPage: '/web/attCheckApply/queryAttCheckApplyByPage.empweb', //补签历史记录
        queryAttCheckApplyByPage2: '/web/attCheckApply/queryAttCheckApplyByPage2.empweb', //员工端补签记录
        queryByPage: "web/attLocationApply/queryByPage.empweb", //考勤地点申请记录
        getSinglePlaceByPage: "/web/attLocationApply/getSinglePlaceByPage.empweb", //考勤地点申请记录
    },
    SelfApi: {
        saveFlowCustApplySetting: '/web/flowCustApply/saveFlowCustApplySetting.empweb', //保存自定义申请
        getFlowCustApplySettingList: '/web/flowCustApplySetting/getFlowCustApplySettingList.empweb', //获取自定义类型列表
        queryFlowCustApplyPage: '/web/flowCustApply/queryFlowCustApplyPage.empweb', //自定义申请列表
        queryFlowCustApplyPage4Pc: '/web/flowCustApply/queryFlowCustApplyPage4Pc.empweb',
        getFlowCustApplySettingDetails: '/web/flowCustApplySetting/getFlowCustApplySettingDetails.empweb', //自定义

    },
    leave: {
        list: '/web/attHolRest/getAttHolYearRestRecords.empweb'
    },
    empApi: {
        addAdjTempByEmp: "/web/salaryAdj/addAdjTemp.empweb", //调薪页面信息加载
        saveEmpSalaryAdjByEmpIdByEmp: "/web/salaryAdj/saveEmpSalaryAdjByEmpId.empweb" //调薪保存接口
    },
    directModifyApi: {
        findDirectSupervisorByPage: '/web/empBaseInfoNew/findDirectSupervisorByPage.jhtml', //列表
        searchDirectSupervisorTemp: '/web/empBaseInfoNew/searchDirectSupervisorTemp.jhtml', //搜索模板
        downLondDirectSupervisor: '/web/empBaseInfoNew/downLoadDirectSupervisor.jhtml', //导出
        removeDirectSupervisorByEmpIds: '/web/empBaseInfoNew/removeDirectSupervisorByEmpIds.jhtml', //清空
        saveDirectSupervisorByEmpIds: '/web/empBaseInfoNew/saveDirectSupervisorByEmpIds.jhtml', //修改直接主管
        downLoadAddTemplate: '/web/empBaseInfoNew/downLoadDirectSupervisorTemp.jhtml',
        addUpload: '/web/empBaseInfoNew/uploadDirectSupervisorByExcel.jhtml'
    },
    empallowance: {
        getAddTemplateList: "/web/empSubsidyProject/getHandlingListPage.jhtml", //调整津贴列表
        searchHandlingTemp: "/web/empSubsidyProject/searchHandlingTemp.jhtml", //调整津贴搜索
        getListPage: "/web/empSubsidyProject/getListPage.jhtml", //已生效列表
        getWaitingListPage: "/web/empSubsidyProject/getWaitingListPage.jhtml", //待生效列表
        searchTemp: "/web/empSubsidyProject/searchTemp.jhtml", //已生效，待生效搜索    	
        getHandlingListPage: "/web/empSubsidyProject/getAddTemplateList.jhtml", //获取调薪信息
        empSubsidyProject: "/web/empSubsidyProject/empallowance/save.jhtml", //发起审批 胡卫卫
        importExcel: "/web/empSubsidyProject/importExcel.jhtml", //导入
        downLoadAddTemp: "/web/empSubsidyProject/downLoadAddTemp.jhtml", //下载模板
        exportWaitingList: "/web/empSubsidyProject/exportWaitingList.jhtml", //未生效列表导出
        exportList: "/web/empSubsidyProject/exportList.jhtml", //已生效列表导出
        getHisEmpSalaryListPage: "/web/salaryAdj/getHisEmpSalaryListPage.jhtml", //获取调薪历史列表
        histSearchTemp: "/web/salaryAdj/histSearchTemp.jhtml", //调薪历史搜索模板
        getNoEnableEmpSalaryListPage: "/web/salaryAdj/getNoEnableEmpSalaryListPage.jhtml", //调薪待生效列表
        noEnableSearchTemp: "/web/salaryAdj/noEnableSearchTemp.jhtml", //调薪待生效搜索模板接口
        handelSearchTemp: "/web/salaryAdj/handelSearchTemp.jhtml", //调薪办理搜索模板接口
        getHandlingEmpSalaryListPage: "/web/salaryAdj/getHandlingEmpSalaryListPage.jhtml", //调薪办理列表
        revokeApply: "/web/attExamStep/salary/revokeApply.jhtml", //撤销调薪 
        addAdjTemp: "/web/salaryAdj/addAdjTemp.jhtml", //获取调薪申请数据
        getAttExamStepDetail: "/web/attExamStep/getAttExamStepDetail.jhtml", //查看员工调薪明细
        saveEmpSalaryAdjByEmpId: "/web/salaryAdj/saveEmpSalaryAdjByEmpId.jhtml", //调薪申请保存

    },
    emppowerSet: {
        powerlist: '/web/appIconSource/getByParentIconId.jhtml', //员工权限设置列表
        getLimitByAppId: "/web/appIconSource/getLimitByAppId.jhtml", //员工权限设置回显数据
        searchLimitEmpInfosTemp: '/web/appIconSource/searchLimitEmpInfosTemp.jhtml', //员工权限搜索
        getLimitEmpInfosByPage: '/web/appIconSource/getLimitEmpInfosByPage.jhtml', //员工权限列表
        saveAppIconSourceLimits: '/web/appIconSource/saveAppIconSourceLimits.jhtml', //权限保存
        saveAppIconSourceLimitsDeptTiling: '/web/appIconSource/deptTiling/saveAppIconSourceLimits.jhtml', //权限保存   -csy
        saveAppIconSourceLimitsStation: '/web/appIconSource/station/saveAppIconSourceLimits.jhtml', //权限保存 --csy
        deleteAppIconSourceLimits: '/web/appIconSource/deleteAppIconSourceLimits.jhtml', //取消限制
        getAppIconSourceTree: '/web/appIconSource/getAppIconSourceTree.jhtml', //复制到
        saveCopyAppIconSourceLimits: '/web/appIconSource/saveCopyAppIconSourceLimits.jhtml', //复制权限保存
        getAllDeptPosLevels: '/web/posLevel/getAllDeptPosLevels.jhtml', //获取岗位
        ImportLimit: '/web/appIconSource/saveImportLimitEmpInfosExcel.jhtml', //导入
        exportLimit: '/web/appIconSource/exportLimitEmpInfosExcel.jhtml', //导出
        downloImportLimit: '/web/appIconSource/downloImportLimitEmpInfosTemplate.jhtml', //导出模板

    },
    manual: {
        manualSer: '/web/icss/AttStMonthQuickViewIcss/manualAttendanceSearchTemp.jhtml', //手工考勤搜索条件
        manualList: '/web/icss/AttStMonthQuickViewIcss/getManualAttendancePage.jhtml', //手工考勤列表
        downManualAttendanceTemp: '/web/icss/AttStMonthQuickViewIcss/downManualAttendanceTemp.jhtml', //手工考勤人员导入模板下载接口
        importManualAttendanceEmp: '/web/icss/AttStMonthQuickViewIcss/importManualAttendanceEmp.jhtml', //手工考勤人员导入
        downManualAttendanceMonth: '/web/icss/AttStMonthQuickViewIcss/downManualAttendanceMonth.jhtml',
        imporMonth: '/web/icss/AttStMonthQuickViewIcss/importManualAttendanceMonth.jhtml', //导入考勤月报
        monthDownExcepTemp: '/web/icss/attDailyData/monthDownExcepTemp/downExcepTemp.jhtml',
        monthUploadExcel: '/web/icss/AttStMonthQuickViewIcss/monthUploadExcel/uploadExcel.jhtml',

        monthDownExcepTemp1: '/web/icss/attDailyData/monthDownExcepTemp1/downExcepTemp.jhtml',
        monthUploadExcel1: '/web/icss/AttStMonthQuickViewIcss/monthUploadExcel1/uploadExcel.jhtml',
        monthDownExcepTemp2: '/web/icss/attDailyData/monthDownExcepTemp2/downExcepTemp.jhtml',
        monthUploadExcel2: '/web/icss/AttStMonthQuickViewIcss/monthUploadExcel2/uploadExcel.jhtml',
        monthDownExcepTemp3: '/web/icss/attDailyData/monthDownExcepTemp3/downExcepTemp.jhtml',
        monthUploadExcel3: '/web/icss/AttStMonthQuickViewIcss/monthUploadExcel3/uploadExcel.jhtml',

    },
    reportForm: {
        settlelist: '/web/icss/icssWorkOvertimeHolPayRest/queryHolPayReportByPage.jhtml',
        settleExport: '/web/icss/icssWorkOvertimeHolPayRest/exportHolPayReportExcel.jhtml',
        ompcalcul: '/web/icss/icssWorkOvertimeHolPayRest/doCaculate.jhtml',
        searchOmpTemp: '/web/icss/icssWorkOvertimeHolPayRest/searchOmpTemp.jhtml',
        leaveworklist: '/web/icss/icssWorkOvertimeHolPayRest/queryRestReportByPage.jhtml',
        leaveExport: '/web/icss/icssWorkOvertimeHolPayRest/exportRestReportExcel.jhtml',
        searchLeaveTemp: '/web/icss/icssWorkOvertimeHolPayRest/searchLeaveTemp.jhtml',
    },
    salarys: {
        tabIdlist: '/web/collectSet/queryCollectSetList.jhtml',
        salaryfieldSet: '/web/collectSet/queryCollectFieldList.jhtml', //薪酬字段设置列表
        salaryfieldSet1: '/web/collectSet/salaryfieldSet1/queryCollectFieldList.jhtml', //薪酬字段设置列表
        salaryfieldSet2: '/web/collectSet/salaryfieldSet2/queryCollectFieldList.jhtml', //薪酬字段设置列表
        salaryfieldSet3: '/web/collectSet/salaryfieldSet3/queryCollectFieldList.jhtml', //薪酬字段设置列表
        salaryfieldSet4: '/web/collectSet/salaryfieldSet4/queryCollectFieldList.jhtml', //薪酬字段设置列表
        salaryfieldSet5: '/web/collectSet/salaryfieldSet5/queryCollectFieldList.jhtml', //薪酬字段设置列表
        collectSyn: '/web/collectSet/syn.jhtml', //同步字段
        collectSyn1: '/web/collectSet/collectSyn1/syn.jhtml', //同步字段
        collectSyn2: '/web/collectSet/collectSyn2/syn.jhtml', //同步字段
        collectSyn3: '/web/collectSet/collectSyn3/syn.jhtml', //同步字段
        collectSyn4: '/web/collectSet/collectSyn4/syn.jhtml', //同步字段
        collectSyn5: '/web/collectSet/collectSyn5/syn.jhtml', //同步字段

        fieldSort: '/web/collectSet/fieldSort.jhtml', //页面排序
        queryExcelInfo: '/web/collectSet/queryExcelInfo.jhtml',
        saveExcelInfo: '/web/collectSet/saveExcelInfo.jhtml', //保存excel编辑信息

        modifyStatus: '/web/collectSet/modifyStatus.jhtml', //字段设置开关
        addCustomItem: '/web/collectSet/addCollectSetTab.jhtml', //新增自定义
        removeCollectSetTab: '/web/collectSet/removeCollectSetTab.jhtml', //删除自定义项目
        updateBatchFieldStatus: '/web/collectSet/updateBatchFieldStatus.jhtml',
        //员工数据采集
        ValidCollectSetList: '/web/collectSet/queryValidCollectSetList.jhtml',
        getSynTime: '/web/collect/emp/getSynTime.jhtml',
        getEmpBasePage: '/web/collect/emp/getEmpBasePage.jhtml', //基本信息列表
        getEmpBasePageSearch: '/web/collect/emp/getEmpBasePageSearch.jhtml', //基本信息搜索模板
        collectexportExcel: '/web/collectEmpBase/exportExcel.jhtml', //基本信息列表导出

        basedownHasTemp: '/web/collectEmpBase/basedownHasTemp/exportExcel.jhtml', //下载现有模板
        baseDownload: '/web/collectEmpBase/downloadTemplate.jhtml', //下载模板
        baseimportAdd: '/web/collectEmpBase/importAdd.jhtml', //导入新增
        baseimportModify: '/web/collectEmpBase/importModify.jhtml', //导入新增

        delEmpById: '/web/collectEmpBase/delEmpBaseById.jhtml', //删除
        getcollectField0: '/web/collectSet/EmpBase/queryVaildCollectFieldList.jhtml', //添加获取字段信息
        collectEmpAdd0: '/web/collectEmpBase/add.jhtml', //添加保存
        getcollectFieldEdit0: '/web/collectSet/EmpBaseEdit/queryVaildCollectFieldList.jhtml', //编辑获取字段信息
        getcollectById0: '/web/collectEmpBase/getById.jhtml', //获取编辑保存信息
        collectEmpEdit0: '/web/collectEmpBase/modify.jhtml', //编辑保存		


        getEmpBasePage1: '/web/collect/emp/getEmpAttPage.jhtml', //考勤信息列表
        getEmpBasePageSearch1: '/web/collect/emp/getEmpAttPageSearch.jhtml', //考勤信息搜索模板
        collectexportExcel1: '/web/collectEmpAtt/exportExcel.jhtml', //考勤信息列表导出

        EmpAttdownHasTemp: '/web/collectEmpAtt/EmpAttdownHasTemp/exportExcel.jhtml', //下载现有模板
        EmpAttDownload: '/web/collectEmpAtt/downloadTemplate.jhtml', //下载模板
        EmpAttimportAdd: '/web/collectEmpAtt/importAdd.jhtml', //导入新增
        EmpAttimportModify: '/web/collectEmpAtt/importModify.jhtml', //导入修改

        delEmpById1: '/web/collectEmpAtt/delEmpAttById.jhtml', //删除
        getcollectField1: '/web/collectSet/EmpAtt/queryVaildCollectFieldList.jhtml', //添加获取字段信息
        collectEmpAdd1: '/web/collectEmpAtt/add.jhtml', //添加保存
        getcollectFieldEdit1: '/web/collectSet/EmpAttEdit/queryVaildCollectFieldList.jhtml', //编辑获取字段信息
        getcollectById1: '/web/collectEmpAtt/getById.jhtml', //获取编辑保存信息
        collectEmpEdit1: '/web/collectEmpAtt/modify.jhtml', //编辑保存



        getEmpBasePage2: '/web/collect/emp/getEmpSoinPage.jhtml', //五险一金列表
        getEmpBasePageSearch2: '/web/collect/emp/getEmpSoinPageSearch.jhtml', //五险一金搜索模板
        collectexportExcel2: '/web/collectEmpSoin/exportExcel.jhtml', //五险一金列表导出

        EmpSoindownHasTemp: '/web/collectEmpSoin/EmpSoindownHasTemp/exportExcel.jhtml', //下载现有模板
        EmpSoinDownload: '/web/collectEmpSoin/downloadTemplate.jhtml', //下载模板
        EmpSoinimportAdd: '/web/collectEmpSoin/importAdd.jhtml', //导入新增
        EmpSoinimportModify: '/web/collectEmpSoin/importModify.jhtml', //导入修改

        delEmpById2: '/web/collectEmpSoin/delEmpSoinById.jhtml', //删除
        getcollectField2: '/web/collectSet/EmpSoin/queryVaildCollectFieldList.jhtml', //添加获取字段信息
        collectEmpAdd2: '/web/collectEmpSoin/add.jhtml', //添加保存
        getcollectFieldEdit2: '/web/collectSet/EmpSoinEdit/queryVaildCollectFieldList.jhtml', //编辑获取字段信息
        getcollectById2: '/web/collectEmpSoin/getById.jhtml', //获取编辑保存信息
        collectEmpEdit2: '/web/collectEmpSoin/modify.jhtml', //编辑保存


        getEmpBasePage3: '/web/collect/emp/getEmpSalaryPage.jhtml', //薪酬信息列表
        getEmpBasePageSearch3: '/web/collect/emp/getEmpSalaryPageSearch.jhtml', //薪酬信息搜索模板
        collectexportExcel3: '/web/collectEmpSalary/exportExcel.jhtml', //薪酬信息列表导出

        EmpSalarydownHasTemp: '/web/collectEmpSalary/EmpSalarydownHasTemp/exportExcel.jhtml', //下载现有模板
        EmpSalaryDownload: '/web/collectEmpSalary/downloadTemplate.jhtml', //下载模板
        EmpSalaryimportAdd: '/web/collectEmpSalary/importAdd.jhtml', //导入新增
        EmpSalaryimportModify: '/web/collectEmpSalary/importModify.jhtml', //导入修改


        delEmpById3: '/web/collectEmpSalary/delEmpSalaryById.jhtml', //删除
        getcollectField3: '/web/collectSet/EmpSalary/queryVaildCollectFieldList.jhtml', //添加获取字段信息
        collectEmpAdd3: '/web/collectEmpSalary/add.jhtml', //添加保存
        getcollectFieldEdit3: '/web/collectSet/EmpSalaryEdit/queryVaildCollectFieldList.jhtml', //编辑获取字段信息
        getcollectById3: '/web/collectEmpSalary/getById.jhtml', //获取编辑保存信息
        collectEmpEdit3: '/web/collectEmpSalary/modify.jhtml', //编辑保存

        getEmpBasePage4: '/web/collect/emp/getEmpSubsidyPage.jhtml', //津贴信息列表
        getEmpBasePageSearch4: '/web/collect/emp/getEmpSubsidyPageSearch.jhtml', //津贴信息搜索模板
        collectexportExcel4: '/web/collectEmpSubsidy/exportExcel.jhtml', //津贴信息列表导出

        EmpSubsidydownHasTemp: '/web/collectEmpSubsidy/EmpSubsidydownHasTemp/exportExcel.jhtml', //下载现有模板
        EmpSubsidyDownload: '/web/collectEmpSubsidy/downloadTemplate.jhtml', //下载模板
        EmpSubsidyimportAdd: '/web/collectEmpSubsidy/importAdd.jhtml', //导入新增
        EmpSubsidyimportModify: '/web/collectEmpSubsidy/importModify.jhtml', //导入修改


        delEmpById4: '/web/collectEmpSubsidy/delEmpSubsidyById.jhtml', //删除
        getcollectField4: '/web/collectSet/EmpSubsidy/queryVaildCollectFieldList.jhtml', //添加获取字段信息
        collectEmpAdd4: '/web/collectEmpSubsidy/add.jhtml', //添加保存
        getcollectFieldEdit4: '/web/collectSet/EmpSubsidyEdit/queryVaildCollectFieldList.jhtml', //编辑获取字段信息
        getcollectById4: '/web/collectEmpSubsidy/getById.jhtml', //获取编辑保存信息
        collectEmpEdit4: '/web/collectEmpSubsidy/modify.jhtml', //编辑保存


        getEmpOtherPage: '/web/collect/emp/getEmpOtherPage.jhtml', //自定义列表
        getRelDictPage: '/web/collect/emp/getRelDictPage.jhtml', //关联项列表
        getEmpOtherPageSearch: '/web/collect/emp/getEmpOtherPageSearch.jhtml', //自定义列
        collectSetRelDict: '/web/collectSetRelDict/exportExcel.jhtml',
        collectEmpOther: '/web/collectEmpOther/exportExcel.jhtml', //导出
        SetRelDictDownload: '/web/collectSetRelDict/downloadTemplate.jhtml', //关联项下载模板

        EmpOtherdownHasTemp: '/web/collectEmpOther/EmpOtherdownHasTemp/exportExcel.jhtml', //下载现有模板
        EmpOtherDownload: '/web/collectEmpOther/downloadTemplate.jhtml', //员工项下载模板
        EmpOtherimportAdd: '/web/collectEmpOther/importAdd.jhtml', //导入新增
        EmpOtherimportModify: '/web/collectEmpOther/importModify.jhtml', //导入修改




        delEmpById5: '/web/collectEmpOther/delEmpOtherById.jhtml', //删除
        getcollectField5: '/web/collectSet/EmpOther/queryVaildCollectFieldList.jhtml', //添加获取字段信息
        collectEmpAdd5: '/web/collectEmpOther/add.jhtml', //添加保存(员工项)
        collectEmpAdd6: '/web/collectSetRelDict/add.jhtml', //添加保存(关联项)
        getcollectFieldEdit5: '/web/collectSet/EmpOtherEdit/queryVaildCollectFieldList.jhtml', //编辑获取字段信息
        collectEmpEdit5: '/web/collectEmpOther/modify.jhtml', //编辑保存
        getcollectById5: '/web/collectEmpOther/getById.jhtml', //获取编辑保存信息
        collectEmpEdit6: '/web/collectSetRelDict/modify.jhtml', //编辑保存





        synCollectData: '/web/collect/emp/synCollectData.jhtml', //员工信息采集同步
        //		薪酬计算
        getPage: '/payrollSettingItem/getPage.jhtml', //薪酬计算列表
        getSearch: '/payrollSettingItem/getSearch.jhtml', //薪酬计算搜索
        payrolldelete: '/payrollSettingItem/delete.jhtml', //删除员工
        payrollgetDictAddEmp: '/payrollSettingItem/getDictAddEmp.jhtml', //新增员工获取信息
        payrollAdd: '/payrollSettingItem/add.jhtml', //新增员工
        payrollDetail: '/payrollSettingItem/getDetail.jhtml', //获取详情
        payrollUpdate: '/payrollSettingItem/update.jhtml', //修改薪酬明细		
        updateStateCalculate: '/payrollSetting/updateStateCalculate.jhtml', //核算工资
        updateStateArch: '/payrollSetting/updateStateArchived.jhtml', //薪酬归档
        payrollexcelDown: '/payrollSettingItem/downloadExcel.jhtml', //薪酬核算导出
        payrollexcelDown1: '/payrollSettingItem/downloadTemplate.jhtml', //薪酬核算下载模板
        payrollexcelUpload: '/payrollSettingItem/importExcel.jhtml', //薪酬核算导入
        checkArchiveState: '/payrollSettingItem/checkArchiveState.jhtml', //计算薪酬归档

        //同步数据
        updateStateArchReverse: '/payrollSetting/updateStateArchiveReverse.jhtml', //反归档
        getSyncGroup: '/payrollSettingItem/getSyncGroup.jhtml', //获取同步数据
        saveSynData: '/payrollSettingItem/saveSynData.jhtml', //同步



        //个税累计
        incometaxList: '/web/accumulate/page.jhtml', //个税列表
        incometaxGet: '/web/accumulate/get.jhtml', //个税编辑获取信息
        incometaxmodify: '/web/accumulate/modify.jhtml', //个税编辑
        incometaxDel: '/web/accumulate/del.jhtml', //个税删除
        incometaxexport: '/web/accumulate/list/export.jhtml', //个税导出
        incomclear: '/web/accumulate/clear.jhtml', //清空
        incomcImportadd: '/web/accumulate/import/add.jhtml', //导入新增
        incomcImportUpdata: '/web/accumulate/import/update.jhtml', //导入修改
        accumulateSer: '/web/accumulate/search.jhtml', //个税搜索
        incometaxTemp: '/web/accumulate/template.jhtml', //下载模板
        existTemplate: '/web/accumulate/list/hasexcel/export.jhtml', //个税导入下载现有模板

        incomerecordSer: '/web/common/import/record/search.jhtml', //导入结果列表搜素
        incomerecordList: '/web/common/import/record/page.jhtml', //导入结果列表
        incomerecorddownload: '/web/common/import/record/download.jhtml', //导入结果下载
        //专项附加
        specificList: '/web/specific/page.jhtml', //专项附加列表
        specificGet: '/web/specific/get.jhtml', //专项附加编辑获取信息
        specificmodify: '/web/specific/modify.jhtml', //专项附加编辑
        specificDel: '/web/specific/del.jhtml', //专项附加删除
        specificexport: '/web/specific/list/export.jhtml', //专项附加导出
        specificclear: '/web/specific/clear.jhtml', //清空
        specificImportadd: '/web/specific/import/add.jhtml', //导入新增
        specificImportUpdata: '/web/specific/import/update.jhtml', //导入修改
        specificSer: '/web/specific/search.jhtml', //专项附加搜索
        specificTemp: '/web/specific/template.jhtml', //下载模板
        specexistTemplate: '/web/specific/list/hasexcel/export.jhtml', //专项附加导入下载现有模板

        specificrecordSer: '/web/common/import/record/specific/search.jhtml', //导入结果列表搜素
        specificrecordList: '/web/common/import/record/specific/page.jhtml', //导入结果列表
        specificrecorddownload: '/web/common/import/record/get.jhtml', //导入结果下载

        // 薪酬归档
        getDetailSchema: '/payrollSetting/getListArchived.jhtml', //薪酬归档
        getPage1: '/payrollSettingItem/getPage1/getPage.jhtml', //薪酬计算列表
        getSearch1: '/payrollSettingItem/getSearch1/getSearch.jhtml', //薪酬计算搜索
        payrollexcelDownDetail: '/payrollSettingItem/downdetail/downloadExcel.jhtml', //薪酬核算导出

        getGuideSetting: '/payrollSetting/getGuideSetting.jhtml', //薪酬归档引导页
        incomegetCount: '/web/accumulate/getCount.jhtml', //个税累计引导页
        specificgetCount: '/web/specific/getCount.jhtml', //专项附加扣除累计引导页
        collectgetCount: '/web/collectEmpBase/getCount.jhtml', //员工采集引导页
        clearCollectData: '/web/collect/emp/clearCollectData.jhtml', //员工数据准备清空
        getSynDataState: '/payrollSettingItem/getSynDataState.jhtml', //获取同步状态接口
        getListSettingGroup: '/payrollSetting/getListSettingGroup.jhtml', //获取首页薪酬分组列表
        calCollectData: '/web/collect/emp/calCollectData.jhtml',
        //		企业微信考勤

        getEmpQywxPage: '/web/collect/emp/getEmpQywxPage.jhtml',
        getEmpQywxPageSer: '/web/collect/emp/getEmpQywxPageSearch.jhtml',
        delEmpQywxById: '/web/collectEmpQywx/delEmpQywxById.jhtml',
        excelEmpQywx: '/web/collectEmpQywx/exportExcel.jhtml', //导出
        addEmpQywx: '/web/collectEmpQywx/add.jhtml', //新增
        getByIdEmpQywx: '/web/collectEmpQywx/getById.jhtml',
        CollectFieldListEmpQywx: '/web/collectSet/EmpQywx/queryVaildCollectFieldList.jhtml', //获取数据
        getFieldListEmpQywx: '/web/collectSet/EmpQywxEdit/queryVaildCollectFieldList.jhtml', //获取数据
        modifyEmpQywx: '/web/collectEmpQywx/modify.jhtml',
        EmpQywxdownHasTemp: '/web/collectEmpQywx/EmpAttdownHasTemp/exportExcel.jhtml', //下载现有模板
        EmpQywxDownload: '/web/collectEmpQywx/downloadTemplate.jhtml', //下载模板
        EmpQywximportAdd: '/web/collectEmpQywx/importAdd.jhtml', //导入新增
        EmpQywximportModify: '/web/collectEmpQywx/importModify.jhtml', //导入修改

    },
    shift: {
        getCurrentSchema: "/web/attSetSchemaNew/getCurrentSchema.jhtml"
    },
    wxPrivilegeNewApi: { //新的企业微信版本权限分配功能相关权限
        list: "/web/privilegeNew/getSysAuRoles.jhtml", //获取列表
        save: "/web/privilegeNew/saveSysRole.jhtml", //新增保存
        update: "/web/privilegeNew/updateSysAuRole.jhtml", //修改保存
        getInfo: "/web/privilegeNew/getSysAuRoleByRoleId.jhtml", //获取单条数据
        releGet: "/web/privilegeNew/getSysAuRoleMenuByRoleId.jhtml",
        updateRole: "/web/privilegeNew/updateSysAuRoleMenu.jhtml",
        getSysCommonAuRoles: "/web/privilegeNew/getSysCommonAuRoles.jhtml", //获取系统级普通角色列表
        synchronization: "/web/privilegeNew/updateSyncSysAuRoleMenu.jhtml", //同步



    },
    newPayroll: {
        PayrollListByDateToOutSys: '/web/payslip/queryPayrollListByDateToOutSys.jhtml', //薪酬组列表	
        getListIndexRatio: '/web/intelligencePayrollAnalysis/getListIndexRatio.jhtml',
        getGuideAnaly: '/web/intelligencePayrollAnalysis/getGuideAnalysis.jhtml',
        queryPayroll: '/payrollSetting/queryPayrollSalaSettingsList.jhtml',
        parrollanay: '/web/intelligencePayrollAnalysis/getRatioPayrollByMonth.jhtml',
        parrollanayydy: '/web/intelligencePayrollAnalysis/ydy/getRatioPayrollByMonth.jhtml',
        getRatioPayroll: 'web/intelligencePayrollAnalysis/getRatioPayroll.jhtml',
        parrollanay1: '/web/intelligencePayrollAnalysis/getRatioDeduction.jhtml',
        parrollanay2: '/web/intelligencePayrollAnalysis/queryAverageSalaryGroupByDeptName.jhtml', //平均薪资
        parrollanay3: '/web/intelligencePayrollAnalysis/queryTaxRateAnalysisData.jhtml',
        parrollanay4: '/web/intelligencePayrollAnalysis/queryLaborCostAnalysisDataTop.jhtml', //企业人力成本分析数据top10
        parrollanay5: '/web/intelligencePayrollAnalysis/getLaborCost.jhtml', //企业人力成本
        parrollanay6: '/web/intelligencePayrollAnalysis/queryLaborCostAnalysisDataByDept.jhtml', //查询人力成本分析数据BY部门
        parrollanay7: '/web/intelligencePayrollAnalysis/getAnalysisTrend.jhtml', //趋势分析
        //薪酬分析
        downLoadSum1: '/web/intelligencePayrollReport/payrollSettingItem/exportExcelSalary.jhtml', //工资汇总表，明细表
        downLoadSum3: '/web/intelligencePayrollReport/downLoadLaborCostTotalDataByMonthly.jhtml', //下载人力成本汇总表月度
        downLoadSum5: '/web/intelligencePayrollReport/downLoadLaborCostTotalDataByNonMonthly.jhtml', //下载人力成本汇总表-非月度
        downLoadSum6: '/web/intelligencePayrollReport/downloadSoinCompanyNonMonthly.jhtml', //下载五险一金汇总表-非月度
        downLoadSum4: '/web/intelligencePayrollReport/downloadSoinCompanyMonthly.jhtml', //下载五险一金汇总表-月度
        getListYearMonth: '/web/intelligencePayrollReport/getListYearMonth.jhtml',





    },
    AttendanceManagementAPI: { //考勤地点管理
        manageAdd: "/web/icss/attSetLocationApply/manageAdd/applyPageList.jhtml", //考勤地点管理-新增
        manageAddDown: "/web/icss/attSetLocationApply/manageAdd/exportExcel.jhtml", //考勤地点管理-新增导出
        manageAddSearch: "/web/icss/attSetLocationApply/manageAdd/getSearchTemplate.jhtml", //考勤地点管理-新增搜索
        manageClose: "/web/icss/attSetLocationApply/manageClose/applyPageList.jhtml", //考勤地点管理-关闭
        manageCloseDown: "/web/icss/attSetLocationApply/manageClose/exportExcel.jhtml", //考勤地点管理-关闭导出
        manageCloseSearch: "/web/icss/attSetLocationApply/manageClose/getSearchTemplate.jhtml", //考勤地点管理-关闭搜索
        applyAdd: "/web/icss/attSetLocationApply/applyAdd/applyPageList.jhtml", //考勤地点申请-申请
        applyAddSearch: "/web/icss/attSetLocationApply/applyAdd/getSearchTemplate.jhtml", //考勤地点申请-申请 搜索
        getSiteTypeFromEmp: "/web/icss/attSetLocationApply/getSiteTypeFromEmp.jhtml", //考勤地点申请 场地类型 的字典表
        applyHis: "/web/icss/attSetLocationApply/applyHis/applyPageList.jhtml", //考勤地点申请-申请历史记录
        applyHisSearch: "/web/icss/attSetLocationApply/applyHis/getSearchTemplate.jhtml", //考勤地点申请-申请历史记录 搜索
        closeList: "/web/icss/attSetLocationApply/close/applyPageList.jhtml", //考勤地点申请-关闭
        closeListSearch: "/web/icss/attSetLocationApply/close/getSearchTemplate.jhtml", //考勤地点申请-关闭 搜索
        closeHisList: "/web/icss/attSetLocationApply/closeHis/applyPageList.jhtml", //考勤地点申请-关闭历史记录
        closeHisListSearch: "/web/icss/attSetLocationApply/closeHis/getSearchTemplate.jhtml", //考勤地点申请-关闭历史记录 搜索
        AddSave: "/web/icss/attSetLocationApply/add/save.jhtml", // 保存
        CloseSave: "/web/icss/attSetLocationApply/close/save.jhtml", // 保存
        chaxun: "/web/icss/attSetLocationApply/getCurrentLocationUsed.jhtml", //查询是否有人在使用
        placeList: "/web/attSetLocation/getAllLocationsForSelect.jhtml", //
        getCitys: "/web/icss/attSetLocationApply/getCitys.jhtml", //
        isNext: "/web/icss/attSetLocationApply/validateRepeatLocation.jhtml", //查  是否有重复
        UnscheduledList: "/web/icss/attArrange/queryAttNoArrangePage.jhtml", //未排班人员列表
        UnscheduledSearch: "/web/icss/attArrange/getSearchTemplate.jhtml", //未排班人员搜索
        UnscheduledDown: "/web/icss/attArrange/exportAttNoArrangeExcel.jhtml", //未排班人员导出
        empGongChuList: "/web/icss/attReport/empGongChu/getAttReport.jhtml", //员工公出情况列表
        empGongChuSearch: "/web/icss/attReport/empGongChu/searchTemp.jhtml", //员工公出情况列表高级筛选
        empGongChuDown: "/web/icss/attReport/empGongChu/exportAttReportExcel.jhtml", //员工公出情况列表导出
        holPoolLeftList: "/web/icss/attReport/holPoolLeft/getAttReport.jhtml", //员工剩余年假&补休明细列表
        holPoolLeftSearch: "/web/icss/attReport/holPoolLeft/searchTemp.jhtml", //员工剩余年假&补休明细列表高级筛选
        holPoolLeftDown: "/web/icss/attReport/holPoolLeft/exportAttReportExcel.jhtml", //员工剩余年假&补休明细列表导出
        stHolYearList: "/web/icss/attReport/stHolYearly/getAttReport.jhtml", //各类假期年度汇总明细列表
        stHolYearSearch: "/web/icss/attReport/stHolYearly/searchTemp.jhtml", //各类假期年度汇总明细列表高级筛选
        getHolYearLeiXing: "/web/icss/attReport/stHolYearly/getSearchData.jhtml", //获取搜索框的请假类型
        stHolYearDown: "/web/icss/attReport/stHolYearly/exportAttReportExcel.jhtml", //各类假期年度汇总明细列表导出
        emp37List: "/web/icss/attReport/emp37/getAttReport.jhtml", //三期员工信息列表
        emp37Search: "/web/icss/attReport/emp37/searchTemp.jhtml", //三期员工信息列表高级筛选
        emp37Down: "/web/icss/attReport/emp37/exportAttReportExcel.jhtml", //三期员工信息列表导出
        holEveryList: "/web/icss/attReport/holEvery/getAttReport.jhtml", //员工整体请假情况表
        holEverySearch: "/web/icss/attReport/holEvery/searchTemp.jhtml", //员工整体请假情况表高级筛选
        holEveryDown: "/web/icss/attReport/holEvery/exportAttReportExcel.jhtml", //员工整体请假情况表导出
        queryAttSetLocationInfoPage: "/web/icss/locationInfo/queryAttSetLocationInfoPage.jhtml", //打卡地址库信息
        exportAttSetLocationInfoExcel: "/web/icss/locationInfo/exportAttSetLocationInfoExcel.jhtml", //打卡地址库信息导出
        getAttSetLocationInfoSearchTemplate: "/web/icss/locationInfo/getAttSetLocationInfoSearchTemplate.jhtml", //打卡地址库信息筛选
        queryEmpLocationInfoPage: "/web/icss/locationInfo/queryEmpLocationInfoPage.jhtml", // 员工对应welink打卡地址列表
        exportEmpLocationInfoExcel: "/web/icss/locationInfo/exportEmpLocationInfoExcel.jhtml", //  员工对应welink打卡地址导出
        getEmpLocationInfoSearchTemplate: "/web/icss/locationInfo/getEmpLocationInfoSearchTemplate.jhtml", // 员工对应welink打卡地址高级筛选 
        StandardWorkingHoursList: "/web/icss/attReport/extraWork/getAttMutualTotalReportByType.jhtml", //连续三个月均超过月标准工时60小时报表list
        StandardWorkingHoursDown: "/web/icss/attReport/extraWork/exportAttMutualTotalReportExcel.jhtml", //连续三个月均超过月标准工时60小时报表list 导出
        StandardWorkingHoursDetailsList: "/web/icss/attReport/extraWork/getAttMutualDetailReportByType.jhtml", //连续三个月均超过月标准工时60小时报表 详情list
        StandardWorkingHoursDetailsSearch: "/web/icss/attReport/extraWork/searchMutualTemp.jhtml", //连续三个月均超过月标准工时60小时报表 详情list搜索
        StandardWorkingHoursDetailsDown: "/web/icss/attReport/extraWork/exportAttMutualDetailReportExcel.jhtml", //连续三个月均超过月标准工时60小时报表 详情list导出
        LateToLeavePostList: "/web/icss/attReport/leaveCheck/getAttMutualTotalReportByType.jhtml", //当日离岗较晚员工明细报表list
        LateToLeavePostDown: "/web/icss/attReport/leaveCheck/exportAttMutualTotalReportExcel.jhtml", //当日离岗较晚员工明细报表list 导出
        LateToLeavePostDetailsList: "/web/icss/attReport/leaveCheck/getAttMutualDetailReportByType.jhtml", //当日离岗较晚员工明细报表详情list
        LateToLeavePostDetailsSearch: "/web/icss/attReport/leaveCheck/searchMutualTemp.jhtml", //当日离岗较晚员工明细报表详情list搜索
        LateToLeavePostDetailsDown: "/web/icss/attReport/leaveCheck/exportAttMutualDetailReportExcel.jhtml", //当日离岗较晚员工明细报表详情list导出
        MoreShiLiuList: "/web/icss/attReport/extraSubsidies/getAttMutualTotalReportByType.jhtml", //月晚补次数超过16次人员明细报表list
        MoreShiLiuDown: "/web/icss/attReport/extraSubsidies/exportAttMutualTotalReportExcel.jhtml", //月晚补次数超过16次人员明细报表list 导出
        MoreShiLiuDetailsList: "/web/icss/attReport/extraSubsidies/getAttMutualDetailReportByType.jhtml", //月晚补次数超过16次人员明细报表详情list
        MoreShiLiuDetailsSearch: "/web/icss/attReport/extraSubsidies/searchMutualTemp.jhtml", //月晚补次数超过16次人员明细报表详情list搜索
        MoreShiLiuDetailsDown: "/web/icss/attReport/extraSubsidies/exportAttMutualDetailReportExcel.jhtml", //月晚补次数超过16次人员明细报表list导出
        MoreSanShiErList: "/web/icss/attReport/weekendWork/getAttMutualTotalReportByType.jhtml", //月周末出勤时长超32H人员明细报表list
        MoreSanShiErDown: "/web/icss/attReport/weekendWork/exportAttMutualTotalReportExcel.jhtml", //月周末出勤时长超32H人员明细报表list 导出
        MoreSanShiErDetailsList: "/web/icss/attReport/weekendWork/getAttMutualDetailReportByType.jhtml", //月周末出勤时长超32H人员明细报表详情list
        MoreSanShiErDetailsSearch: "/web/icss/attReport/weekendWork/searchMutualTemp.jhtml", //月周末出勤时长超32H人员明细报表详情list搜索
        MoreSanShiErDetailsDown: "/web/icss/attReport/weekendWork/exportAttMutualDetailReportExcel.jhtml", //月周末出勤时长超32H人员明细报表详情list导出
    },
    applysum: {
        findHealthByPage: '/web/health/record/findHealthByPage.jhtml',
        findHealthByPage1: '/web/health/record/1/findHealthByPage.jhtml',
        findHealthByPage2: '/web/health/record/2/findHealthByPage.jhtml',
        findHealthByCount: '/web/health/record/findHealthByCount.jhtml', //汇总
        findHealthByCount1: '/web/health/record/1/findHealthByCount.jhtml',
        findHealthByCount2: '/web/health/record/2/findHealthByCount.jhtml',
        downExcelDetail: '/web/health/record/downExcelDetail.jhtml', //导出
        downExcelDetail1: '/web/health/record/1/downExcelDetail.jhtml',
        downExcelDetail2: '/web/health/record/2/downExcelDetail.jhtml',
        downExcel: '/web/health/record/downExcel.jhtml', //导出汇总
        downExcel1: '/web/health/record/1/downExcel.jhtml',
        downExcel2: '/web/health/record/2/downExcel.jhtml',

    },
    wxPrivilegeMonth: {
        getAttQywxSetCalRulList: "/web/attQywxSetCalRul/getAttQywxSetCalRulList.jhtml", //列表
        updateEffective: "/web/attQywxSetCalRul/updateEffective.jhtml", //变更状态
        saveAttQywxSetCalRul: "/web/attQywxSetCalRul/saveAttQywxSetCalRul.jhtml", //新增保存
        updateAttQywxSetCalRul: "/web/attQywxSetCalRul/updateAttQywxSetCalRul.jhtml", //修改保存
        deleteAttQywxSetCalRul: "/web/attQywxSetCalRul/deleteAttQywxSetCalRul.jhtml", //删除
        getAttQywxSetCalRule: "/web/attQywxSetCalRul/getAttQywxSetCalRule.jhtml", //查看获取数据
        getAttQywxMonthPage: "/web/attQywxMonth/getAttQywxMonthPage.jhtml", //获取列表
        getAttQywxMonthDetail: "/web/attQywxMonth/getAttQywxMonthDetail.jhtml", //获取数据
        deleteAttQywxMonthDetail: "/web/attQywxMonth/deleteAttQywxMonthDetail.jhtml", //删除
        updateAttQywxMonthDetail: "/web/attQywxMonth/updateAttQywxMonthDetail.jhtml", //编辑保存
        clearAttQywxMonthDetails: "/web/attQywxMonth/clearAttQywxMonthDetails.jhtml", //清空
        getAttQywxMonthDetailsByQYWX: "/web/attQywxMonth/getAttQywxMonthDetailsByQYWX.jhtml", //同步企业微信月报
        getEmpOrDeptInfo: "/web/empBaseInfo/getEmpOrDeptInfo.jhtml", //根据员工姓名查询员工或根据部门名称查询部门
        searchTemp: "/web/attQywxMonth/searchTemp.jhtml", //搜索模板
        downloadAttQywxMonthDetails: "/web/attQywxMonth/downloadAttQywxMonthDetails.jhtml", //导出
        downloadTemp: "/web/attQywxMonth/downloadTemp.jhtml", //导入模板
        importQywxMonthDaily: "/web/attQywxMonth/importQywxMonthDaily.jhtml", //导入
        calculationQywxMonthDetails: "/web/attQywxMonth/calculationQywxMonthDetails.jhtml", //计算扣款及加班费
        isSynchronization: "/web/attQywxMonth/isSynchronization.jhtml", //判断是否同步过企业微信月报
        getCalculate: "/web/attQywxMonth/getCalculate.jhtml", //获取企业微信月报计算的状态
        getSynchroState: "/web/attQywxMonth/getSynchroState.jhtml", //获取同步状态
    },
    buqingrecords: {
        holqueryAddRecordPage: "/web/vitasoyAttAddRec/addHolRecord/queryAddRecordPage.jhtml", //列表
        holexportAddRecordExcel: "/web/vitasoyAttAddRec/addHolRecord/exportAddRecordExcel.jhtml", //列表导出
        holsearchAddRecordTemp: "/web/vitasoyAttAddRec/addHolRecord/searchAddRecordTemp.jhtml", //高级筛选
        holexportAddRecordTemplate: "/web/vitasoyAttAddRec/addHolRecord/exportAddRecordTemplate.jhtml", //导出下载模板
        holimportAddRecordTemplate: "/web/vitasoyAttAddRec/addHolRecord/importAddRecordTemplate.jhtml", //导入上传文件
        overtimequeryAddRecordPage: "/web/vitasoyAttAddRec/addOverRecord/queryAddRecordPage.jhtml", //列表
        overtimeexportAddRecordExcel: "/web/vitasoyAttAddRec/addOverRecord/exportAddRecordExcel.jhtml", //列表导出
        overtimesearchAddRecordTemp: "/web/vitasoyAttAddRec/addOverRecord/searchAddRecordTemp.jhtml", //高级筛选
        overtimeexportAddRecordTemplate: "/web/vitasoyAttAddRec/addOverRecord/exportAddRecordTemplate.jhtml", //导出下载模板
        overtimeimportAddRecordTemplate: "/web/vitasoyAttAddRec/addOverRecord/importAddRecordTemplate.jhtml", //导入上传文件
        dakaqueryAddRecordPage: "/web/vitasoyAttAddRec/addClockRecord/queryAddRecordPage.jhtml", //列表
        dakaexportAddRecordExcel: "/web/vitasoyAttAddRec/addClockRecord/exportAddRecordExcel.jhtml", //列表导出
        dakasearchAddRecordTemp: "/web/vitasoyAttAddRec/addClockRecord/searchAddRecordTemp.jhtml", //高级筛选
        dakaexportAddRecordTemplate: "/web/vitasoyAttAddRec/addClockRecord/exportAddRecordTemplate.jhtml", //导出下载模板
        dakaimportAddRecordTemplate: "/web/vitasoyAttAddRec/addClockRecord/importAddRecordTemplate.jhtml", //导入上传文件
    },
    acquisitionAPI: {
        list: "/payrollbase/collectDistribute/emp/getTabPage.empweb",//主列表
        getDetail: "/payrollbase/collectDistribute/emp/1/getDetail.empweb",//
        datalist: "/payrollbase/collectDistribute/emp/2/getPage.empweb",//
        getTitle: "/payrollbase/collectDistribute/emp/getTitle.empweb",//
        saveInfo: "/payrollbase/collectDistribute/emp/2/save.empweb",
        delete: "/payrollbase/collectDistribute/emp/delete.empweb",//
        export: "/payrollbase/collectDistribute/emp/2/export.empweb",//
        search:"/payrollbase/collectDistribute/emp/2/getSer.empweb",
        searchEmpBase:"/payrollbase/collectDistribute/emp/2/getCollectEmpBase.empweb",
        saveexs:"/payrollbase/collectDistribute/emp/import.empweb"
    },
    acquisitionManageAPI: {
        list: "/payrollbase/collectDistribute/manage/getTabPage.empweb",//主列表
        getDetail: "/payrollbase/collectDistribute/manage/1/getDetail.empweb",//
        datalist: "/payrollbase/collectDistribute/manage/2/getPage.empweb",//
        getTitle: "/payrollbase/collectDistribute/manage/getTitle.empweb",//
        saveInfo: "/payrollbase/collectDistribute/manage/2/save.empweb",
        delete: "/payrollbase/collectDistribute/manage/delete.empweb",//
        export: "/payrollbase/collectDistribute/manage/2/export.empweb",//
        search:"/payrollbase/collectDistribute/manage/2/getSer.empweb",
        searchEmpBase: "/payrollbase/collectDistribute/manage/2/getCollectEmpBase.empweb",
        submitdata: "/payrollbase/collectDistribute/manage/2/submit.empweb",
        unsubmitdata: "/payrollbase/collectDistribute/manage/2/unSubmit.empweb",
        updata: "/payrollbase/excel/gc/file/pares/sheet/names.empweb",
        saveexs:"/payrollbase/collectDistribute/manage/import.empweb"
    }
};

export default api;
//module.exports = api;